(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5808],{

/***/ 43174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createAggregator = __webpack_require__(55189);

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

module.exports = partition;


/***/ }),

/***/ 49234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ AddToWalletTextOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8253);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19551);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11200);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83313);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65335);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96293);
/* harmony import */ var _utils_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84695);







var AddToWalletTextOptions;
(function(AddToWalletTextOptions) {
    AddToWalletTextOptions[AddToWalletTextOptions["NO_TEXT"] = 0] = "NO_TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT"] = 1] = "TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT_WITH_ASSET"] = 2] = "TEXT_WITH_ASSET";
})(AddToWalletTextOptions || (AddToWalletTextOptions = {}));
var getWalletIcon = function(marginTextBetweenLogo) {
    var ref, ref1, ref2, ref3;
    var iconProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "16px"
    }, marginTextBetweenLogo && {
        ml: marginTextBetweenLogo
    });
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isTrust) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isCoinbaseWallet) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTokenPocket) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isMetaMask) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, iconProps));
    }
    return null;
};
var getWalletName = function() {
    var ref, ref1, ref2, ref3;
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isTrust) {
        return "Trust Wallet";
    }
    if (window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isCoinbaseWallet) {
        return "Coinbase Wallet";
    }
    if (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTokenPocket) {
        return "TokenPocket Wallet";
    }
    if (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isMetaMask) {
        return "Metamask";
    }
    return null;
};
var AddToWalletButton = function(_param) {
    var tokenAddress = _param.tokenAddress, tokenSymbol = _param.tokenSymbol, tokenDecimals = _param.tokenDecimals, tokenLogo = _param.tokenLogo, _textOptions = _param.textOptions, textOptions = _textOptions === void 0 ? AddToWalletTextOptions.NO_TEXT : _textOptions, _marginTextBetweenLogo = _param.marginTextBetweenLogo, marginTextBetweenLogo = _marginTextBetweenLogo === void 0 ? "0px" : _marginTextBetweenLogo, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "tokenAddress",
        "tokenSymbol",
        "tokenDecimals",
        "tokenLogo",
        "textOptions",
        "marginTextBetweenLogo"
    ]);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    if (!(0,_utils_wallet__WEBPACK_IMPORTED_MODULE_2__/* .canRegisterToken */ .UO)()) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        onClick: function() {
            return (0,_utils_wallet__WEBPACK_IMPORTED_MODULE_2__/* .registerToken */ .$P)(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo);
        },
        children: [
            textOptions !== AddToWalletTextOptions.NO_TEXT && (textOptions === AddToWalletTextOptions.TEXT ? t("Add to %wallet%", {
                wallet: getWalletName()
            }) : t("Add %asset% to %wallet%", {
                asset: tokenSymbol,
                wallet: getWalletName()
            })),
            getWalletIcon(marginTextBetweenLogo)
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AddToWalletButton);


/***/ }),

/***/ 36261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h2": function() { return /* binding */ GreyCard; },
/* harmony export */   "hl": function() { return /* binding */ LightCard; },
/* harmony export */   "m5": function() { return /* binding */ LightGreyCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44850);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-21be8dee-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "1.25rem";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius !== null && borderRadius !== void 0 ? borderRadius : "16px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Card);
var LightCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-21be8dee-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var LightGreyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-21be8dee-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var GreyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-21be8dee-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});


/***/ }),

/***/ 87218:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DAY_IN_SECONDS = 86400;
var MONTH_IN_SECONDS = 2629800;
var YEAR_IN_SECONDS = 31557600;
/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */ var getTimePeriods = function(seconds) {
    var delta = Math.abs(seconds);
    var timeLeft = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    if (delta >= YEAR_IN_SECONDS) {
        timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS);
        delta -= timeLeft.years * YEAR_IN_SECONDS;
    }
    if (delta >= MONTH_IN_SECONDS) {
        timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS);
        delta -= timeLeft.months * MONTH_IN_SECONDS;
    }
    if (delta >= DAY_IN_SECONDS) {
        timeLeft.days = Math.floor(delta / DAY_IN_SECONDS);
        delta -= timeLeft.days * DAY_IN_SECONDS;
    }
    if (delta >= HOUR_IN_SECONDS) {
        timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS);
        delta -= timeLeft.hours * HOUR_IN_SECONDS;
    }
    if (delta >= MINUTE_IN_SECONDS) {
        timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS);
        delta -= timeLeft.minutes * MINUTE_IN_SECONDS;
    }
    timeLeft.seconds = delta;
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (getTimePeriods);


/***/ }),

/***/ 25808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ views_Pools; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber_js_bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber_js_bignumber);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(91186);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/lodash/partition.js
var partition = __webpack_require__(43174);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(8253);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.ts
var useIntersectionObserver = __webpack_require__(76538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 34 modules
var state = __webpack_require__(46506);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(27892);
// EXTERNAL MODULE: ./src/config/constants/farms.ts
var farms = __webpack_require__(81115);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 6 modules
var state_pools = __webpack_require__(28246);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 1 modules
var state_farms = __webpack_require__(36393);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/state/pools/helpers.ts
var helpers = __webpack_require__(89713);
;// CONCATENATED MODULE: ./src/utils/cakePool.ts

var isStaked = function(param) {
    var userShares = param.userShares;
    return userShares && userShares.gt(0);
};
var isLocked = function(param) {
    var userShares = param.userShares, locked = param.locked;
    return isStaked({
        userShares: userShares
    }) && Boolean(locked) // && !isAfter(new Date(lockEndTime * 1000), new Date())
    ;
};
var isLockedEnd = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() >= parseInt(lockEndTime) * 1000 && Date.now() <= new Date(parseInt(lockEndTime) * 1000).getTime() + pools/* UNLOCK_FREE_DURATION */.by * 1000;
};
var isAfterBurning = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() > new Date(parseInt(lockEndTime) * 1000).getTime() + pools/* UNLOCK_FREE_DURATION */.by * 1000;
};
var VaultPosition;
(function(VaultPosition) {
    VaultPosition[VaultPosition["None"] = 0] = "None";
    VaultPosition[VaultPosition["Flexible"] = 1] = "Flexible";
    VaultPosition[VaultPosition["Locked"] = 2] = "Locked";
    VaultPosition[VaultPosition["LockedEnd"] = 3] = "LockedEnd";
    VaultPosition[VaultPosition["AfterBurning"] = 4] = "AfterBurning";
})(VaultPosition || (VaultPosition = {}));
var getVaultPosition = function(params) {
    if (isAfterBurning(params)) {
        return VaultPosition.AfterBurning;
    }
    if (isLockedEnd(params)) {
        return VaultPosition.LockedEnd;
    }
    if (isLocked(params)) {
        return VaultPosition.Locked;
    }
    if (isStaked(params)) {
        return VaultPosition.Flexible;
    }
    return VaultPosition.None;
};

;// CONCATENATED MODULE: ./src/state/pools/selectors.ts










var selectPoolsData = function(state) {
    return state.pools.data;
};
var selectPoolData = function(sousId) {
    return function(state) {
        return state.pools.data.find(function(p) {
            return p.sousId === sousId;
        });
    };
};
var selectUserDataLoaded = function(state) {
    return state.pools.userDataLoaded;
};
var selectVault = function(key) {
    return function(state) {
        return key ? state.pools[key] : state_pools/* initialPoolVaultState */.XW;
    };
};
var selectIfo = function(state) {
    return state.pools.ifo;
};
var _credit;
var selectIfoUserCredit = function(state) {
    return (_credit = state.pools.ifo.credit) !== null && _credit !== void 0 ? _credit : bigNumber/* BIG_ZERO */.HW;
};
var makePoolWithUserDataLoadingSelector = function(sousId) {
    return (0,reselect_es/* createSelector */.P1)([
        selectPoolData(sousId),
        selectUserDataLoaded
    ], function(pool, userDataLoaded) {
        return {
            pool: (0,helpers/* transformPool */.xK)(pool),
            userDataLoaded: userDataLoaded
        };
    });
};
var poolsWithUserDataLoadingSelector = (0,reselect_es/* createSelector */.P1)([
    selectPoolsData,
    selectUserDataLoaded
], function(pools, userDataLoaded) {
    return {
        pools: pools.map(helpers/* transformPool */.xK),
        userDataLoaded: userDataLoaded
    };
});
var makeVaultPoolByKey = function(key) {
    return (0,reselect_es/* createSelector */.P1)([
        selectVault(key)
    ], function(vault) {
        return (0,helpers/* transformVault */.LJ)(key, vault);
    });
};
var poolsWithVaultSelector = (0,reselect_es/* createSelector */.P1)([
    poolsWithUserDataLoadingSelector,
    makeVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault),
    makeVaultPoolByKey(types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault), 
], function(poolsWithUserDataLoading, deserializedLockedCakeVault, deserializedFlexibleSideCakeVault) {
    var pools = poolsWithUserDataLoading.pools, userDataLoaded = poolsWithUserDataLoading.userDataLoaded;
    var cakePool = pools.find(function(pool) {
        return !pool.isFinished && pool.sousId === 0;
    });
    var withoutCakePool = pools.filter(function(pool) {
        return pool.sousId !== 0;
    });
    var cakeAutoVault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedLockedCakeVault), {
        vaultKey: types/* VaultKey.CakeVault */.om.CakeVault,
        userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedLockedCakeVault.userData)
    });
    var lockedVaultPosition = getVaultPosition(deserializedLockedCakeVault.userData);
    var hasFlexibleSideSharesStaked = deserializedFlexibleSideCakeVault.userData.userShares.gt(0);
    var cakeAutoFlexibleSideVault = lockedVaultPosition > VaultPosition.Flexible || hasFlexibleSideSharesStaked ? [
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedFlexibleSideCakeVault), {
            vaultKey: types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault,
            userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedFlexibleSideCakeVault.userData)
        }), 
    ] : [];
    return {
        pools: [
            cakeAutoVault
        ].concat((0,_to_consumable_array/* default */.Z)(cakeAutoFlexibleSideVault), (0,_to_consumable_array/* default */.Z)(withoutCakePool)),
        userDataLoaded: userDataLoaded
    };
});
var makeVaultPoolWithKeySelector = function(vaultKey) {
    return (0,reselect_es/* createSelector */.P1)(poolsWithVaultSelector, function(param) {
        var pools = param.pools;
        return pools.find(function(p) {
            return p.vaultKey === vaultKey;
        });
    });
};
var ifoCreditSelector = (0,reselect_es/* createSelector */.P1)([
    selectIfoUserCredit
], function(ifoUserCredit) {
    return new (bignumber_default())(ifoUserCredit);
});
var ifoCeilingSelector = (0,reselect_es/* createSelector */.P1)([
    selectIfo
], function(ifoData) {
    return new (bignumber_default())(ifoData.ceiling);
});

;// CONCATENATED MODULE: ./src/state/pools/hooks.ts













var lPoolAddresses = pools/* livePools.filter */.$$.filter(function(param) {
    var sousId = param.sousId;
    return sousId !== 0;
}).map(function(param) {
    var earningToken = param.earningToken;
    return earningToken.address;
});
// Only fetch farms for live pools
var activeFarms = farms/* default.filter */.Z.filter(function(param) {
    var token = param.token, pid = param.pid, quoteToken = param.quoteToken;
    return pid !== 0 && (token.symbol === "BUSD" && quoteToken.symbol === "WBNB" || lPoolAddresses.find(function(poolAddress) {
        return poolAddress === token.address;
    }));
}).map(function(farm) {
    return farm.pid;
});
var useFetchPublicPoolsData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function(currentBlock) {
        var fetchPoolsDataWithFarms = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return dispatch((0,state_farms/* fetchFarmsPublicDataAsync */.eG)(activeFarms));
                        case 2:
                            (0,es/* batch */.dC)(function() {
                                dispatch((0,state_pools/* fetchPoolsPublicDataAsync */.ht)(currentBlock));
                                dispatch((0,state_pools/* fetchPoolsStakingLimitsAsync */.E$)());
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchPoolsDataWithFarms() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPoolsDataWithFarms();
    }, [
        dispatch
    ]);
};
var usePool = function(sousId) {
    var poolWithUserDataLoadingSelector = (0,react.useMemo)(function() {
        return makePoolWithUserDataLoadingSelector(sousId);
    }, [
        sousId
    ]);
    return (0,es/* useSelector */.v9)(poolWithUserDataLoadingSelector);
};
var usePoolsWithVault = function() {
    return (0,es/* useSelector */.v9)(poolsWithVaultSelector);
};
var useDeserializedPoolByVaultKey = function(vaultKey) {
    var vaultPoolWithKeySelector = (0,react.useMemo)(function() {
        return makeVaultPoolWithKeySelector(vaultKey);
    }, [
        vaultKey
    ]);
    return (0,es/* useSelector */.v9)(vaultPoolWithKeySelector);
};
var usePoolsPageFetch = function() {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    useFetchPublicPoolsData();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        (0,es/* batch */.dC)(function() {
            dispatch((0,state_pools/* fetchCakeVaultPublicData */.P4)());
            dispatch((0,state_pools/* fetchCakeFlexibleSideVaultPublicData */.i)());
            dispatch((0,state_pools/* fetchIfoPublicDataAsync */.aG)());
            if (account) {
                dispatch((0,state_pools/* fetchPoolsUserDataAsync */.XK)(account));
                dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                    account: account
                }));
                dispatch((0,state_pools/* fetchCakeFlexibleSideVaultUserData */.dU)({
                    account: account
                }));
            }
        });
    }, [
        account,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        (0,es/* batch */.dC)(function() {
            dispatch((0,state_pools/* fetchCakeVaultFees */.HX)());
            dispatch((0,state_pools/* fetchCakeFlexibleSideVaultFees */.qd)());
        });
    }, [
        dispatch
    ]);
};
var useFetchIfo = function() {
    var account = useWeb3React().account;
    var dispatch = useAppDispatch();
    useFastRefreshEffect(function() {
        batch(function() {
            dispatch(fetchCakeVaultPublicData());
            dispatch(fetchIfoPublicDataAsync());
            if (account) {
                dispatch(fetchPoolsUserDataAsync(account));
                dispatch(fetchCakeVaultUserData({
                    account: account
                }));
                dispatch(fetchUserIfoCreditDataAsync(account));
            }
        });
    }, [
        dispatch,
        account
    ]);
    useEffect(function() {
        dispatch(fetchCakeVaultFees());
    }, [
        dispatch
    ]);
};
var useCakeVault = function() {
    return useVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault);
};
var useVaultPoolByKey = function(key) {
    var vaultPoolByKey = (0,react.useMemo)(function() {
        return makeVaultPoolByKey(key);
    }, [
        key
    ]);
    return (0,es/* useSelector */.v9)(vaultPoolByKey);
};
var useIfoCredit = function() {
    return (0,es/* useSelector */.v9)(ifoCreditSelector);
};
var useIfoCeiling = function() {
    return (0,es/* useSelector */.v9)(ifoCeilingSelector);
};

// EXTERNAL MODULE: ./src/utils/latinise.ts
var latinise = __webpack_require__(11438);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(40508);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./src/components/PageHeader/index.ts + 1 modules
var PageHeader = __webpack_require__(44482);
// EXTERNAL MODULE: ./src/components/SearchInput/index.ts + 1 modules
var SearchInput = __webpack_require__(14450);
// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(37370);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/state/user/actions.ts
var actions = __webpack_require__(46245);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var block_hooks = __webpack_require__(37063);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(37519);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardRibbon.tsx
var CardRibbon = __webpack_require__(18842);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(95239);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Calculate.tsx
var Calculate = __webpack_require__(47509);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./src/components/RoiCalculatorModal/index.tsx + 3 modules
var RoiCalculatorModal = __webpack_require__(61102);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/views/Pools/helpers.tsx
var Pools_helpers = __webpack_require__(53136);
;// CONCATENATED MODULE: ./src/views/Pools/components/Apr.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var AprLabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e6967d5e-0"
})(_templateObject());
var Apr = function(_param) {
    var pool = _param.pool, showIcon = _param.showIcon, stakedBalance = _param.stakedBalance, _fontSize = _param.fontSize, fontSize = _fontSize === void 0 ? "16px" : _fontSize, _performanceFee = _param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee, props = (0,_object_without_properties/* default */.Z)(_param, [
        "pool",
        "showIcon",
        "stakedBalance",
        "fontSize",
        "performanceFee"
    ]);
    var ref;
    var stakingToken = pool.stakingToken, earningToken = pool.earningToken, isFinished = pool.isFinished, earningTokenPrice = pool.earningTokenPrice, stakingTokenPrice = pool.stakingTokenPrice, userData = pool.userData, apr = pool.apr, rawApr = pool.rawApr, vaultKey = pool.vaultKey;
    var t = (0,src/* useTranslation */.$G)().t;
    var currentBlock = (0,block_hooks/* useCurrentBlock */.je)();
    var ref1 = (0,Pools_helpers/* getPoolBlockInfo */.zy)(pool, currentBlock), shouldShowBlockCountdown = ref1.shouldShowBlockCountdown, hasPoolStarted = ref1.hasPoolStarted;
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new (bignumber_default())(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var apyModalLink = stakingToken.address ? "/swap?outputCurrency=".concat(stakingToken.address) : "/swap";
    var ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal/* default */.Z, {
        earningTokenPrice: earningTokenPrice,
        stakingTokenPrice: stakingTokenPrice,
        stakingTokenBalance: stakedBalance.plus(stakingTokenBalance),
        apr: vaultKey ? rawApr : apr,
        stakingTokenSymbol: stakingToken.symbol,
        linkLabel: t("Get %symbol%", {
            symbol: stakingToken.symbol
        }),
        linkHref: apyModalLink,
        earningTokenSymbol: earningToken.symbol,
        autoCompoundFrequency: (ref2 = (ref = pools/* vaultPoolConfig */.Y4[vaultKey]) === null || ref === void 0 ? void 0 : ref.autoCompoundFrequency) !== null && ref2 !== void 0 ? ref2 : 0,
        performanceFee: performanceFee
    })), 1), onPresentApyModal = ref3[0];
    var openRoiModal = function(event) {
        event.stopPropagation();
        onPresentApyModal();
    };
    var isValidate = apr !== undefined && !Number.isNaN(apr);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AprLabelContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "flex-start"
    }, props), {
        children: isValidate || isFinished ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hasPoolStarted || !shouldShowBlockCountdown ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                        onClick: openRoiModal,
                        fontSize: fontSize,
                        isDisabled: isFinished,
                        value: isFinished ? 0 : apr,
                        decimals: 2,
                        unit: "%"
                    }),
                    !isFinished && showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: openRoiModal,
                        variant: "text",
                        width: "20px",
                        height: "20px",
                        padding: "0px",
                        marginLeft: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                            color: "textSubtle",
                            width: "20px"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: "-"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "80px",
            height: "16px"
        })
    }));
};
/* harmony default export */ var components_Apr = (Apr);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/AprRow.tsx




var AprRow = function(param) {
    var pool = param.pool, stakedBalance = param.stakedBalance, _performanceFee = param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    var t = (0,src/* useTranslation */.$G)().t;
    var vaultKey = pool.vaultKey;
    var tooltipContent = vaultKey ? t("APY includes compounding, APR doesn\u2019t. This pool\u2019s BNOU is compounded automatically, so we show APY.") : t("This pool\u2019s rewards aren\u2019t compounded automatically, so we show APR");
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                ref: targetRef,
                children: vaultKey ? "".concat(t("APY"), ":") : "".concat(t("APR"), ":")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Apr, {
                pool: pool,
                stakedBalance: stakedBalance,
                performanceFee: performanceFee,
                showIcon: showIcon
            })
        ]
    });
};
/* harmony default export */ var PoolCard_AprRow = (AprRow);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/StyledCard.tsx

function StyledCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 280px;\n  max-width: 100%;\n  margin: 0 0 24px 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-self: baseline;\n  position: relative;\n  color: ",
        ";\n\n  ",
        " {\n    max-width: 350px;\n    margin: 0 12px 46px;\n  }\n"
    ]);
    StyledCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-34431ece-0"
})(StyledCard_templateObject(), function(param) {
    var isFinished = param.isFinished, theme = param.theme;
    return theme.colors[isFinished ? "textDisabled" : "secondary"];
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
/* harmony default export */ var PoolCard_StyledCard = ((/* unused pure expression or super */ null && (StyledCard)));

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(95596);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(62276);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/ExpandableButton.tsx
var ExpandableButton = __webpack_require__(10763);
// EXTERNAL MODULE: ./src/components/Tags.tsx
var Tags = __webpack_require__(69160);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Timer.tsx
var Timer = __webpack_require__(22491);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
// EXTERNAL MODULE: ./src/components/AddToWallet/AddToWalletButton.tsx
var AddToWalletButton = __webpack_require__(49234);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(55878);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/views/Pools/components/MaxStakeRow.tsx







var MaxStakeRow = function(param) {
    var _small = param.small, small = _small === void 0 ? false : _small, stakingLimit = param.stakingLimit, currentBlock = param.currentBlock, stakingLimitEndBlock = param.stakingLimitEndBlock, stakingToken = param.stakingToken, hasPoolStarted = param.hasPoolStarted;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: small,
                        children: [
                            t("Max. stake per user"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: small,
                        children: "".concat((0,formatBalance/* getFullDisplayBalance */.NJ)(stakingLimit, stakingToken.decimals, 0), " ").concat(stakingToken.symbol)
                    })
                ]
            }),
            hasPoolStarted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: small,
                        children: [
                            t("Max. stake limit ends in"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        external: true,
                        href: (0,utils/* getBscScanLink */.s6)(stakingLimitEndBlock, "countdown"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                small: small,
                                value: Math.max(stakingLimitEndBlock - currentBlock, 0),
                                decimals: 0,
                                color: "primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                small: small,
                                ml: "4px",
                                color: "primary",
                                textTransform: "lowercase",
                                children: t("Blocks")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
                                ml: "4px",
                                color: "primary"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_MaxStakeRow = (MaxStakeRow);

// EXTERNAL MODULE: ./node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(14841);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ./src/utils/getFullDecimalMultiplier.ts
var getFullDecimalMultiplier = __webpack_require__(44356);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 9 modules
var en_US = __webpack_require__(35077);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDuration/index.js

var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];

/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @param {Duration} duration - the duration to format
 * @param {Object} [options] - an object with options.
 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
 * @param {boolean} [options.zero=false] - should zeros be included in the output?
 * @param {string} [options.delimiter=' '] - delimiter string
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {string} the formatted date string
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */
function formatDuration(duration) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var format = (options === null || options === void 0 ? void 0 : options.format) || defaultFormat;
  var locale = (options === null || options === void 0 ? void 0 : options.locale) || en_US/* default */.Z;
  var zero = (options === null || options === void 0 ? void 0 : options.zero) || false;
  var delimiter = (options === null || options === void 0 ? void 0 : options.delimiter) || ' ';
  var result = format.reduce(function (acc, unit) {
    var token = "x".concat(unit.replace(/(^.)/, function (m) {
      return m.toUpperCase();
    }));
    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
    return addChunk && locale.formatDistance ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
  }, []).join(delimiter);
  return result;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js + 2 modules
var differenceInDays = __webpack_require__(94533);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMethods = __webpack_require__(93645);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInWeeks/index.js



/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInDays/* default */.Z)(dateLeft, dateRight) / 7;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(61973);
;// CONCATENATED MODULE: ./src/views/Pools/components/utils/formatSecondsToWeeks.ts



var secondsToWeeks = function(seconds) {
    var now = new Date();
    var addedDate = (0,addSeconds/* default */.Z)(now, seconds);
    return differenceInWeeks(new Date(addedDate), now, {
        roundingMethod: "round"
    });
};
var weeksToSeconds = function(weeks) {
    return weeks * 7 * 24 * 60 * 60;
};
var formatSecondsToWeeks = function(secondDuration) {
    return formatDuration({
        weeks: secondsToWeeks(secondDuration)
    });
};
/* harmony default export */ var utils_formatSecondsToWeeks = (formatSecondsToWeeks);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useAvgLockDuration.tsx







function useAvgLockDuration() {
    var ref = useCakeVault(), totalLockedAmount = ref.totalLockedAmount, totalShares = ref.totalShares, totalCakeInVault = ref.totalCakeInVault, pricePerFullShare = ref.pricePerFullShare;
    var avgLockDurationsInSeconds = (0,react.useMemo)(function() {
        var flexibleCakeAmount = totalCakeInVault.minus(totalLockedAmount);
        var flexibleCakeShares = flexibleCakeAmount.div(pricePerFullShare).times((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(18));
        var lockedCakeBoostedShares = totalShares.minus(flexibleCakeShares);
        var lockedCakeOriginalShares = totalLockedAmount.div(pricePerFullShare).times((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(18));
        var avgBoostRatio = lockedCakeBoostedShares.div(lockedCakeOriginalShares);
        return avgBoostRatio.minus(1).times(new (bignumber_default())(pools/* DURATION_FACTOR.toString */.A0.toString())).div(new (bignumber_default())(pools/* BOOST_WEIGHT.toString */.xt.toString()).div((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(12))).toFixed(0);
    }, [
        totalCakeInVault,
        totalLockedAmount,
        pricePerFullShare,
        totalShares
    ]);
    var avgLockDurationsInWeeks = (0,react.useMemo)(function() {
        return utils_formatSecondsToWeeks(avgLockDurationsInSeconds);
    }, [
        avgLockDurationsInSeconds
    ]);
    return {
        avgLockDurationsInWeeks: avgLockDurationsInWeeks,
        avgLockDurationsInSeconds: toNumber_default()(avgLockDurationsInSeconds)
    };
};

;// CONCATENATED MODULE: ./src/views/Pools/components/Stat.tsx








var StatWrapper = function(param) {
    var children = param.children, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        mb: "2px",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
            label,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: children
            })
        ]
    });
};
var PerformanceFee = function(param) {
    var userData = param.userData, performanceFeeAsDecimal = param.performanceFeeAsDecimal;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(t("Performance fee only applies to the flexible staking rewards."), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    var isLock = isLocked(userData);
    var isStake = isStaked(userData);
    if (!performanceFeeAsDecimal || isLock) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatWrapper, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
            ref: targetRef,
            small: true,
            children: t("Performance Fee")
        }),
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                ml: "4px",
                small: true,
                children: isStake ? "".concat(performanceFeeAsDecimal, "%") : "0~".concat(performanceFeeAsDecimal, "%")
            })
        ]
    });
};
var TotalToken = function(param) {
    var total = param.total, token = param.token;
    if (total && total.gte(0)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
            small: true,
            value: (0,formatBalance/* getBalanceNumber */.mW)(total, token.decimals),
            decimals: 0,
            unit: " ".concat(token.symbol)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: "90px",
        height: "21px"
    });
};
var TotalLocked = function(param) {
    var totalLocked = param.totalLocked, lockedToken = param.lockedToken;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatWrapper, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            small: true,
            children: [
                t("Total locked"),
                ":"
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalToken, {
            total: totalLocked,
            token: lockedToken
        })
    });
};
var DurationAvg = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(t("The average lock duration of all the locked staking positions of other users"), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    var avgLockDurationsInWeeks = useAvgLockDuration().avgLockDurationsInWeeks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatWrapper, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
            ref: targetRef,
            small: true,
            children: [
                t("Average lock duration"),
                ":"
            ]
        }),
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                ml: "4px",
                small: true,
                children: avgLockDurationsInWeeks
            })
        ]
    });
};
var TotalStaked = function(param) {
    var totalStaked = param.totalStaked, stakingToken = param.stakingToken;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(t("Total amount of %symbol% staked in this pool", {
        symbol: stakingToken.symbol
    }), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatWrapper, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
            ref: targetRef,
            small: true,
            children: [
                t("Total staked"),
                ":"
            ]
        }),
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalToken, {
                total: totalStaked,
                token: stakingToken
            })
        ]
    });
};
var AprInfo = function(param) {
    var pool = param.pool, stakedBalance = param.stakedBalance;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                small: true,
                children: [
                    t("APR"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Apr, {
                pool: pool,
                showIcon: true,
                stakedBalance: stakedBalance,
                performanceFee: 0,
                fontSize: "14px"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolStatsInfo.tsx
















var PoolStatsInfo = function(param) {
    var pool = param.pool, account = param.account, _showTotalStaked = param.showTotalStaked, showTotalStaked = _showTotalStaked === void 0 ? true : _showTotalStaked, _alignLinksToRight = param.alignLinksToRight, alignLinksToRight = _alignLinksToRight === void 0 ? true : _alignLinksToRight;
    var t = (0,src/* useTranslation */.$G)().t;
    var currentBlock = (0,block_hooks/* useCurrentBlock */.je)();
    var stakingToken = pool.stakingToken, earningToken = pool.earningToken, totalStaked = pool.totalStaked, startBlock = pool.startBlock, endBlock = pool.endBlock, stakingLimit = pool.stakingLimit, stakingLimitEndBlock = pool.stakingLimitEndBlock, contractAddress = pool.contractAddress, vaultKey = pool.vaultKey, profileRequirement = pool.profileRequirement, isFinished = pool.isFinished, poolUserData = pool.userData;
    var stakedBalance = (poolUserData === null || poolUserData === void 0 ? void 0 : poolUserData.stakedBalance) ? poolUserData.stakedBalance : bigNumber/* BIG_ZERO */.HW;
    var ref = useVaultPoolByKey(vaultKey), totalCakeInVault = ref.totalCakeInVault, totalLockedAmount = ref.totalLockedAmount, performanceFeeAsDecimal = ref.fees.performanceFeeAsDecimal, userData = ref.userData;
    var tokenAddress = earningToken.address || "";
    var poolContractAddress = (0,addressHelpers/* getAddress */.Kn)(contractAddress);
    var cakeVaultContractAddress = (0,addressHelpers/* getVaultPoolAddress */.ZX)(vaultKey);
    var ref1 = (0,Pools_helpers/* getPoolBlockInfo */.zy)(pool, currentBlock), shouldShowBlockCountdown = ref1.shouldShowBlockCountdown, blocksUntilStart = ref1.blocksUntilStart, blocksRemaining = ref1.blocksRemaining, hasPoolStarted = ref1.hasPoolStarted, blocksToDisplay = ref1.blocksToDisplay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            profileRequirement && (profileRequirement.required || profileRequirement.thresholdPoints.gt(0)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "8px",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: true,
                        children: [
                            t("Requirement"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: true,
                        textAlign: "right",
                        children: [
                            profileRequirement.required && t("Pancake Profile"),
                            " ",
                            profileRequirement.thresholdPoints.gt(0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                small: true,
                                children: [
                                    profileRequirement.thresholdPoints.toNumber().toLocaleString(),
                                    " ",
                                    t("Profile Points")
                                ]
                            })
                        ]
                    })
                ]
            }),
            !vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(AprInfo, {
                pool: pool,
                stakedBalance: stakedBalance
            }),
            showTotalStaked && /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalStaked, {
                totalStaked: vaultKey ? totalCakeInVault : totalStaked,
                stakingToken: stakingToken
            }),
            vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalLocked, {
                totalLocked: totalLockedAmount,
                lockedToken: stakingToken
            }),
            vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAvg, {}),
            !isFinished && stakingLimit && stakingLimit.gt(0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MaxStakeRow, {
                small: true,
                currentBlock: currentBlock,
                hasPoolStarted: hasPoolStarted,
                stakingLimit: stakingLimit,
                stakingLimitEndBlock: stakingLimitEndBlock,
                stakingToken: stakingToken
            }),
            shouldShowBlockCountdown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: true,
                        children: [
                            hasPoolStarted ? t("Ends in") : t("Starts in"),
                            ":"
                        ]
                    }),
                    blocksRemaining || blocksUntilStart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            external: true,
                            href: (0,utils/* getBscScanLink */.s6)(hasPoolStarted ? endBlock : startBlock, "countdown"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    small: true,
                                    value: blocksToDisplay,
                                    decimals: 0,
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    small: true,
                                    ml: "4px",
                                    color: "primary",
                                    textTransform: "lowercase",
                                    children: t("Blocks")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
                                    ml: "4px",
                                    color: "primary"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "54px",
                        height: "21px"
                    })
                ]
            }),
            vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(PerformanceFee, {
                userData: userData,
                performanceFeeAsDecimal: performanceFeeAsDecimal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "/info/token/".concat(earningToken.address),
                    bold: false,
                    small: true,
                    children: t("See Token Info")
                })
            }),
            !vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: earningToken.projectLink,
                    bold: false,
                    small: true,
                    children: t("View Project Site")
                })
            }),
            vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "https://docs.pancakeswap.finance/products/syrup-pool/new-cake-pool",
                    bold: false,
                    small: true,
                    children: t("View Tutorial")
                })
            }),
            poolContractAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "".concat(config/* BASE_BSC_SCAN_URL */.OS, "/address/").concat(vaultKey ? cakeVaultContractAddress : poolContractAddress),
                    bold: false,
                    small: true,
                    children: t("View Contract")
                })
            }),
            account && tokenAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWalletButton/* default */.Z, {
                    variant: "text",
                    p: "0",
                    height: "auto",
                    style: {
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "normal"
                    },
                    marginTextBetweenLogo: "4px",
                    textOptions: AddToWalletButton/* AddToWalletTextOptions.TEXT */.L.TEXT,
                    tokenAddress: tokenAddress,
                    tokenSymbol: earningToken.symbol,
                    tokenDecimals: earningToken.decimals,
                    tokenLogo: "https://app.bitnou.com/images/".concat(tokenAddress, ".png")
                })
            })
        ]
    });
};
/* harmony default export */ var components_PoolStatsInfo = (/*#__PURE__*/(0,react.memo)(PoolStatsInfo));

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardFooter/index.tsx

function CardFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  button {\n    padding: 0;\n  }\n"
    ]);
    CardFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    height: 14px;\n    width: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ExpandableButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3b2038e4-0"
})(CardFooter_templateObject());
var ExpandedWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3b2038e4-1"
})(_templateObject1());
var Footer = function(param) {
    var pool = param.pool, account = param.account, defaultExpanded = param.defaultExpanded, children = param.children;
    var vaultKey = pool.vaultKey;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(defaultExpanded || false), isExpanded = ref[0], setIsExpanded = ref[1];
    var manualTooltipText = t("You must harvest and compound your earnings from this pool manually.");
    var autoTooltipText = t("Rewards are distributed and included into your staking balance automatically. There\u2019s no need to manually compound your rewards.");
    var ref1 = (0,useTooltip/* default */.Z)(vaultKey ? autoTooltipText : manualTooltipText, {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardFooter/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandableButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CompoundingPoolTag */.yd, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* ManualPoolTag */.EM, {}),
                            tooltipVisible && tooltip,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                    ml: "4px",
                                    width: "20px",
                                    height: "20px",
                                    color: "textSubtle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableButton/* ExpandableLabel */.L, {
                        expanded: isExpanded,
                        onClick: function() {
                            return setIsExpanded(!isExpanded);
                        },
                        children: isExpanded ? t("Hide") : t("Details")
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandedWrapper, {
                flexDirection: "column",
                children: children || /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PoolStatsInfo, {
                    pool: pool,
                    account: account
                })
            })
        ]
    });
};
/* harmony default export */ var PoolCard_CardFooter = (Footer);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx
var CardHeader = __webpack_require__(87654);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/PoolCardHeader.tsx

function PoolCardHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    PoolCardHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(CardHeader/* default */.Z).withConfig({
    componentId: "sc-7f0398ff-0"
})(PoolCardHeader_templateObject(), function(param) {
    var isFinished = param.isFinished, background = param.background, theme = param.theme;
    return isFinished ? theme.colors.backgroundDisabled : theme.colors.gradients[background];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
});
var PoolCardHeader = function(param) {
    var _isFinished = param.isFinished, isFinished = _isFinished === void 0 ? false : _isFinished, _isStaking = param.isStaking, isStaking = _isStaking === void 0 ? false : _isStaking, children = param.children;
    var background = isStaking ? "bubblegum" : "cardHeader";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        isFinished: isFinished,
        background: background,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            alignItems: "center",
            justifyContent: "space-between",
            children: children
        })
    });
};
var PoolCardHeaderTitle = function(param) {
    var isFinished = param.isFinished, title = param.title, subTitle = param.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: isFinished ? "textDisabled" : "body",
                scale: "lg",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                color: isFinished ? "textDisabled" : "textSubtle",
                children: subTitle
            })
        ]
    });
};
/* harmony default export */ var PoolCard_PoolCardHeader = (PoolCardHeader);

// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var constants_types = __webpack_require__(97971);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 6 modules
var profile_hooks = __webpack_require__(82957);
;// CONCATENATED MODULE: ./src/views/Pools/hooks/useProfileRequirement.ts


function useProfileRequirement(profileRequirement) {
    var ref = (0,profile_hooks/* useProfile */.Un)(), profile = ref.profile, hasActiveProfile = ref.hasActiveProfile;
    var notMeetRequired = (0,react.useMemo)(function() {
        return profileRequirement && profileRequirement.required && !hasActiveProfile;
    }, [
        profileRequirement,
        hasActiveProfile
    ]);
    var ref1;
    var notMeetThreshold = (0,react.useMemo)(function() {
        return profileRequirement && profileRequirement.thresholdPoints.gt(0) && profileRequirement.thresholdPoints.gt((ref1 = profile === null || profile === void 0 ? void 0 : profile.points) !== null && ref1 !== void 0 ? ref1 : 0);
    }, [
        profileRequirement,
        profile
    ]);
    return {
        notMeetRequired: notMeetRequired,
        notMeetThreshold: notMeetThreshold
    };
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
;// CONCATENATED MODULE: ./src/state/actions.ts



// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(38472);
;// CONCATENATED MODULE: ./src/hooks/useCakeApprovalStatus.ts




// TODO: refactor as useTokenApprovalStatus for generic use
var useCakeApprovalStatus = function(spender) {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useContract/* useCake */.kL)(), cakeContract = ref.reader;
    var key = (0,react.useMemo)(function() {
        return account && spender ? {
            contract: cakeContract,
            methodName: "allowance",
            params: [
                account,
                spender
            ]
        } : null;
    }, [
        account,
        cakeContract,
        spender
    ]);
    var ref1 = (0,useSWRContract/* useSWRContract */.Av)(key), data = ref1.data, mutate = ref1.mutate;
    return {
        isVaultApproved: data ? data.gt(0) : false,
        setLastUpdated: mutate
    };
};
/* harmony default export */ var hooks_useCakeApprovalStatus = (useCakeApprovalStatus);

;// CONCATENATED MODULE: ./src/hooks/useCakeApprove.tsx










var useCakeApprove = function(setLastUpdated, spender, successMsg) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref1 = (0,useContract/* useCake */.kL)(), cakeContract = ref1.signer;
    var handleApprove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return callWithGasPrice(cakeContract, "approve", [
                                spender,
                                bignumbers/* MaxUint256 */.Bz
                            ]);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: successMsg
                            }));
                            setLastUpdated();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleApprove() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};
/* harmony default export */ var hooks_useCakeApprove = (useCakeApprove);

;// CONCATENATED MODULE: ./src/views/Pools/hooks/useApprove.tsx
















var useApprovePool = function(lpContract, sousId, earningTokenSymbol) {
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var handleApprove = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return callWithGasPrice(lpContract, "approve", [
                            sousChefContract.address,
                            bignumbers/* MaxUint256 */.Bz
                        ]);
                    });
                case 2:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: receipt.transactionHash,
                            children: t("You can now stake in the %symbol% pool!", {
                                symbol: earningTokenSymbol
                            })
                        }));
                        dispatch((0,state_pools/* updateUserAllowance */.Oy)({
                            sousId: sousId,
                            account: account
                        }));
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        account,
        dispatch,
        lpContract,
        sousChefContract,
        sousId,
        earningTokenSymbol,
        t,
        toastSuccess,
        callWithGasPrice,
        fetchWithCatchTxError, 
    ]);
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};
// Approve BNOU auto pool
var useVaultApprove = function(vaultKey, setLastUpdated) {
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)(vaultKey);
    var t = (0,src/* useTranslation */.$G)().t;
    return hooks_useCakeApprove(setLastUpdated, vaultPoolContract === null || vaultPoolContract === void 0 ? void 0 : vaultPoolContract.address, t("You can now stake in the %symbol% vault!", {
        symbol: "BNOU"
    }));
};
var useCheckVaultApprovalStatus = function(vaultKey) {
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)(vaultKey);
    return hooks_useCakeApprovalStatus(vaultPoolContract === null || vaultPoolContract === void 0 ? void 0 : vaultPoolContract.address);
};

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/ApprovalAction.tsx





var ApprovalAction = function(param) {
    var pool = param.pool, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken;
    var t = (0,src/* useTranslation */.$G)().t;
    var stakingTokenContract = (0,useContract/* useERC20 */.X_)(stakingToken.address || "");
    var ref = useApprovePool(stakingTokenContract, sousId, earningToken.symbol), handleApprove = ref.handleApprove, pendingTx = ref.pendingTx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: pendingTx,
            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                spin: true,
                color: "currentColor"
            }) : null,
            disabled: pendingTx,
            onClick: handleApprove,
            width: "100%",
            children: t("Enable")
        })
    });
};
/* harmony default export */ var CardActions_ApprovalAction = (ApprovalAction);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(72943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/OpenNew.tsx
var OpenNew = __webpack_require__(24788);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/NotEnoughTokensModal.tsx

function NotEnoughTokensModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    NotEnoughTokensModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-7a95bff2-0"
})(NotEnoughTokensModal_templateObject());
var NotEnoughTokensModal = function(param) {
    var tokenSymbol = param.tokenSymbol, onDismiss = param.onDismiss;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: t("%symbol% required", {
            symbol: tokenSymbol
        }),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "failure",
                bold: true,
                children: t("Insufficient %symbol% balance", {
                    symbol: tokenSymbol
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "24px",
                children: t("You\u2019ll need %symbol% to stake in this pool!", {
                    symbol: tokenSymbol
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Buy some %symbol%, or make sure your %symbol% isn\u2019t in another pool or LP.", {
                    symbol: tokenSymbol
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                mt: "24px",
                as: "a",
                external: true,
                href: "/swap",
                children: [
                    t("Buy"),
                    " ",
                    tokenSymbol
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                href: "https://yieldwatch.net",
                external: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "secondary",
                    mt: "8px",
                    width: "100%",
                    children: [
                        t("Locate Assets"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNew/* default */.Z, {
                            color: "primary",
                            ml: "4px"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: onDismiss,
                children: t("Close Window")
            })
        ]
    });
};
/* harmony default export */ var Modals_NotEnoughTokensModal = (NotEnoughTokensModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx
var BalanceInput = __webpack_require__(64366);
// EXTERNAL MODULE: ./packages/uikit/src/components/Slider/Slider.tsx + 1 modules
var Slider = __webpack_require__(59739);
// EXTERNAL MODULE: ./src/utils/compoundApyHelpers.ts
var compoundApyHelpers = __webpack_require__(43452);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/PercentageButton.tsx

function PercentageButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    PercentageButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-65705e00-0"
})(PercentageButton_templateObject());
var PercentageButton = function(param) {
    var children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        scale: "xs",
        mx: "2px",
        p: "4px 16px",
        variant: "tertiary",
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ var Modals_PercentageButton = (PercentageButton);

// EXTERNAL MODULE: ./src/utils/getGasPrice.ts
var getGasPrice = __webpack_require__(76582);
;// CONCATENATED MODULE: ./src/views/Pools/hooks/useStakePool.ts










var options = {
    gasLimit: config/* DEFAULT_GAS_LIMIT */.QL
};
var sousStake = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sousChefContract, amount) {
        var decimals, gasPrice, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    decimals = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 18;
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    return _ctx.abrupt("return", sousChefContract.deposit(new (bignumber_default())(amount).times((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(decimals)).toString(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sousStake(sousChefContract, amount) {
        return _ref.apply(this, arguments);
    };
}();
var sousStakeBnb = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sousChefContract, amount) {
        var gasPrice;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    return _ctx.abrupt("return", sousChefContract.deposit(new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sousStakeBnb(sousChefContract, amount) {
        return _ref.apply(this, arguments);
    };
}();
var useStakePool = function(sousId) {
    var isUsingBnb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var handleStake = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount, decimals) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isUsingBnb) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", sousStakeBnb(sousChefContract, amount));
                    case 2:
                        return _ctx.abrupt("return", sousStake(sousChefContract, amount, decimals));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount, decimals) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isUsingBnb,
        sousChefContract
    ]);
    return {
        onStake: handleStake
    };
};
/* harmony default export */ var hooks_useStakePool = (useStakePool);

;// CONCATENATED MODULE: ./src/views/Pools/hooks/useUnstakePool.ts






var sousUnstake = function(sousChefContract, amount, decimals) {
    var gasPrice = (0,getGasPrice/* default */.Z)();
    var units = (0,lib_esm/* parseUnits */.vz)(amount, decimals);
    return sousChefContract.withdraw(units.toString(), {
        gasPrice: gasPrice
    });
};
var sousEmergencyUnstake = function(sousChefContract) {
    var gasPrice = (0,getGasPrice/* default */.Z)();
    return sousChefContract.emergencyWithdraw({
        gasPrice: gasPrice
    });
};
var useUnstakePool = function(sousId) {
    var enableEmergencyWithdraw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var handleUnstake = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount, decimals) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!enableEmergencyWithdraw) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", sousEmergencyUnstake(sousChefContract));
                    case 2:
                        return _ctx.abrupt("return", sousUnstake(sousChefContract, amount, decimals));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount, decimals) {
            return _ref.apply(this, arguments);
        };
    }(), [
        enableEmergencyWithdraw,
        sousChefContract
    ]);
    return {
        onUnstake: handleUnstake
    };
};
/* harmony default export */ var hooks_useUnstakePool = (useUnstakePool);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/StakeModal.tsx



function StakeModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    StakeModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StakeModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    StakeModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



















var StakeModal_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-7fe11ba8-0"
})(StakeModal_templateObject());
var AnnualRoiContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7fe11ba8-1"
})(StakeModal_templateObject1());
var AnnualRoiDisplay = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-7fe11ba8-2"
})(_templateObject2());
var StakeModal = function(param) {
    var isBnbPool = param.isBnbPool, pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, stakingTokenPrice = param.stakingTokenPrice, _isRemovingStake = param.isRemovingStake, isRemovingStake = _isRemovingStake === void 0 ? false : _isRemovingStake, onDismiss = param.onDismiss;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningTokenPrice = pool.earningTokenPrice, apr = pool.apr, userData = pool.userData, stakingLimit = pool.stakingLimit, earningToken = pool.earningToken;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var onStake = hooks_useStakePool(sousId, isBnbPool).onStake;
    var onUnstake = hooks_useUnstakePool(sousId, pool.enableEmergencyWithdraw).onUnstake;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var ref1 = (0,react.useState)(""), stakeAmount = ref1[0], setStakeAmount = ref1[1];
    var ref2 = (0,react.useState)(false), hasReachedStakeLimit = ref2[0], setHasReachedStakedLimit = ref2[1];
    var ref3 = (0,react.useState)(0), percent = ref3[0], setPercent = ref3[1];
    var ref4 = (0,react.useState)(false), showRoiCalculator = ref4[0], setShowRoiCalculator = ref4[1];
    var getCalculatedStakingLimit = (0,react.useCallback)(function() {
        if (isRemovingStake) {
            return userData.stakedBalance;
        }
        return stakingLimit.gt(0) && stakingTokenBalance.gt(stakingLimit) ? stakingLimit : stakingTokenBalance;
    }, [
        userData.stakedBalance,
        stakingTokenBalance,
        stakingLimit,
        isRemovingStake
    ]);
    var fullDecimalStakeAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new (bignumber_default())(stakeAmount), stakingToken.decimals);
    var userNotEnoughToken = isRemovingStake ? userData.stakedBalance.lt(fullDecimalStakeAmount) : userData.stakingTokenBalance.lt(fullDecimalStakeAmount);
    var usdValueStaked = new (bignumber_default())(stakeAmount).times(stakingTokenPrice);
    var formattedUsdValueStaked = !usdValueStaked.isNaN() && (0,formatBalance/* formatNumber */.uf)(usdValueStaked.toNumber());
    var interestBreakdown = (0,compoundApyHelpers/* getInterestBreakdown */.A1)({
        principalInUSD: !usdValueStaked.isNaN() ? usdValueStaked.toNumber() : 0,
        apr: apr,
        earningTokenPrice: earningTokenPrice
    });
    var annualRoi = interestBreakdown[3] * pool.earningTokenPrice;
    var formattedAnnualRoi = (0,formatBalance/* formatNumber */.uf)(annualRoi, annualRoi > 10000 ? 0 : 2, annualRoi > 10000 ? 0 : 2);
    var getTokenLink = stakingToken.address ? "/swap?outputCurrency=".concat(stakingToken.address) : "/swap";
    (0,react.useEffect)(function() {
        if (stakingLimit.gt(0) && !isRemovingStake) {
            setHasReachedStakedLimit(fullDecimalStakeAmount.plus(userData.stakedBalance).gt(stakingLimit));
        }
    }, [
        stakeAmount,
        stakingLimit,
        userData,
        stakingToken,
        isRemovingStake,
        setHasReachedStakedLimit,
        fullDecimalStakeAmount, 
    ]);
    var handleStakeInputChange = function(input) {
        if (input) {
            var convertedInput = (0,formatBalance/* getDecimalAmount */.Qe)(new (bignumber_default())(input), stakingToken.decimals);
            var percentage = Math.floor(convertedInput.dividedBy(getCalculatedStakingLimit()).multipliedBy(100).toNumber());
            setPercent(Math.min(percentage, 100));
        } else {
            setPercent(0);
        }
        setStakeAmount(input);
    };
    var handleChangePercent = (0,react.useCallback)(function(sliderPercent) {
        if (sliderPercent > 0) {
            var percentageOfStakingMax = getCalculatedStakingLimit().dividedBy(100).multipliedBy(sliderPercent);
            var amountToStake = (0,formatBalance/* getFullDisplayBalance */.NJ)(percentageOfStakingMax, stakingToken.decimals, stakingToken.decimals);
            setStakeAmount(amountToStake);
        } else {
            setStakeAmount("");
        }
        setPercent(sliderPercent);
    }, [
        getCalculatedStakingLimit,
        stakingToken.decimals
    ]);
    var handleConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            if (isRemovingStake) {
                                return onUnstake(stakeAmount, stakingToken.decimals);
                            }
                            return onStake(stakeAmount, stakingToken.decimals);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            if (isRemovingStake) {
                                toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have also been harvested to your wallet!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            } else {
                                toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% funds have been staked in the pool!", {
                                        symbol: stakingToken.symbol
                                    })
                                }));
                            }
                            dispatch((0,state_pools/* updateUserStakedBalance */.cR)({
                                sousId: sousId,
                                account: account
                            }));
                            dispatch((0,state_pools/* updateUserPendingReward */.J4)({
                                sousId: sousId,
                                account: account
                            }));
                            dispatch((0,state_pools/* updateUserBalance */.yi)({
                                sousId: sousId,
                                account: account
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal/* default */.Z, {
            earningTokenPrice: earningTokenPrice,
            stakingTokenPrice: stakingTokenPrice,
            apr: apr,
            linkLabel: t("Get %symbol%", {
                symbol: stakingToken.symbol
            }),
            linkHref: getTokenLink,
            stakingTokenBalance: userData.stakedBalance.plus(stakingTokenBalance),
            stakingTokenSymbol: stakingToken.symbol,
            earningTokenSymbol: earningToken.symbol,
            onBack: function() {
                return setShowRoiCalculator(false);
            },
            initialValue: stakeAmount
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        minWidth: "346px",
        title: isRemovingStake ? t("Unstake") : t("Stake in Pool"),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            stakingLimit.gt(0) && !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "secondary",
                bold: true,
                mb: "24px",
                style: {
                    textAlign: "center"
                },
                fontSize: "16px",
                children: t("Max stake for this pool: %amount% %token%", {
                    amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(stakingLimit, stakingToken.decimals, 0),
                    token: stakingToken.symbol
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        children: [
                            isRemovingStake ? t("Unstake") : t("Stake"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingToken.address, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingToken.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingToken.symbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                value: stakeAmount,
                onUserInput: handleStakeInputChange,
                currencyValue: stakingTokenPrice !== 0 && "~".concat(formattedUsdValueStaked || 0, " USD"),
                isWarning: hasReachedStakeLimit || userNotEnoughToken,
                decimals: stakingToken.decimals
            }),
            hasReachedStakeLimit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "failure",
                fontSize: "12px",
                style: {
                    textAlign: "right"
                },
                mt: "4px",
                children: t("Maximum total stake: %amount% %token%", {
                    amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(new (bignumber_default())(stakingLimit), stakingToken.decimals, 0),
                    token: stakingToken.symbol
                })
            }),
            userNotEnoughToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "failure",
                fontSize: "12px",
                style: {
                    textAlign: "right"
                },
                mt: "4px",
                children: t("Insufficient %symbol% balance", {
                    symbol: stakingToken.symbol
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                ml: "auto",
                color: "textSubtle",
                fontSize: "12px",
                mb: "8px",
                children: t("Balance: %balance%", {
                    balance: (0,formatBalance/* getFullDisplayBalance */.NJ)(getCalculatedStakingLimit(), stakingToken.decimals)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                min: 0,
                max: 100,
                value: percent,
                onValueChanged: handleChangePercent,
                name: "stake",
                valueLabel: "".concat(percent, "%"),
                step: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mt: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                        onClick: function() {
                            return handleChangePercent(25);
                        },
                        children: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                        onClick: function() {
                            return handleChangePercent(50);
                        },
                        children: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                        onClick: function() {
                            return handleChangePercent(75);
                        },
                        children: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                        onClick: function() {
                            return handleChangePercent(100);
                        },
                        children: t("Max")
                    })
                ]
            }),
            !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        mr: "8px",
                        color: "textSubtle",
                        children: [
                            t("Annual ROI at current rates"),
                            ":"
                        ]
                    }),
                    Number.isFinite(annualRoi) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiContainer, {
                        alignItems: "center",
                        onClick: function() {
                            setShowRoiCalculator(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiDisplay, {
                                children: [
                                    "$",
                                    formattedAnnualRoi
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "text",
                                scale: "sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                    color: "textSubtle",
                                    width: "18px"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 60
                    })
                ]
            }),
            isRemovingStake && pool.enableEmergencyWithdraw && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                maxWidth: "346px",
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    textAlign: "center",
                    children: t("This pool was misconfigured. Please unstake your tokens from it, emergencyWithdraw method will be used. Your tokens will be returned to your wallet, however rewards will not be harvested.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                isLoading: pendingTx,
                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "currentColor"
                }) : null,
                onClick: handleConfirmClick,
                disabled: !stakeAmount || parseFloat(stakeAmount) === 0 || hasReachedStakeLimit || userNotEnoughToken,
                mt: "24px",
                children: pendingTx ? t("Confirming") : t("Confirm")
            }),
            !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeModal_StyledLink, {
                external: true,
                href: getTokenLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    width: "100%",
                    mt: "8px",
                    variant: "secondary",
                    children: t("Get %symbol%", {
                        symbol: stakingToken.symbol
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Modals_StakeModal = (StakeModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/StakeActions.tsx








var StakeAction = function(param) {
    var pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, stakedBalance = param.stakedBalance, isBnbPool = param.isBnbPool, isStaked = param.isStaked, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var stakingToken = pool.stakingToken, stakingTokenPrice = pool.stakingTokenPrice, stakingLimit = pool.stakingLimit, isFinished = pool.isFinished, userData = pool.userData;
    var t = (0,src/* useTranslation */.$G)().t;
    var stakedTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance, stakingToken.decimals);
    var stakedTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance.multipliedBy(stakingTokenPrice), stakingToken.decimals);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_NotEnoughTokensModal, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_StakeModal, {
        isBnbPool: isBnbPool,
        pool: pool,
        stakingTokenBalance: stakingTokenBalance,
        stakingTokenPrice: stakingTokenPrice
    })), 1), onPresentStake = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_StakeModal, {
        stakingTokenBalance: stakingTokenBalance,
        isBnbPool: isBnbPool,
        pool: pool,
        stakingTokenPrice: stakingTokenPrice,
        isRemovingStake: true
    })), 1), onPresentUnstake = ref2[0];
    var ref3 = (0,useTooltip/* default */.Z)(t("You\u2019ve already staked the maximum amount you can stake in this pool!"), {
        placement: "bottom"
    }), targetRef = ref3.targetRef, tooltip = ref3.tooltip, tooltipVisible = ref3.tooltipVisible;
    var reachStakingLimit = stakingLimit.gt(0) && userData.stakedBalance.gte(stakingLimit);
    var renderStakeAction = function() {
        return isStaked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flexDirection: "column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                bold: true,
                                fontSize: "20px",
                                decimals: 3,
                                value: stakedTokenBalance
                            }),
                            stakingTokenPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    decimals: 2,
                                    value: stakedTokenDollarBalance,
                                    prefix: "~",
                                    unit: " USD"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "secondary",
                            onClick: onPresentUnstake,
                            mr: "6px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                color: "primary",
                                width: "24px"
                            })
                        }),
                        reachStakingLimit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            ref: targetRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "secondary",
                                disabled: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "textDisabled",
                                    width: "24px",
                                    height: "24px"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "secondary",
                            onClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
                            disabled: isFinished,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                color: "primary",
                                width: "24px",
                                height: "24px"
                            })
                        })
                    ]
                }),
                tooltipVisible && tooltip
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            disabled: isFinished,
            onClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
            children: t("Stake")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        }) : renderStakeAction()
    });
};
/* harmony default export */ var StakeActions = (StakeAction);

// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
;// CONCATENATED MODULE: ./src/views/Pools/hooks/useHarvestPool.ts









var useHarvestPool_options = {
    gasLimit: config/* DEFAULT_GAS_LIMIT */.QL
};
var harvestPool = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sousChefContract) {
        var gasPrice;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    return _ctx.abrupt("return", sousChefContract.deposit("0", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useHarvestPool_options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function harvestPool(sousChefContract) {
        return _ref.apply(this, arguments);
    };
}();
var harvestPoolBnb = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sousChefContract) {
        var gasPrice;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    return _ctx.abrupt("return", sousChefContract.deposit((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useHarvestPool_options), {
                        value: bigNumber/* BIG_ZERO */.HW,
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function harvestPoolBnb(sousChefContract) {
        return _ref.apply(this, arguments);
    };
}();
var useHarvestPool = function(sousId) {
    var isUsingBnb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var handleHarvest = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!isUsingBnb) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", harvestPoolBnb(sousChefContract));
                case 2:
                    return _ctx.abrupt("return", harvestPool(sousChefContract));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isUsingBnb,
        sousChefContract
    ]);
    return {
        onReward: handleHarvest
    };
};
/* harmony default export */ var hooks_useHarvestPool = (useHarvestPool);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/CollectModal.tsx
















var CollectModal = function(param) {
    var formattedBalance = param.formattedBalance, fullBalance = param.fullBalance, earningToken = param.earningToken, earningsDollarValue = param.earningsDollarValue, sousId = param.sousId, isBnbPool = param.isBnbPool, _isCompoundPool = param.isCompoundPool, isCompoundPool = _isCompoundPool === void 0 ? false : _isCompoundPool, onDismiss = param.onDismiss;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var onReward = hooks_useHarvestPool(sousId, isBnbPool).onReward;
    var onStake = hooks_useStakePool(sousId, isBnbPool).onStake;
    var ref1 = (0,react.useState)(isCompoundPool), shouldCompound = ref1[0], setShouldCompound = ref1[1];
    var ref2 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "12px",
                children: t("Compound: collect and restake BNOU into pool.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Harvest: collect BNOU and send to wallet")
            })
        ]
    }), {
        placement: "bottom-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref2.targetRef, tooltip = ref2.tooltip, tooltipVisible = ref2.tooltipVisible;
    var handleHarvestConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            if (shouldCompound) {
                                return onStake(fullBalance, earningToken.decimals);
                            }
                            return onReward();
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            if (shouldCompound) {
                                toastSuccess("".concat(t("Compounded"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have been re-invested into the pool!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            } else {
                                toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have been sent to your wallet!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            }
                            dispatch((0,state_pools/* updateUserStakedBalance */.cR)({
                                sousId: sousId,
                                account: account
                            }));
                            dispatch((0,state_pools/* updateUserPendingReward */.J4)({
                                sousId: sousId,
                                account: account
                            }));
                            dispatch((0,state_pools/* updateUserBalance */.yi)({
                                sousId: sousId,
                                account: account
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleHarvestConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: "".concat(earningToken.symbol, " ").concat(isCompoundPool ? t("Collect") : t("Harvest")),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            isCompoundPool && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                        activeIndex: shouldCompound ? 0 : 1,
                        scale: "sm",
                        variant: "subtle",
                        onItemClick: function(index) {
                            return setShouldCompound(!index);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                as: "button",
                                children: t("Compound")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                as: "button",
                                children: t("Harvest")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        ml: "10px",
                        ref: targetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                            color: "textSubtle"
                        })
                    }),
                    tooltipVisible && tooltip
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            shouldCompound ? t("Compounding") : t("Harvesting"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                children: [
                                    formattedBalance,
                                    " ",
                                    earningToken.symbol
                                ]
                            }),
                            earningsDollarValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: "~".concat((0,formatBalance/* formatNumber */.uf)(earningsDollarValue), " USD")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mt: "8px",
                onClick: handleHarvestConfirm,
                isLoading: pendingTx,
                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "currentColor"
                }) : null,
                children: pendingTx ? t("Confirming") : t("Confirm")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: onDismiss,
                pb: "0px",
                children: t("Close Window")
            })
        ]
    });
};
/* harmony default export */ var Modals_CollectModal = (CollectModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/HarvestActions.tsx







var HarvestActions = function(param) {
    var earnings = param.earnings, earningToken = param.earningToken, sousId = param.sousId, isBnbPool = param.isBnbPool, earningTokenPrice = param.earningTokenPrice, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var t = (0,src/* useTranslation */.$G)().t;
    var earningTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings, earningToken.decimals);
    var formattedBalance = (0,formatBalance/* formatNumber */.uf)(earningTokenBalance, 3, 3);
    var earningTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings.multipliedBy(earningTokenPrice), earningToken.decimals);
    var fullBalance = (0,formatBalance/* getFullDisplayBalance */.NJ)(earnings, earningToken.decimals);
    var hasEarnings = earnings.toNumber() > 0;
    var isCompoundPool = sousId === 0;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_CollectModal, {
        formattedBalance: formattedBalance,
        fullBalance: fullBalance,
        earningToken: earningToken,
        earningsDollarValue: earningTokenDollarBalance,
        sousId: sousId,
        isBnbPool: isBnbPool,
        isCompoundPool: isCompoundPool
    })), 1), onPresentCollect = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        mb: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexDirection: "column",
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "48px"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: hasEarnings ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                bold: true,
                                fontSize: "20px",
                                decimals: 5,
                                value: earningTokenBalance
                            }),
                            earningTokenPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                display: "inline",
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                prefix: "~",
                                value: earningTokenDollarBalance,
                                unit: " USD"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                color: "textDisabled",
                                children: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textDisabled",
                                children: "0 USD"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                disabled: !hasEarnings,
                onClick: onPresentCollect,
                children: isCompoundPool ? t("Collect") : t("Harvest")
            })
        ]
    });
};
/* harmony default export */ var CardActions_HarvestActions = (HarvestActions);

// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(53629);
;// CONCATENATED MODULE: ./src/views/Pools/components/ProfileRequirementWarning.tsx





function ProfileRequirementWarning(param) {
    var profileRequirement = param.profileRequirement;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useProfileRequirement(profileRequirement), notMeetRequired = ref.notMeetRequired, notMeetThreshold = ref.notMeetThreshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
        variant: "warning",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                    children: [
                        notMeetRequired && notMeetThreshold && t("This pool requires active Pancake Profile and %amount% profile points.", {
                            amount: profileRequirement.thresholdPoints.toNumber().toLocaleString()
                        }),
                        notMeetRequired && !notMeetThreshold && t("This pool requires active Pancake Profile"),
                        !notMeetRequired && notMeetThreshold && t("This pool requires %amount% profile points.", {
                            amount: profileRequirement.thresholdPoints.toNumber().toLocaleString()
                        })
                    ]
                }),
                (notMeetRequired || notMeetThreshold) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    bold: true,
                    children: notMeetRequired ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* NextLinkFromReactRouter */.a, {
                        style: {
                            textDecoration: "underline"
                        },
                        to: "/create-profile",
                        children: [
                            t("Create Profile"),
                            " \xbb"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* NextLinkFromReactRouter */.a, {
                        style: {
                            textDecoration: "underline"
                        },
                        to: "/profile",
                        children: [
                            t("Go to Profile"),
                            " \xbb"
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/index.tsx

function CardActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    CardActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var InlineText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-7d1628c8-0"
})(CardActions_templateObject());
var CardActions = function(param) {
    var pool = param.pool, stakedBalance = param.stakedBalance;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken, poolCategory = pool.poolCategory, userData = pool.userData, earningTokenPrice = pool.earningTokenPrice, profileRequirement = pool.profileRequirement;
    // Pools using native BNB behave differently than pools using a token
    var isBnbPool = poolCategory === constants_types/* PoolCategory.BINANCE */.jh.BINANCE;
    var t = (0,src/* useTranslation */.$G)().t;
    var allowance = (userData === null || userData === void 0 ? void 0 : userData.allowance) ? new (bignumber_default())(userData.allowance) : bigNumber/* BIG_ZERO */.HW;
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new (bignumber_default())(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var earnings = (userData === null || userData === void 0 ? void 0 : userData.pendingReward) ? new (bignumber_default())(userData.pendingReward) : bigNumber/* BIG_ZERO */.HW;
    var needsApproval = !allowance.gt(0) && !isBnbPool;
    var isStaked = stakedBalance.gt(0);
    var isLoading = !userData;
    var ref = useProfileRequirement(profileRequirement), notMeetRequired = ref.notMeetRequired, notMeetThreshold = ref.notMeetThreshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "inline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                                    color: "secondary",
                                    textTransform: "uppercase",
                                    bold: true,
                                    fontSize: "12px",
                                    children: "".concat(earningToken.symbol, " ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                                    color: "textSubtle",
                                    textTransform: "uppercase",
                                    bold: true,
                                    fontSize: "12px",
                                    children: t("Earned")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions_HarvestActions, {
                            earnings: earnings,
                            earningToken: earningToken,
                            sousId: sousId,
                            earningTokenPrice: earningTokenPrice,
                            isBnbPool: isBnbPool,
                            isLoading: isLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "inline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InlineText, {
                            color: isStaked ? "secondary" : "textSubtle",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: [
                                isStaked ? stakingToken.symbol : t("Stake"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                            color: isStaked ? "textSubtle" : "secondary",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: isStaked ? t("Staked") : "".concat(stakingToken.symbol)
                        })
                    ]
                }),
                notMeetRequired || notMeetThreshold ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileRequirementWarning, {
                    profileRequirement: profileRequirement
                }) : needsApproval ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions_ApprovalAction, {
                    pool: pool,
                    isLoading: isLoading
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeActions, {
                    isLoading: isLoading,
                    pool: pool,
                    stakingTokenBalance: stakingTokenBalance,
                    stakedBalance: stakedBalance,
                    isBnbPool: isBnbPool,
                    isStaked: isStaked
                })
            ]
        })
    });
};
/* harmony default export */ var PoolCard_CardActions = (CardActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/index.tsx












var PoolCard = function(param) {
    var pool = param.pool, account = param.account;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken, isFinished = pool.isFinished, userData = pool.userData;
    var t = (0,src/* useTranslation */.$G)().t;
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new (bignumber_default())(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    var accountHasStakedBalance = stakedBalance.gt(0);
    var isCakePool = earningToken.symbol === "BNOU" && stakingToken.symbol === "BNOU";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        isFinished: isFinished && sousId !== 0,
        ribbon: isFinished && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRibbon/* default */.Z, {
            variantColor: "textDisabled",
            text: t("Finished")
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolCard_PoolCardHeader, {
                isStaking: accountHasStakedBalance,
                isFinished: isFinished && sousId !== 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCardHeaderTitle, {
                        title: isCakePool ? t("Manual") : t("Earn %asset%", {
                            asset: earningToken.symbol
                        }),
                        subTitle: isCakePool ? t("Earn BNOU, stake BNOU") : t("Stake %symbol%", {
                            symbol: stakingToken.symbol
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                        primaryToken: earningToken,
                        secondaryToken: stakingToken,
                        width: 64,
                        height: 64
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard_AprRow, {
                        pool: pool,
                        stakedBalance: stakedBalance
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        mt: "24px",
                        flexDirection: "column",
                        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard_CardActions, {
                            pool: pool,
                            stakedBalance: stakedBalance
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mb: "10px",
                                    textTransform: "uppercase",
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    bold: true,
                                    children: t("Start earning")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard_CardFooter, {
                pool: pool,
                account: account
            })
        ]
    });
};
/* harmony default export */ var components_PoolCard = (PoolCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/Image/TokenPairImage.tsx + 2 modules
var TokenPairImage = __webpack_require__(56503);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Split.tsx
var Split = __webpack_require__(79539);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Lock.tsx
var Lock = __webpack_require__(79491);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Unlock.tsx
var Unlock = __webpack_require__(57503);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Hot.tsx
var Hot = __webpack_require__(41725);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(24930);
// EXTERNAL MODULE: ./src/components/Trans.tsx
var Trans = __webpack_require__(96464);
;// CONCATENATED MODULE: ./src/views/Pools/components/Vault/VaultPositionTag.tsx











var _obj;
var tagConfig = (_obj = {}, (0,_define_property/* default */.Z)(_obj, VaultPosition.None, {}), (0,_define_property/* default */.Z)(_obj, VaultPosition.Flexible, {
    variant: "success"
}), (0,_define_property/* default */.Z)(_obj, VaultPosition.Locked, {
    variant: "secondary"
}), (0,_define_property/* default */.Z)(_obj, VaultPosition.LockedEnd, {
    variant: "secondary",
    outline: true
}), (0,_define_property/* default */.Z)(_obj, VaultPosition.AfterBurning, {
    variant: "failure",
    outline: true
}), _obj);
var _obj1;
var iconConfig = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, VaultPosition.None, null), (0,_define_property/* default */.Z)(_obj1, VaultPosition.Flexible, Split/* default */.Z), (0,_define_property/* default */.Z)(_obj1, VaultPosition.Locked, Lock/* default */.Z), (0,_define_property/* default */.Z)(_obj1, VaultPosition.LockedEnd, Unlock/* default */.Z), (0,_define_property/* default */.Z)(_obj1, VaultPosition.AfterBurning, Hot/* default */.Z), _obj1);
var _obj2;
var positionLabel = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, VaultPosition.None, ""), (0,_define_property/* default */.Z)(_obj2, VaultPosition.Flexible, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "Flexible"
})), (0,_define_property/* default */.Z)(_obj2, VaultPosition.Locked, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "Locked"
})), (0,_define_property/* default */.Z)(_obj2, VaultPosition.LockedEnd, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "Locked End"
})), (0,_define_property/* default */.Z)(_obj2, VaultPosition.AfterBurning, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "After Burning"
})), _obj2);
var VaultPositionTag = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tagConfig[position]), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                as: iconConfig[position],
                mr: "4px"
            }),
            positionLabel[position]
        ]
    }));
};
var VaultPositionTagWithLabel = function(_param) {
    var userData = _param.userData, props = (0,_object_without_properties/* default */.Z)(_param, [
        "userData"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var position = (0,react.useMemo)(function() {
        return getVaultPosition(userData);
    }, [
        userData
    ]);
    if (position) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            alignItems: "center",
            justifyContent: "space-between",
            marginX: "8px",
            mb: "8px",
            gap: "12px"
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "secondary",
                    textTransform: "uppercase",
                    bold: true,
                    children: t("My Position")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultPositionTag, {
                    position: position
                })
            ]
        }));
    }
    return null;
};


;// CONCATENATED MODULE: ./src/views/Pools/hooks/useWithdrawalFeeTimer.ts

var getHasWithdrawFee = function(lastDepositedTime) {
    var withdrawalFeePeriod = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 259200;
    var feeEndTime = lastDepositedTime + withdrawalFeePeriod;
    var currentSeconds = Math.floor(Date.now() / 1000);
    var secondsRemainingCalc = feeEndTime - currentSeconds;
    return secondsRemainingCalc > 0;
};
var useWithdrawalFeeTimer = function(lastDepositedTime, userShares) {
    var withdrawalFeePeriod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 259200;
    var ref = (0,react.useState)(null), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var ref1 = (0,react.useState)(false), hasUnstakingFee = ref1[0], setHasUnstakingFee = ref1[1];
    var ref2 = (0,react.useState)(function() {
        return Math.floor(Date.now() / 1000);
    }), currentSeconds = ref2[0], setCurrentSeconds = ref2[1];
    (0,react.useEffect)(function() {
        var feeEndTime = lastDepositedTime + withdrawalFeePeriod;
        var secondsRemainingCalc = feeEndTime - currentSeconds;
        var doesUnstakingFeeApply = userShares.gt(0) && secondsRemainingCalc > 0;
        var tick = function() {
            setCurrentSeconds(function(prevSeconds) {
                return prevSeconds + 1;
            });
        };
        var timerInterval = setInterval(function() {
            return tick();
        }, 1000);
        if (doesUnstakingFeeApply) {
            setSecondsRemaining(secondsRemainingCalc);
            setHasUnstakingFee(true);
        } else {
            setHasUnstakingFee(false);
            clearInterval(timerInterval);
        }
        return function() {
            return clearInterval(timerInterval);
        };
    }, [
        lastDepositedTime,
        withdrawalFeePeriod,
        setSecondsRemaining,
        currentSeconds,
        userShares
    ]);
    return {
        hasUnstakingFee: hasUnstakingFee,
        secondsRemaining: secondsRemaining
    };
};
/* harmony default export */ var hooks_useWithdrawalFeeTimer = (useWithdrawalFeeTimer);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/secondsToHours/index.js


/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */

function secondsToHours(seconds) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var hours = seconds / constants/* secondsInHour */.R3;
  return Math.floor(hours);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js + 4 modules
var formatDistanceToNowStrict = __webpack_require__(16422);
;// CONCATENATED MODULE: ./src/utils/timeHelper.ts

var secondsToDay = function(s) {
    return Math.floor(s / (24 * 60 * 60));
};
var convertTimeToSeconds = function(time) {
    return parseInt(time) * 1000;
};
// https://date-fns.org/v2.28.0/docs/formatDistanceToNowStrict
var distanceToNowStrict = function(timeInMilliSeconds) {
    var endTime = new Date(timeInMilliSeconds);
    return new Date() > endTime || !Number.isFinite(timeInMilliSeconds) ? "0 seconds" : (0,formatDistanceToNowStrict/* default */.Z)(endTime);
};

// EXTERNAL MODULE: ./src/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(87218);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/WithdrawalFeeTimer.tsx




var WithdrawalFeeTimer = function(param) {
    var secondsRemaining = param.secondsRemaining;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,getTimePeriods/* default */.Z)(secondsRemaining), days = ref.days, hours = ref.hours, minutes = ref.minutes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        bold: true,
        fontSize: "14px",
        children: t("%day%d:%hour%h:%minute%m", {
            day: days,
            hour: hours,
            minute: minutes
        })
    });
};
/* harmony default export */ var CakeVaultCard_WithdrawalFeeTimer = (WithdrawalFeeTimer);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/UnstakingFeeCountdownRow.tsx









var UnstakingFeeCountdownRow = function(param) {
    var isTableVariant = param.isTableVariant, vaultKey = param.vaultKey;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = useVaultPoolByKey(vaultKey), _userData = ref.userData, lastDepositedTime = _userData.lastDepositedTime, userShares = _userData.userShares, _fees = ref.fees, withdrawalFee = _fees.withdrawalFee, withdrawalFeePeriod = _fees.withdrawalFeePeriod;
    var feeAsDecimal = withdrawalFee / 100 || "-";
    var withdrawalDayPeriod = withdrawalFeePeriod ? secondsToDay(withdrawalFeePeriod) : "-";
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Unstaking fee: %fee%%", {
                    fee: feeAsDecimal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Only applies within %num% days of staking. Unstaking after %num% days will not include a fee. Timer resets every time you stake new BNOU in the pool.", {
                    num: withdrawalDayPeriod
                })
            })
        ]
    }), {
        placement: "bottom-start"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var ref2 = hooks_useWithdrawalFeeTimer(parseInt(lastDepositedTime, 10), userShares, withdrawalFeePeriod), secondsRemaining = ref2.secondsRemaining, hasUnstakingFee = ref2.hasUnstakingFee;
    // The user has made a deposit, but has no fee
    var noFeeToPay = lastDepositedTime && !hasUnstakingFee && userShares.gt(0);
    // Show the timer if a user is connected, has deposited, and has an unstaking fee
    var shouldShowTimer = account && lastDepositedTime && hasUnstakingFee;
    var withdrawalFeePeriodHour = withdrawalFeePeriod ? secondsToHours(withdrawalFeePeriod) : "-";
    var getRowText = function() {
        if (noFeeToPay) {
            return t("Unstaking Fee");
        }
        if (shouldShowTimer) {
            return t("unstaking fee before");
        }
        return t("unstaking fee if withdrawn within %num%h", {
            num: withdrawalFeePeriodHour
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: isTableVariant ? "flex-start" : "center",
        justifyContent: "space-between",
        flexDirection: isTableVariant ? "column" : "row",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
                ref: targetRef,
                small: true,
                textTransform: "lowercase",
                children: [
                    noFeeToPay ? "0" : feeAsDecimal,
                    "% ",
                    getRowText()
                ]
            }),
            shouldShowTimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_WithdrawalFeeTimer, {
                secondsRemaining: secondsRemaining
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_UnstakingFeeCountdownRow = (UnstakingFeeCountdownRow);

// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var farms_hooks = __webpack_require__(17166);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__(76972);
;// CONCATENATED MODULE: ./src/views/Pools/components/AutoEarningsBreakdown.tsx







var AutoEarningsBreakdown = function(param) {
    var pool = param.pool, account = param.account;
    var t = (0,src/* useTranslation */.$G)().t;
    var earningTokenPrice = pool.earningTokenPrice;
    var ref = useVaultPoolByKey(pool.vaultKey), pricePerFullShare = ref.pricePerFullShare, userData = ref.userData;
    var ref1 = (0,Pools_helpers/* getCakeVaultEarnings */.UN)(account, userData.cakeAtLastUserAction, userData.userShares, pricePerFullShare, earningTokenPrice, pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? userData.currentPerformanceFee.plus(userData.currentOverdueFee).plus(userData.userBoostedShare) : null), autoCakeToDisplay = ref1.autoCakeToDisplay, autoUsdToDisplay = ref1.autoUsdToDisplay;
    var lastActionInMs = userData.lastUserActionTime ? parseInt(userData.lastUserActionTime) * 1000 : 0;
    var hourDiffSinceLastAction = (0,differenceInHours/* default */.Z)(Date.now(), lastActionInMs);
    var earnedCakePerHour = hourDiffSinceLastAction ? autoCakeToDisplay / hourDiffSinceLastAction : 0;
    var earnedUsdPerHour = hourDiffSinceLastAction ? autoUsdToDisplay / hourDiffSinceLastAction : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                bold: true,
                children: [
                    autoCakeToDisplay.toFixed(3),
                    " BNOU"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                bold: true,
                children: [
                    "~$",
                    autoUsdToDisplay.toFixed(2)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                children: [
                    t("Earned since your last action"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: new Date(lastActionInMs).toLocaleString()
            }),
            hourDiffSinceLastAction ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            t("Your average per hour"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        children: t("BNOU per hour: %amount%", {
                            amount: earnedCakePerHour.toFixed(2)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        children: t("per hour: ~$%amount%", {
                            amount: earnedUsdPerHour.toFixed(2)
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var components_AutoEarningsBreakdown = (AutoEarningsBreakdown);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/RecentCakeProfitBalance.tsx




var RecentCakeProfitBalance = function(param) {
    var cakeToDisplay = param.cakeToDisplay, pool = param.pool, account = param.account;
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_AutoEarningsBreakdown, {
        pool: pool,
        account: account
    }), {
        placement: "bottom-end"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                ref: targetRef,
                small: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                    fontSize: "14px",
                    value: cakeToDisplay
                })
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_RecentCakeProfitBalance = (RecentCakeProfitBalance);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/RecentCakeProfitRow.tsx









var RecentCakeProfitCountdownRow = function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = useVaultPoolByKey(pool.vaultKey), pricePerFullShare = ref.pricePerFullShare, userData = ref.userData;
    var cakePriceBusd = (0,farms_hooks/* usePriceCakeBusd */.Iu)();
    var ref1 = (0,Pools_helpers/* getCakeVaultEarnings */.UN)(account, userData.cakeAtLastUserAction, userData.userShares, pricePerFullShare, cakePriceBusd.toNumber(), pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? userData.currentPerformanceFee.plus(userData.currentOverdueFee) : null), hasAutoEarnings = ref1.hasAutoEarnings, autoCakeToDisplay = ref1.autoCakeToDisplay;
    if (!(userData.userShares.gt(0) && account)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                children: "".concat(t("Recent BNOU profit"), ":")
            }),
            hasAutoEarnings && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_RecentCakeProfitBalance, {
                cakeToDisplay: autoCakeToDisplay,
                pool: pool,
                account: account
            })
        ]
    });
};
/* harmony default export */ var RecentCakeProfitRow = (RecentCakeProfitCountdownRow);

// EXTERNAL MODULE: ./src/components/Card/index.tsx
var components_Card = __webpack_require__(36261);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/lodash/toString.js
var lodash_toString = __webpack_require__(79833);
var toString_default = /*#__PURE__*/__webpack_require__.n(lodash_toString);
// EXTERNAL MODULE: ./src/config/abi/masterchef.json
var masterchef = __webpack_require__(84951);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
;// CONCATENATED MODULE: ./src/hooks/useVaultApy.ts















var masterChefAddress = (0,addressHelpers/* getMasterChefAddress */.Oc)();
// default
var DEFAULT_PERFORMANCE_FEE_DECIMALS = 2;
var PRECISION_FACTOR = bignumber/* BigNumber.from */.O$.from("1000000000000");
var getFlexibleApy = function(totalCakePoolEmissionPerYear, pricePerFullShare, totalShares) {
    return totalCakePoolEmissionPerYear.mulUnsafe(fixednumber/* FixedNumber.from */.xs.from(bignumbers/* WeiPerEther */.Ce)).divUnsafe(pricePerFullShare).divUnsafe(totalShares).mulUnsafe(fixednumber/* FixedNumber.from */.xs.from(100));
};
var _getBoostFactor = function(boostWeight, duration, durationFactor) {
    // console.log('debug booster::', duration, Math.max(duration, 0), typeof Math.max(duration, 0))
    return fixednumber/* FixedNumber.from */.xs.from(boostWeight).mulUnsafe(fixednumber/* FixedNumber.from */.xs.from(bignumber/* BigNumber.from */.O$.from(Math.max(duration, 0)))).divUnsafe(fixednumber/* FixedNumber.from */.xs.from(durationFactor)).divUnsafe(fixednumber/* FixedNumber.from */.xs.from(PRECISION_FACTOR));
};
var getLockedApy = function(flexibleApy, boostFactor) {
    return fixednumber/* FixedNumber.from */.xs.from(flexibleApy).mulUnsafe(boostFactor.addUnsafe(fixednumber/* FixedNumber.from */.xs.from("1")));
};
var cakePoolPID = 0;
function useVaultApy() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _duration = ref.duration, duration = _duration === void 0 ? pools/* MAX_LOCK_DURATION */.VO : _duration;
    var ref1 = useCakeVault(), _totalShares = ref1.totalShares, totalShares = _totalShares === void 0 ? bigNumber/* BIG_ZERO */.HW : _totalShares, _pricePerFullShare = ref1.pricePerFullShare, pricePerFullShare = _pricePerFullShare === void 0 ? bigNumber/* BIG_ZERO */.HW : _pricePerFullShare, tmp = ref1.fees, performanceFeeAsDecimal = (tmp === void 0 ? {
        performanceFeeAsDecimal: DEFAULT_PERFORMANCE_FEE_DECIMALS
    } : tmp).performanceFeeAsDecimal;
    var totalSharesAsEtherBN = (0,react.useMemo)(function() {
        return fixednumber/* FixedNumber.from */.xs.from(totalShares.toString());
    }, [
        totalShares
    ]);
    var pricePerFullShareAsEtherBN = (0,react.useMemo)(function() {
        return fixednumber/* FixedNumber.from */.xs.from(pricePerFullShare.toString());
    }, [
        pricePerFullShare
    ]);
    var ref2 = (0,dist/* default */.Z)("masterChef-total-cake-pool-emission", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var calls, ref, ref1, specialFarmsPerBlock, cakePoolInfo, ref2, totalSpecialAllocPoint, cakePoolSharesInSpecialFarms;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    calls = [
                        {
                            address: masterChefAddress,
                            name: "bnouPerBlock",
                            params: [
                                false
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "poolInfo",
                            params: [
                                cakePoolPID
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "totalSpecialAllocPoint"
                        }, 
                    ];
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 4;
                    return (0,multicall/* multicallv2 */.v)(masterchef, calls);
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    ref1 = (0,_sliced_to_array/* default */.Z)(ref[0], 1);
                    specialFarmsPerBlock = ref1[0];
                    cakePoolInfo = ref[1];
                    ref2 = (0,_sliced_to_array/* default */.Z)(ref[2], 1);
                    totalSpecialAllocPoint = ref2[0];
                    cakePoolSharesInSpecialFarms = fixednumber/* FixedNumber.fromString */.xs.fromString("1");
                    return _ctx.abrupt("return", fixednumber/* FixedNumber.from */.xs.from(specialFarmsPerBlock).mulUnsafe(fixednumber/* FixedNumber.from */.xs.from(config/* BLOCKS_PER_YEAR */.Bi)).mulUnsafe(cakePoolSharesInSpecialFarms));
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), totalCakePoolEmissionPerYear = ref2.data;
    var flexibleApy = (0,react.useMemo)(function() {
        return totalCakePoolEmissionPerYear && !pricePerFullShareAsEtherBN.isZero() && !totalSharesAsEtherBN.isZero() && getFlexibleApy(totalCakePoolEmissionPerYear, pricePerFullShareAsEtherBN, totalSharesAsEtherBN).toString();
    }, [
        pricePerFullShareAsEtherBN,
        totalCakePoolEmissionPerYear,
        totalSharesAsEtherBN
    ]);
    var boostFactor = (0,react.useMemo)(function() {
        return _getBoostFactor(pools/* BOOST_WEIGHT */.xt, duration, pools/* DURATION_FACTOR */.A0);
    }, [
        duration
    ]);
    var lockedApy = (0,react.useMemo)(function() {
        return flexibleApy && getLockedApy(flexibleApy, boostFactor).toString();
    }, [
        boostFactor,
        flexibleApy
    ]);
    var getBoostFactor = (0,react.useCallback)(function(adjustDuration) {
        return _getBoostFactor(pools/* BOOST_WEIGHT */.xt, adjustDuration, pools/* DURATION_FACTOR */.A0);
    }, []);
    var flexibleApyNoFee = (0,react.useMemo)(function() {
        if (flexibleApy && performanceFeeAsDecimal) {
            var rewardPercentageNoFee = toString_default()(1 - performanceFeeAsDecimal / 100);
            return fixednumber/* FixedNumber.from */.xs.from(flexibleApy).mulUnsafe(fixednumber/* FixedNumber.from */.xs.from(rewardPercentageNoFee)).toString();
        }
        return flexibleApy;
    }, [
        flexibleApy,
        performanceFeeAsDecimal
    ]);
    return {
        flexibleApy: flexibleApyNoFee,
        lockedApy: lockedApy,
        getLockedApy: (0,react.useCallback)(function(adjustDuration) {
            return flexibleApy && getLockedApy(flexibleApy, getBoostFactor(adjustDuration)).toString();
        }, [
            flexibleApy,
            getBoostFactor
        ]),
        boostFactor: (0,react.useMemo)(function() {
            return boostFactor.addUnsafe(fixednumber/* FixedNumber.from */.xs.from("1"));
        }, [
            boostFactor
        ]),
        getBoostFactor: (0,react.useCallback)(function(adjustDuration) {
            return getBoostFactor(adjustDuration).addUnsafe(fixednumber/* FixedNumber.from */.xs.from("1"));
        }, [
            getBoostFactor
        ])
    };
}

// EXTERNAL MODULE: ./src/components/RoiCalculatorModal/useRoiCalculatorReducer.ts
var useRoiCalculatorReducer = __webpack_require__(44307);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/LockDurationField.tsx

function LockDurationField_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  margin-right: 8px;\n"
    ]);
    LockDurationField_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DURATIONS = [
    1,
    5,
    10,
    25
];
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-8be2cfd2-0"
})(LockDurationField_templateObject());
var LockDurationField = function(param) {
    var duration = param.duration, setDuration = param.setDuration, isOverMax = param.isOverMax, currentDuration = param.currentDuration, currentDurationLeft = param.currentDurationLeft;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isMaxSelected = ref[0], setIsMaxSelected = ref[1];
    var maxAvailableDuration = currentDurationLeft ? pools/* MAX_LOCK_DURATION */.VO - currentDurationLeft : pools/* MAX_LOCK_DURATION */.VO;
    (0,react.useEffect)(function() {
        if (isMaxSelected) {
            setDuration(maxAvailableDuration);
        }
    }, [
        isMaxSelected,
        maxAvailableDuration,
        setDuration
    ]);
    // When user extends the duration due to time passed when approving
    // transaction the extended duration will be a couple of seconds off to max duration,
    // therefore it is better to compare based on weeks
    var currentDurationInWeeks = (0,react.useMemo)(function() {
        return currentDuration && secondsToWeeks(currentDuration);
    }, [
        currentDuration
    ]);
    var maxDurationInWeeks = (0,react.useMemo)(function() {
        return secondsToWeeks(pools/* MAX_LOCK_DURATION */.VO);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "secondary",
                                bold: true,
                                mr: "2px",
                                textTransform: "uppercase",
                                children: t("Add")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("duration")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexWrap: "wrap",
                        children: [
                            DURATIONS.map(function(week) {
                                var weekSeconds = weeksToSeconds(week);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    onClick: function() {
                                        setIsMaxSelected(false);
                                        setDuration(weekSeconds);
                                    },
                                    mt: "4px",
                                    mr: [
                                        "2px",
                                        "2px",
                                        "4px",
                                        "4px"
                                    ],
                                    scale: "sm",
                                    disabled: weekSeconds > maxAvailableDuration,
                                    variant: weekSeconds === duration ? "subtle" : "tertiary",
                                    children: [
                                        week,
                                        "W"
                                    ]
                                }, week);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    setIsMaxSelected(true);
                                },
                                mt: "4px",
                                mr: [
                                    "2px",
                                    "2px",
                                    "4px",
                                    "4px"
                                ],
                                scale: "sm",
                                disabled: maxAvailableDuration < pools/* ONE_WEEK_DEFAULT */.kp,
                                variant: isMaxSelected ? "subtle" : "tertiary",
                                children: t("Max")
                            }, "max")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        value: secondsToWeeks(duration),
                        autoComplete: "off",
                        pattern: "^[0-9]+$",
                        inputMode: "numeric",
                        onChange: function(e) {
                            var ref;
                            setIsMaxSelected(false);
                            var weeks = toNumber_default()(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                            // Prevent large number input which cause NaN
                            // Why 530, just want to avoid user get laggy experience
                            // For example, allow user put 444 which they still get warning no more than 52
                            if (e.currentTarget.validity.valid && weeks < 530) {
                                var ref1;
                                setDuration(weeksToSeconds(toNumber_default()(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value)));
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Week")
                    })
                ]
            }),
            isOverMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "12px",
                textAlign: "right",
                color: "failure",
                children: t("Total lock duration exceeds 52 weeks")
            }),
            currentDurationLeft && currentDurationInWeeks === maxDurationInWeeks && !isMaxSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    maxWidth: "240px",
                    children: t('Recommend choosing "MAX" to renew your staking position in order to keep similar yield boost.')
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Common_LockDurationField = (LockDurationField);

;// CONCATENATED MODULE: ./src/views/Pools/components/Vault/VaultRoiCalculatorModal.tsx















var VaultRoiCalculatorModal = function(_param) {
    var pool = _param.pool, initialView = _param.initialView, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "pool",
        "initialView"
    ]);
    var ref, ref1;
    var ref2 = useVaultPoolByKey(pool.vaultKey), _userData = ref2.userData, cakeAsBigNumber = _userData.balance.cakeAsBigNumber;
    var ref3 = useVaultApy(), getLockedApy = ref3.getLockedApy, flexibleApy = ref3.flexibleApy;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref4 = (0,react.useState)(initialView || 0), cakeVaultView = ref4[0], setCakeVaultView = ref4[1];
    var ref5 = (0,react.useState)(function() {
        return weeksToSeconds(1);
    }), duration = ref5[0], setDuration = ref5[1];
    var buttonMenuItems = (0,react.useMemo)(function() {
        return [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                children: t("Flexible")
            }, "Flexible"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                children: t("Locked")
            }, "Locked"), 
        ];
    }, [
        t
    ]);
    var apy = (0,react.useMemo)(function() {
        return cakeVaultView === 0 ? flexibleApy : getLockedApy(duration);
    }, [
        cakeVaultView,
        getLockedApy,
        flexibleApy,
        duration
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        stakingTokenSymbol: pool.stakingToken.symbol,
        apy: +apy,
        initialState: {
            controls: {
                compounding: false
            }
        },
        linkHref: "/swap",
        linkLabel: t("Get %symbol%", {
            symbol: pool.stakingToken.symbol
        }),
        earningTokenPrice: pool.earningTokenPrice,
        stakingTokenPrice: pool.stakingTokenPrice,
        stakingTokenBalance: ((ref = pool.userData) === null || ref === void 0 ? void 0 : ref.stakingTokenBalance) ? cakeAsBigNumber.plus((ref1 = pool.userData) === null || ref1 === void 0 ? void 0 : ref1.stakingTokenBalance) : cakeAsBigNumber,
        autoCompoundFrequency: 1,
        strategy: cakeVaultView ? function(state, dispatch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedRoiStrategy, {
                state: state,
                dispatch: dispatch,
                stakingTokenPrice: pool.stakingTokenPrice,
                earningTokenPrice: pool.earningTokenPrice,
                duration: duration
            });
        } : null,
        header: pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenu/* default */.Z, {
            mb: "24px",
            fullWidth: true,
            scale: "sm",
            variant: "subtle",
            activeIndex: cakeVaultView,
            onItemClick: setCakeVaultView,
            children: buttonMenuItems
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    }, rest), {
        children: cakeVaultView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mt: "16px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockDurationField, {
                duration: duration,
                setDuration: setDuration,
                isOverMax: false
            })
        })
    }));
};

function LockedRoiStrategy(param) {
    var state = param.state, dispatch = param.dispatch, earningTokenPrice = param.earningTokenPrice, duration = param.duration, stakingTokenPrice = param.stakingTokenPrice;
    var getLockedApy = useVaultApy().getLockedApy;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, roiUSD = _data.roiUSD;
    var _controls = state.controls, compounding = _controls.compounding, compoundingFrequency = _controls.compoundingFrequency, stakingDuration = _controls.stakingDuration, mode = _controls.mode;
    (0,react.useEffect)(function() {
        if (mode === useRoiCalculatorReducer/* CalculatorMode.ROI_BASED_ON_PRINCIPAL */.ee.ROI_BASED_ON_PRINCIPAL) {
            var principalInUSDAsNumber = parseFloat(principalAsUSD);
            var interest = principalInUSDAsNumber / earningTokenPrice * (+getLockedApy(duration) / 100) * (duration / 31449600);
            var hasInterest = !Number.isNaN(interest);
            var roiTokens = hasInterest ? interest : 0;
            var roiAsUSD = hasInterest ? roiTokens * earningTokenPrice : 0;
            var roiPercentage = hasInterest ? (0,compoundApyHelpers/* getRoi */.Lu)({
                amountEarned: roiAsUSD,
                amountInvested: principalInUSDAsNumber
            }) : 0;
            dispatch({
                type: "setRoi",
                payload: {
                    roiUSD: roiAsUSD,
                    roiTokens: roiTokens,
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        principalAsUSD,
        stakingDuration,
        earningTokenPrice,
        compounding,
        compoundingFrequency,
        mode,
        duration,
        dispatch,
        getLockedApy, 
    ]);
    (0,react.useEffect)(function() {
        if (mode === useRoiCalculatorReducer/* CalculatorMode.PRINCIPAL_BASED_ON_ROI */.ee.PRINCIPAL_BASED_ON_ROI) {
            var principalUSD = roiUSD / (+getLockedApy(duration) / 100) / (duration / 31449600);
            var roiPercentage = (0,compoundApyHelpers/* getRoi */.Lu)({
                amountEarned: roiUSD,
                amountInvested: principalUSD
            });
            var principalToken = principalUSD / stakingTokenPrice;
            dispatch({
                type: "setPrincipalForTargetRoi",
                payload: {
                    principalAsUSD: principalUSD.toFixed(2),
                    principalAsToken: principalToken.toFixed(10),
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        dispatch,
        duration,
        getLockedApy,
        mode,
        roiUSD,
        stakingTokenPrice
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/StakingApy.tsx


function StakingApy_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    StakingApy_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var StakingApy_AprLabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a5065958-0"
})(StakingApy_templateObject());
var StakingApy = /*#__PURE__*/ (0,react.memo)(function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useVaultApy(), flexibleApy = ref.flexibleApy, lockedApy = ref.lockedApy;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
        pool: pool
    })), 1), onPresentFlexibleApyModal = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
        pool: pool,
        initialView: 1
    })), 1), onPresentLockedApyModal = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Card/* LightGreyCard */.m5, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: [
                            t("Flexible"),
                            " APY:"
                        ]
                    }),
                    flexibleApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StakingApy_AprLabelContainer, {
                        alignItems: "center",
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                fontSize: "16px",
                                value: parseFloat(flexibleApy),
                                decimals: 2,
                                unit: "%",
                                bold: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function(e) {
                                    e.stopPropagation();
                                    onPresentFlexibleApyModal();
                                },
                                variant: "text",
                                width: "20px",
                                height: "20px",
                                padding: "0px",
                                marginLeft: "4px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                    color: "textSubtle",
                                    width: "20px"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "80px",
                        height: "16px"
                    })
                ]
            }),
            pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: [
                            t("Locked"),
                            " APY:"
                        ]
                    }),
                    lockedApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                        gap: "4px",
                        flexWrap: "wrap",
                        justifyContent: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                style: {
                                    whiteSpace: "nowrap"
                                },
                                bold: true,
                                children: t("Up to")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StakingApy_AprLabelContainer, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                        fontSize: "16px",
                                        value: parseFloat(lockedApy),
                                        decimals: 2,
                                        unit: "%",
                                        bold: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            onPresentLockedApyModal();
                                        },
                                        variant: "text",
                                        width: "20px",
                                        height: "20px",
                                        padding: "0px",
                                        marginLeft: "4px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                            color: "textSubtle",
                                            width: "20px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "80px",
                        height: "16px"
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/VaultApprovalAction.tsx




var VaultApprovalAction = function(param) {
    var vaultKey = param.vaultKey, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, setLastUpdated = param.setLastUpdated;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useVaultApprove(vaultKey, setLastUpdated), handleApprove = ref.handleApprove, pendingTx = ref.pendingTx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: pendingTx,
            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                spin: true,
                color: "currentColor"
            }) : null,
            disabled: pendingTx,
            onClick: handleApprove,
            width: "100%",
            children: t("Enable")
        })
    });
};
/* harmony default export */ var VaultCardActions_VaultApprovalAction = (VaultApprovalAction);

;// CONCATENATED MODULE: ./src/views/Pools/components/Vault/VaultStakeButtonGroup.tsx




var VaultStakeButtonGroup = function(param) {
    var onFlexibleClick = param.onFlexibleClick, onLockedClick = param.onLockedClick;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: t("Flexible staking offers flexibility for staking/unstaking whenever you want. Locked staking offers higher APY as well as other benefits.")
    }), {}), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                gap: "12px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        style: {
                            flex: 1
                        },
                        onClick: onFlexibleClick,
                        children: t("Flexible")
                    }),
                    onLockedClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        style: {
                            flex: 1
                        },
                        onClick: onLockedClick,
                        children: t("Locked")
                    })
                ]
            }),
            tooltipVisible && tooltip,
            onLockedClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                mt: "16px",
                small: true,
                ref: targetRef,
                children: t("What\u2019s the difference?")
            })
        ]
    });
};

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpointsContext.ts
var useMatchBreakpointsContext = __webpack_require__(98946);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
;// CONCATENATED MODULE: ./src/components/Divider/index.tsx

function Divider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  width: 100%;\n"
    ]);
    Divider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-d9299de2-0"
})(Divider_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
/* harmony default export */ var components_Divider = (Divider);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/StaticAmount.tsx





var StaticAmount = function(param) {
    var stakingSymbol = param.stakingSymbol, stakingAddress = param.stakingAddress, lockedAmount = param.lockedAmount, usdValueStaked = param.usdValueStaked;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: t("Add BNOU to lock")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                color: "text",
                                bold: true,
                                fontSize: "16px",
                                value: lockedAmount,
                                decimals: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                value: usdValueStaked,
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                prefix: "~",
                                unit: " USD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingAddress, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingSymbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {})
        ]
    });
};
/* harmony default export */ var Common_StaticAmount = (StaticAmount);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/isUndefinedOrNull.ts
var isUndefinedOrNull = __webpack_require__(12157);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/CrossText.tsx

function CrossText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: line-through;\n"
    ]);
    CrossText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CrossText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4b9cfd09-0"
})(CrossText_templateObject());
/* harmony default export */ var Overview_CrossText = (CrossText);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/TextRow.tsx




var DiffText = function(param) {
    var value = param.value, newValue = param.newValue;
    if ((0,isUndefinedOrNull/* default */.Z)(newValue) || (0,isUndefinedOrNull/* default */.Z)(value) || value === newValue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            bold: true,
            fontSize: "16px",
            children: value || "-"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_CrossText, {
                bold: true,
                fontSize: "16px",
                mr: "4px",
                children: value
            }),
            "->",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                color: "failure",
                ml: "4px",
                fontSize: "16px",
                children: newValue
            })
        ]
    });
};
var TextRow = function(param) {
    var title = param.title, value = param.value, newValue = param.newValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiffText, {
                    value: value,
                    newValue: newValue
                })
            })
        ]
    });
};
/* harmony default export */ var Overview_TextRow = (TextRow);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/BalanceRow.tsx







var DiffBalance = function(param) {
    var value = param.value, newValue = param.newValue, decimals = param.decimals, unit = param.unit, prefix = param.prefix;
    if ((0,isUndefinedOrNull/* default */.Z)(newValue) || !value || value === newValue || toNumber_default()(newValue) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
            bold: true,
            fontSize: "16px",
            value: value,
            decimals: decimals,
            unit: unit,
            prefix: prefix
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_CrossText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                    bold: true,
                    fontSize: "16px",
                    mr: "4px",
                    value: value,
                    decimals: decimals,
                    unit: unit,
                    prefix: prefix
                })
            }),
            "->",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                bold: true,
                color: "failure",
                fontSize: "16px",
                ml: "4px",
                value: newValue,
                decimals: decimals,
                unit: unit,
                prefix: prefix
            })
        ]
    });
};
var BalanceRow = function(param) {
    var title = param.title, value = param.value, newValue = param.newValue, unit = param.unit, decimals = param.decimals, prefix = param.prefix, suffix = param.suffix, tooltipContent = param.tooltipContent;
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            tooltipContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    textTransform: "uppercase",
                    bold: true,
                    fontSize: "12px",
                    children: title
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiffBalance, {
                        newValue: newValue,
                        value: value,
                        decimals: decimals,
                        unit: unit,
                        prefix: prefix
                    }),
                    suffix
                ]
            })
        ]
    });
};
/* harmony default export */ var Overview_BalanceRow = (/*#__PURE__*/(0,react.memo)(BalanceRow));

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 17 modules
var format = __webpack_require__(87344);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/DateRow.tsx




var DateRow = function(param) {
    var title = param.title, value = param.value, color = param.color;
    var t = (0,src/* useTranslation */.$G)().t;
    var tooltipContent = t("You will be able to withdraw the staked BNOU and profit only when the staking position is unlocked, i.e. when the staking period ends.");
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    textTransform: "uppercase",
                    bold: true,
                    fontSize: "12px",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                color: color,
                children: value ? (0,format/* default */.Z)(value, "MMM do, yyyy HH:mm") : "-"
            })
        ]
    });
};
/* harmony default export */ var Overview_DateRow = (DateRow);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/utils/formatRoi.ts
function formatRoi(roiArgs) {
    var lockedApy = roiArgs.lockedApy, usdValueStaked = roiArgs.usdValueStaked, duration = roiArgs.duration;
    var roi = usdValueStaked * (Number(lockedApy) / 100) * (duration / 31449600);
    var roiFractionDigits = roi > 10000 ? 0 : 2;
    return roi.toLocaleString("en", {
        minimumFractionDigits: roiFractionDigits,
        maximumFractionDigits: roiFractionDigits
    });
};

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/utils/formatICake.ts

function formatiCake(param) {
    var lockedAmount = param.lockedAmount, duration = param.duration, ceiling = param.ceiling;
    var durationAsBn = new (bignumber_default())(duration);
    if (durationAsBn.gte(ceiling)) {
        return new (bignumber_default())(lockedAmount).toNumber();
    }
    if (durationAsBn.lt(ceiling) && durationAsBn.gte(0)) {
        return durationAsBn.times(lockedAmount).div(ceiling).toNumber();
    }
    return 0;
};

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Modals/RoiCalculatorModalProvider.tsx






var RoiCalculatorModalContext = /*#__PURE__*/ (0,react.createContext)(null);
var RoiCalculatorModalProvider = function(param) {
    var children = param.children, lockedAmount = param.lockedAmount;
    var ref;
    var ref1 = (0,react.useState)(false), showRoiCalculator = ref1[0], setShowRoiCalculator = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    // Get Vault pool
    var pool = usePool(0).pool;
    var stakingTokenAddress = (pool === null || pool === void 0 ? void 0 : (ref = pool.stakingToken) === null || ref === void 0 ? void 0 : ref.address) ? pool.stakingToken.address.toLowerCase() : null;
    if (showRoiCalculator) {
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
            pool: pool,
            linkLabel: t("Get %symbol%", {
                symbol: "BNOU"
            }),
            linkHref: stakingTokenAddress ? "/swap?outputCurrency=".concat(stakingTokenAddress) : "/swap",
            stakingTokenBalance: pool === null || pool === void 0 ? void 0 : (ref2 = pool.userData) === null || ref2 === void 0 ? void 0 : ref2.stakingTokenBalance,
            onBack: function() {
                return setShowRoiCalculator(false);
            },
            initialValue: toString_default()(lockedAmount),
            initialView: 1
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModalContext.Provider, {
        value: setShowRoiCalculator,
        children: children
    });
};
/* harmony default export */ var Modals_RoiCalculatorModalProvider = (RoiCalculatorModalProvider);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/CalculatorButton.tsx




var CalculatorButton = function() {
    var setShowRoiCalculator = (0,react.useContext)(RoiCalculatorModalContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        variant: "text",
        scale: "sm",
        mr: "-8px",
        onClick: function() {
            return setShowRoiCalculator && setShowRoiCalculator(true);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
            color: "textSubtle",
            width: "18px"
        })
    });
};
/* harmony default export */ var Buttons_CalculatorButton = (CalculatorButton);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/index.tsx
















var Overview = function(param) {
    var usdValueStaked = param.usdValueStaked, lockedAmount = param.lockedAmount, duration = param.duration, isValidDuration = param.isValidDuration, newDuration = param.newDuration, newLockedAmount = param.newLockedAmount, lockStartTime = param.lockStartTime, lockEndTime = param.lockEndTime, showLockWarning = param.showLockWarning, ceiling = param.ceiling;
    var ref = useVaultApy(), getLockedApy = ref.getLockedApy, getBoostFactor = ref.getBoostFactor;
    var t = (0,src/* useTranslation */.$G)().t;
    var lockedApy = (0,react.useMemo)(function() {
        return getLockedApy(duration);
    }, [
        getLockedApy,
        duration
    ]);
    var boostFactor = (0,react.useMemo)(function() {
        return getBoostFactor(duration);
    }, [
        getBoostFactor,
        duration
    ]);
    var newLockedApy = (0,react.useMemo)(function() {
        return newDuration && getLockedApy(newDuration) || 0;
    }, [
        getLockedApy,
        newDuration
    ]);
    var newBoost = (0,react.useMemo)(function() {
        return newDuration && getBoostFactor(newDuration) || 0;
    }, [
        getBoostFactor,
        newDuration
    ]);
    var formattedRoi = (0,react.useMemo)(function() {
        return formatRoi({
            usdValueStaked: usdValueStaked,
            lockedApy: lockedApy,
            duration: duration
        });
    }, [
        lockedApy,
        usdValueStaked,
        duration
    ]);
    var newFormattedRoi = (0,react.useMemo)(function() {
        return newLockedApy && formatRoi({
            usdValueStaked: usdValueStaked,
            lockedApy: newLockedApy,
            duration: newDuration
        });
    }, [
        newLockedApy,
        usdValueStaked,
        newDuration
    ]);
    var now = new Date();
    var unlockDate = newDuration ? (0,addSeconds/* default */.Z)(Number(lockStartTime) ? new Date(convertTimeToSeconds(lockStartTime)) : now, newDuration) : Number(lockEndTime) ? new Date(convertTimeToSeconds(lockEndTime)) : (0,addSeconds/* default */.Z)(now, duration);
    var formattediCake = (0,react.useMemo)(function() {
        return formatiCake({
            lockedAmount: lockedAmount,
            duration: duration,
            ceiling: ceiling
        });
    }, [
        lockedAmount,
        duration,
        ceiling
    ]);
    var newFormattediCake = (0,react.useMemo)(function() {
        var amount = Number(newLockedAmount) ? newLockedAmount : lockedAmount;
        var lockDuration = Number(newDuration) ? newDuration : duration;
        return formatiCake({
            lockedAmount: amount,
            duration: lockDuration,
            ceiling: ceiling
        });
    }, [
        lockedAmount,
        newLockedAmount,
        duration,
        newDuration,
        ceiling
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "secondary",
                                bold: true,
                                mr: "2px",
                                textTransform: "uppercase",
                                children: t("Lock")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Overview")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Card/* LightGreyCard */.m5, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: t("Bnou to be locked"),
                                value: lockedAmount,
                                newValue: newLockedAmount,
                                decimals: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: "iBnou",
                                decimals: 2,
                                value: formattediCake,
                                newValue: newFormattediCake
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: "apy",
                                unit: "%",
                                value: toNumber_default()(lockedApy),
                                decimals: 2,
                                newValue: toNumber_default()(newLockedApy),
                                tooltipContent: t("Calculated based on current rates and subject to change based on pool conditions. It is an estimate provided for your convenience only, and by no means represents guaranteed returns.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_TextRow, {
                                title: t("duration"),
                                value: isValidDuration && utils_formatSecondsToWeeks(duration),
                                newValue: isValidDuration && newDuration && utils_formatSecondsToWeeks(newDuration)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: t("Yield boost"),
                                unit: "x",
                                value: toNumber_default()(boostFactor),
                                decimals: 2,
                                newValue: toNumber_default()(newBoost),
                                tooltipContent: t("Your yield will be boosted based on the total lock duration of your current fixed term staking position.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_DateRow, {
                                color: toNumber_default()(newDuration) ? "failure" : "text",
                                title: t("Unlock on"),
                                value: isValidDuration && unlockDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: t("Expected ROI"),
                                value: formattedRoi,
                                newValue: newFormattedRoi,
                                prefix: "$",
                                decimals: 2,
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_CalculatorButton, {}),
                                tooltipContent: t("Calculated based on current rates and subject to change based on pool conditions. It is an estimate provided for your convenience only, and by no means represents guaranteed returns.")
                            })
                        ]
                    })
                ]
            }),
            showLockWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: "16px",
                maxWidth: "370px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                    variant: "warning",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                        children: t("You will be able to withdraw the staked BNOU and profit only when the staking position is unlocked")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Common_Overview = (Overview);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useLockedPool.tsx


















function useLockedPool(hookArgs) {
    var lockedAmount = hookArgs.lockedAmount, stakingToken = hookArgs.stakingToken, onDismiss = hookArgs.onDismiss, prepConfirmArg = hookArgs.prepConfirmArg;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)(types/* VaultKey.CakeVault */.om.CakeVault);
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref1 = (0,react.useState)(pools/* ONE_WEEK_DEFAULT */.kp), duration = ref1[0], setDuration = ref1[1];
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(lockedAmount.toNumber());
    var handleDeposit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(convertedStakeAmount, lockDuration) {
            var callOptions, receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        callOptions = {
                            gasLimit: pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].gasLimit
                        };
                        _ctx.next = 3;
                        return fetchWithCatchTxError(function() {
                            // .toString() being called to fix a BigNumber error in prod
                            // as suggested here https://github.com/ChainSafe/web3.js/issues/2077
                            var methodArgs = [
                                convertedStakeAmount.toString(),
                                lockDuration
                            ];
                            return callWithGasPrice(vaultPoolContract, "deposit", methodArgs, callOptions);
                        });
                    case 3:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Staked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the pool")
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                                account: account
                            }));
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(convertedStakeAmount, lockDuration) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetchWithCatchTxError,
        toastSuccess,
        dispatch,
        onDismiss,
        account,
        vaultPoolContract,
        t,
        callWithGasPrice
    ]);
    var handleConfirmClick = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, _finalLockedAmount, finalLockedAmount, _finalDuration, finalDuration, convertedStakeAmount;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = typeof prepConfirmArg === "function" ? prepConfirmArg({
                        duration: duration
                    }) : {}, _finalLockedAmount = ref.finalLockedAmount, finalLockedAmount = _finalLockedAmount === void 0 ? lockedAmount : _finalLockedAmount, _finalDuration = ref.finalDuration, finalDuration = _finalDuration === void 0 ? duration : _finalDuration;
                    convertedStakeAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new (bignumber_default())(finalLockedAmount), stakingToken.decimals);
                    handleDeposit(convertedStakeAmount, finalDuration);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        prepConfirmArg,
        stakingToken,
        handleDeposit,
        duration,
        lockedAmount
    ]);
    return {
        usdValueStaked: usdValueStaked,
        duration: duration,
        setDuration: setDuration,
        pendingTx: pendingTx,
        handleConfirmClick: handleConfirmClick
    };
};

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/LockedModalBody.tsx













var ExtendEnable = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(561), __webpack_require__.e(1341)]).then(__webpack_require__.bind(__webpack_require__, 1341));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1341)
            ];
        }
    },
    ssr: false
});
var LockedModalBody = function(param) {
    var stakingToken = param.stakingToken, onDismiss = param.onDismiss, lockedAmount = param.lockedAmount, currentBalance = param.currentBalance, currentDuration = param.currentDuration, currentDurationLeft = param.currentDurationLeft, editAmountOnly = param.editAmountOnly, prepConfirmArg = param.prepConfirmArg, validator = param.validator, customOverview = param.customOverview;
    var t = (0,src/* useTranslation */.$G)().t;
    var ceiling = useIfoCeiling();
    var ref = useLockedPool({
        stakingToken: stakingToken,
        onDismiss: onDismiss,
        lockedAmount: lockedAmount,
        prepConfirmArg: prepConfirmArg
    }), usdValueStaked = ref.usdValueStaked, duration = ref.duration, setDuration = ref.setDuration, pendingTx = ref.pendingTx, handleConfirmClick = ref.handleConfirmClick;
    var ref1 = (0,react.useMemo)(function() {
        return typeof validator === "function" ? validator({
            duration: duration
        }) : {
            isValidAmount: (lockedAmount === null || lockedAmount === void 0 ? void 0 : lockedAmount.toNumber()) > 0 && (0,formatBalance/* getBalanceAmount */.U4)(currentBalance).gte(lockedAmount),
            isValidDuration: duration > 0 && duration <= pools/* MAX_LOCK_DURATION */.VO,
            isOverMax: duration > pools/* MAX_LOCK_DURATION */.VO
        };
    }, [
        validator,
        currentBalance,
        lockedAmount,
        duration
    ]), isValidAmount = ref1.isValidAmount, isValidDuration = ref1.isValidDuration, isOverMax = ref1.isOverMax;
    var cakeNeeded = (0,react.useMemo)(function() {
        return isValidDuration && currentDuration && currentDuration + duration > pools/* MAX_LOCK_DURATION */.VO;
    }, [
        isValidDuration,
        currentDuration,
        duration
    ]);
    var hasEnoughBalanceToExtend = (0,react.useMemo)(function() {
        return currentBalance === null || currentBalance === void 0 ? void 0 : currentBalance.gte(Pools_helpers/* ENABLE_EXTEND_LOCK_AMOUNT */.iL);
    }, [
        currentBalance
    ]);
    var needsEnable = (0,react.useMemo)(function() {
        return cakeNeeded && !hasEnoughBalanceToExtend;
    }, [
        cakeNeeded,
        hasEnoughBalanceToExtend
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "16px",
                children: editAmountOnly || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockDurationField, {
                        isOverMax: isOverMax,
                        currentDuration: currentDuration,
                        currentDurationLeft: currentDurationLeft,
                        setDuration: setDuration,
                        duration: duration
                    })
                })
            }),
            customOverview ? customOverview({
                isValidDuration: isValidDuration,
                duration: duration
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Overview, {
                isValidDuration: isValidDuration,
                openCalculator: (noop_default()),
                duration: duration,
                lockedAmount: lockedAmount === null || lockedAmount === void 0 ? void 0 : lockedAmount.toNumber(),
                usdValueStaked: usdValueStaked,
                showLockWarning: true,
                ceiling: ceiling
            }),
            cakeNeeded ? hasEnoughBalanceToExtend ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "12px",
                mt: "24px",
                children: t("0.0001 BNOU will be spent to extend")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    maxWidth: "200px",
                    children: t("0.0001 BNOU required for enabling extension")
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mt: "24px",
                children: needsEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendEnable, {
                    isValidAmount: isValidAmount,
                    isValidDuration: isValidDuration
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    width: "100%",
                    isLoading: pendingTx,
                    endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }) : null,
                    onClick: handleConfirmClick,
                    disabled: !(isValidAmount && isValidDuration),
                    children: pendingTx ? t("Confirming") : t("Confirm")
                })
            })
        ]
    });
};
/* harmony default export */ var Common_LockedModalBody = (LockedModalBody);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Modals/ExtendDurationModal.tsx
















var ExtendDurationModal = function(param) {
    var modalTitle = param.modalTitle, stakingToken = param.stakingToken, onDismiss = param.onDismiss, currentLockedAmount = param.currentLockedAmount, currentDuration = param.currentDuration, currentDurationLeft = param.currentDurationLeft, currentBalance = param.currentBalance, lockStartTime = param.lockStartTime;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ceiling = useIfoCeiling();
    var t = (0,src/* useTranslation */.$G)().t;
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(currentLockedAmount);
    var validator = (0,react.useCallback)(function(param) {
        var duration = param.duration;
        var isValidAmount = currentLockedAmount && currentLockedAmount > 0;
        var totalDuration = currentDurationLeft + duration;
        var isValidDuration = duration > 0 && totalDuration > 0 && totalDuration <= pools/* MAX_LOCK_DURATION */.VO;
        return {
            isValidAmount: isValidAmount,
            isValidDuration: isValidDuration,
            isOverMax: totalDuration > pools/* MAX_LOCK_DURATION */.VO
        };
    }, [
        currentLockedAmount,
        currentDurationLeft
    ]);
    var prepConfirmArg = (0,react.useCallback)(function(param) {
        var duration = param.duration;
        return {
            finalDuration: duration,
            finalLockedAmount: currentDuration && currentDuration + duration > pools/* MAX_LOCK_DURATION */.VO ? (0,formatBalance/* getBalanceAmount */.U4)(Pools_helpers/* ENABLE_EXTEND_LOCK_AMOUNT */.iL, stakingToken.decimals).toNumber() : 0
        };
    }, [
        stakingToken.decimals,
        currentDuration
    ]);
    var customOverview = (0,react.useCallback)(function(param) {
        var isValidDuration = param.isValidDuration, duration = param.duration;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Overview, {
            lockStartTime: currentDuration + duration > pools/* MAX_LOCK_DURATION */.VO ? Math.floor(Date.now() / 1000).toString() : lockStartTime,
            isValidDuration: isValidDuration,
            openCalculator: (noop_default()),
            duration: currentDuration || duration,
            newDuration: currentDuration + duration > pools/* MAX_LOCK_DURATION */.VO ? currentDurationLeft + duration : currentDuration + duration,
            lockedAmount: currentLockedAmount,
            usdValueStaked: usdValueStaked,
            showLockWarning: !+lockStartTime,
            ceiling: ceiling
        });
    }, [
        lockStartTime,
        currentDuration,
        currentLockedAmount,
        currentDurationLeft,
        usdValueStaked,
        ceiling
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_RoiCalculatorModalProvider, {
        lockedAmount: currentLockedAmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            title: modalTitle || t("Extend Lock"),
            onDismiss: onDismiss,
            headerBackground: theme.colors.gradients.cardHeader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_StaticAmount, {
                        stakingAddress: stakingToken.address,
                        stakingSymbol: stakingToken.symbol,
                        lockedAmount: currentLockedAmount,
                        usdValueStaked: usdValueStaked
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockedModalBody, {
                    stakingToken: stakingToken,
                    currentBalance: currentBalance,
                    currentDuration: currentDuration,
                    currentDurationLeft: currentDurationLeft,
                    onDismiss: onDismiss,
                    lockedAmount: new (bignumber_default())(currentLockedAmount),
                    validator: validator,
                    prepConfirmArg: prepConfirmArg,
                    customOverview: customOverview
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_ExtendDurationModal = (ExtendDurationModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/ExtendDurationButton.tsx









var ExtendDurationButton = function(_param) {
    var modalTitle = _param.modalTitle, stakingToken = _param.stakingToken, currentLockedAmount = _param.currentLockedAmount, currentBalance = _param.currentBalance, lockEndTime = _param.lockEndTime, lockStartTime = _param.lockStartTime, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "modalTitle",
        "stakingToken",
        "currentLockedAmount",
        "currentBalance",
        "lockEndTime",
        "lockStartTime",
        "children"
    ]);
    var nowInSeconds = Math.floor(Date.now() / 1000);
    var currentDuration = (0,react.useMemo)(function() {
        return Number(lockEndTime) - Number(lockStartTime);
    }, [
        lockEndTime,
        lockStartTime
    ]);
    var currentDurationLeft = (0,react.useMemo)(function() {
        return Math.max(Number(lockEndTime) - nowInSeconds, 0);
    }, [
        lockEndTime,
        nowInSeconds
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_ExtendDurationModal, {
        modalTitle: modalTitle,
        stakingToken: stakingToken,
        lockStartTime: lockStartTime,
        currentBalance: currentBalance,
        currentLockedAmount: currentLockedAmount,
        currentDuration: currentDuration,
        currentDurationLeft: currentDurationLeft
    }), true, true, "ExtendDurationModal"), 1), openExtendDurationModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disabled: Number.isFinite(currentDurationLeft) && pools/* MAX_LOCK_DURATION */.VO - currentDurationLeft < pools/* ONE_WEEK_DEFAULT */.kp,
        onClick: openExtendDurationModal,
        width: "100%"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var Buttons_ExtendDurationButton = (ExtendDurationButton);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/ConvertToLock.tsx







var ConvertToLock = function(param) {
    var stakingToken = param.stakingToken, currentStakedAmount = param.currentStakedAmount, isInline = param.isInline;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var isTableView = isInline && !isMobile;
    var avgLockDurationsInSeconds = useAvgLockDuration().avgLockDurationsInSeconds;
    var lockedApy = useVaultApy({
        duration: avgLockDurationsInSeconds
    }).lockedApy;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
        variant: "warning",
        action: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            mt: !isTableView && "8px",
            flexGrow: 1,
            ml: isTableView && "80px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_ExtendDurationButton, {
                modalTitle: t("Convert to Lock"),
                lockEndTime: "0",
                lockStartTime: "0",
                stakingToken: stakingToken,
                currentLockedAmount: currentStakedAmount,
                children: t("Convert to Lock")
            })
        }),
        actionInline: isTableView,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
            children: t("Lock staking users are earning an average of %amount%% APY. More benefits are coming soon.", {
                amount: lockedApy ? parseFloat(lockedApy).toFixed(2) : 0
            })
        })
    });
};
/* harmony default export */ var Common_ConvertToLock = (/*#__PURE__*/(0,react.memo)(ConvertToLock));

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/FeeSummary.tsx







var FeeSummary = function(param) {
    var stakingTokenSymbol = param.stakingTokenSymbol, stakeAmount = param.stakeAmount, vaultKey = param.vaultKey;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useVaultPoolByKey(vaultKey), _fees = ref.fees, withdrawalFee = _fees.withdrawalFee, withdrawalFeePeriod = _fees.withdrawalFeePeriod, lastDepositedTime = ref.userData.lastDepositedTime;
    var feeAsDecimal = withdrawalFee / 100;
    var feeInCake = (parseFloat(stakeAmount) * (feeAsDecimal / 100)).toFixed(4);
    var withdrawalDayPeriod = withdrawalFeePeriod ? secondsToDay(withdrawalFeePeriod) : "-";
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Unstaking fee: %fee%%", {
                    fee: feeAsDecimal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Only applies within %num% days of staking. Unstaking after %num% days will not include a fee. Timer resets every time you stake new BNOU in the pool.", {
                    num: withdrawalDayPeriod
                })
            })
        ]
    }), {
        placement: "top-start"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var hasFeeToPay = lastDepositedTime && getHasWithdrawFee(parseInt(lastDepositedTime, 10), withdrawalFeePeriod);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    tooltipVisible && tooltip,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                        ref: targetRef,
                        small: true,
                        children: t("Unstaking Fee")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontSize: "14px",
                        children: [
                            stakeAmount && hasFeeToPay ? feeInCake : "-",
                            " ",
                            stakingTokenSymbol
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_UnstakingFeeCountdownRow, {
                vaultKey: vaultKey
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_FeeSummary = (FeeSummary);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultStakeModal.tsx




function VaultStakeModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    VaultStakeModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VaultStakeModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    VaultStakeModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VaultStakeModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n"
    ]);
    VaultStakeModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




























var VaultStakeModal_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-71194a7d-0"
})(VaultStakeModal_templateObject());
var VaultStakeModal_AnnualRoiContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-71194a7d-1"
})(VaultStakeModal_templateObject1());
var VaultStakeModal_AnnualRoiDisplay = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-71194a7d-2"
})(VaultStakeModal_templateObject2());
var VaultStakeModal = function(param) {
    var pool = param.pool, stakingMax = param.stakingMax, performanceFee = param.performanceFee, _isRemovingStake = param.isRemovingStake, isRemovingStake = _isRemovingStake === void 0 ? false : _isRemovingStake, onDismiss = param.onDismiss;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var stakingToken = pool.stakingToken, earningTokenPrice = pool.earningTokenPrice, vaultKey = pool.vaultKey;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)(pool.vaultKey);
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref1 = useVaultPoolByKey(pool.vaultKey), _userData = ref1.userData, lastDepositedTime = _userData.lastDepositedTime, userShares = _userData.userShares, _balance = _userData.balance, cakeAsBigNumber = _balance.cakeAsBigNumber, cakeAsNumberBalance = _balance.cakeAsNumberBalance;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref2 = (0,react.useState)(""), stakeAmount = ref2[0], setStakeAmount = ref2[1];
    var ref3 = (0,react.useState)(0), percent = ref3[0], setPercent = ref3[1];
    var ref4 = (0,react.useState)(false), showRoiCalculator = ref4[0], setShowRoiCalculator = ref4[1];
    var hasUnstakingFee = hooks_useWithdrawalFeeTimer(parseInt(lastDepositedTime, 10), userShares).hasUnstakingFee;
    var cakePriceBusd = (0,farms_hooks/* usePriceCakeBusd */.Iu)();
    var usdValueStaked = new (bignumber_default())(stakeAmount).times(cakePriceBusd);
    var formattedUsdValueStaked = cakePriceBusd.gt(0) && stakeAmount ? (0,formatBalance/* formatNumber */.uf)(usdValueStaked.toNumber()) : "";
    var flexibleApy = useVaultApy().flexibleApy;
    var callOptions = {
        gasLimit: pools/* vaultPoolConfig */.Y4[pool.vaultKey].gasLimit
    };
    var interestBreakdown = (0,compoundApyHelpers/* getInterestBreakdown */.A1)({
        principalInUSD: !usdValueStaked.isNaN() ? usdValueStaked.toNumber() : 0,
        apr: +flexibleApy,
        earningTokenPrice: earningTokenPrice,
        performanceFee: performanceFee,
        compoundFrequency: 0
    });
    var annualRoi = interestBreakdown[3] * pool.earningTokenPrice;
    var formattedAnnualRoi = (0,formatBalance/* formatNumber */.uf)(annualRoi, annualRoi > 10000 ? 0 : 2, annualRoi > 10000 ? 0 : 2);
    var getTokenLink = stakingToken.address ? "/swap?outputCurrency=".concat(stakingToken.address) : "/swap";
    var convertedStakeAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new (bignumber_default())(stakeAmount), stakingToken.decimals);
    var handleStakeInputChange = function(input) {
        if (input) {
            var convertedInput = new (bignumber_default())(input).multipliedBy((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(stakingToken.decimals));
            var percentage = Math.floor(convertedInput.dividedBy(stakingMax).multipliedBy(100).toNumber());
            setPercent(percentage > 100 ? 100 : percentage);
        } else {
            setPercent(0);
        }
        setStakeAmount(input);
    };
    var handleChangePercent = (0,react.useCallback)(function(sliderPercent) {
        if (sliderPercent > 0) {
            var percentageOfStakingMax = stakingMax.dividedBy(100).multipliedBy(sliderPercent);
            var amountToStake = (0,formatBalance/* getFullDisplayBalance */.NJ)(percentageOfStakingMax, stakingToken.decimals, stakingToken.decimals);
            setStakeAmount(amountToStake);
        } else {
            setStakeAmount("");
        }
        setPercent(sliderPercent);
    }, [
        stakingMax,
        stakingToken.decimals
    ]);
    var handleWithdrawal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isWithdrawingAll, receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isWithdrawingAll = stakingMax.minus(convertedStakeAmount).lte(Pools_helpers/* MIN_LOCK_AMOUNT */.dF);
                        _ctx.next = 3;
                        return fetchWithCatchTxError(function() {
                            // .toString() being called to fix a BigNumber error in prod
                            // as suggested here https://github.com/ChainSafe/web3.js/issues/2077
                            return isWithdrawingAll ? callWithGasPrice(vaultPoolContract, "withdrawAll", undefined, callOptions) : callWithGasPrice(vaultPoolContract, "withdraw", [
                                convertedStakeAmount.toString()
                            ], callOptions);
                        });
                    case 3:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Unstaked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                                account: account
                            }));
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleWithdrawal() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeposit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var lockDuration, receipt, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        lockDuration = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 0;
                        _ctx.next = 3;
                        return fetchWithCatchTxError(function() {
                            // .toString() being called to fix a BigNumber error in prod
                            // as suggested here https://github.com/ChainSafe/web3.js/issues/2077
                            var extraArgs = pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? [
                                lockDuration.toString()
                            ] : [];
                            var methodArgs = [
                                convertedStakeAmount.toString()
                            ].concat((0,_to_consumable_array/* default */.Z)(extraArgs));
                            return callWithGasPrice(vaultPoolContract, "deposit", methodArgs, callOptions);
                        });
                    case 3:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Staked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the pool")
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                                account: account
                            }));
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeposit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isRemovingStake) {
                            // unstaking
                            handleWithdrawal();
                        } else {
                            // staking
                            handleDeposit();
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
            pool: pool,
            linkLabel: t("Get %symbol%", {
                symbol: stakingToken.symbol
            }),
            linkHref: getTokenLink,
            stakingTokenBalance: cakeAsBigNumber.plus(stakingMax),
            onBack: function() {
                return setShowRoiCalculator(false);
            },
            initialValue: stakeAmount,
            performanceFee: performanceFee
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: isRemovingStake ? t("Unstake xxx") : t("Stake in Pool"),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        children: [
                            isRemovingStake ? t("Unstake") : t("Stake"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingToken.address, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingToken.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingToken.symbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                value: stakeAmount,
                onUserInput: handleStakeInputChange,
                currencyValue: cakePriceBusd.gt(0) && "~".concat(formattedUsdValueStaked || 0, " USD"),
                decimals: stakingToken.decimals
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "8px",
                ml: "auto",
                color: "textSubtle",
                fontSize: "12px",
                mb: "8px",
                children: t("Balance: %balance%", {
                    balance: (0,formatBalance/* getFullDisplayBalance */.NJ)(stakingMax, stakingToken.decimals)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                min: 0,
                max: 100,
                value: percent,
                onValueChanged: handleChangePercent,
                name: "stake",
                valueLabel: "".concat(percent, "%"),
                step: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mt: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(25);
                        },
                        children: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(50);
                        },
                        children: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(75);
                        },
                        children: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(100);
                        },
                        children: t("Max")
                    })
                ]
            }),
            isRemovingStake && hasUnstakingFee && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_FeeSummary, {
                vaultKey: vaultKey,
                stakingTokenSymbol: stakingToken.symbol,
                stakeAmount: stakeAmount
            }),
            !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        mr: "8px",
                        color: "textSubtle",
                        children: [
                            t("Annual ROI at current rates"),
                            ":"
                        ]
                    }),
                    Number.isFinite(annualRoi) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(VaultStakeModal_AnnualRoiContainer, {
                        alignItems: "center",
                        onClick: function() {
                            setShowRoiCalculator(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VaultStakeModal_AnnualRoiDisplay, {
                                children: [
                                    "$",
                                    formattedAnnualRoi
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "text",
                                scale: "sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                    color: "textSubtle",
                                    width: "18px"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 60
                    })
                ]
            }),
            pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && cakeAsNumberBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: "8px",
                maxWidth: "370px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_ConvertToLock, {
                    stakingToken: stakingToken,
                    currentStakedAmount: cakeAsNumberBalance
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                isLoading: pendingTx,
                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "currentColor"
                }) : null,
                onClick: handleConfirmClick,
                disabled: !stakeAmount || parseFloat(stakeAmount) === 0 || stakingMax.lt(convertedStakeAmount),
                mt: "24px",
                children: pendingTx ? t("Confirming") : t("Confirm")
            }),
            !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mt: "8px",
                as: "a",
                external: true,
                href: getTokenLink,
                variant: "secondary",
                children: t("Get %symbol%", {
                    symbol: stakingToken.symbol
                })
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_VaultStakeModal = (VaultStakeModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useUserEnoughCakeValidator.ts




var useUserEnoughCakeValidator = function(cakeAmount, stakingTokenBalance) {
    var t = (0,src/* useTranslation */.$G)().t;
    var errorMessage = t("Insufficient BNOU balance");
    var userNotEnoughCake = (0,react.useMemo)(function() {
        if (new (bignumber_default())(cakeAmount).gt((0,formatBalance/* getBalanceAmount */.U4)(stakingTokenBalance, 18))) return true;
        return false;
    }, [
        cakeAmount,
        stakingTokenBalance
    ]);
    return {
        userNotEnoughCake: userNotEnoughCake,
        notEnoughErrorMessage: errorMessage
    };
};

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/BalanceField.tsx

function BalanceField_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    BalanceField_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var BalanceField_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-88fad77a-0"
})(BalanceField_templateObject());
var BalanceField = function(param) {
    var stakingAddress = param.stakingAddress, stakingSymbol = param.stakingSymbol, stakingDecimals = param.stakingDecimals, lockedAmount = param.lockedAmount, stakingMax = param.stakingMax, setLockedAmount = param.setLockedAmount, usedValueStaked = param.usedValueStaked, stakingTokenBalance = param.stakingTokenBalance;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useUserEnoughCakeValidator(lockedAmount, stakingTokenBalance), userNotEnoughCake = ref.userNotEnoughCake, notEnoughErrorMessage = ref.notEnoughErrorMessage;
    var percent = (0,react.useMemo)(function() {
        var amount = new (bignumber_default())(lockedAmount);
        if (amount.gt(0)) {
            var convertedInput = amount.multipliedBy((0,getFullDecimalMultiplier/* getFullDecimalMultiplier */.t)(stakingDecimals));
            var percentage = Math.floor(convertedInput.dividedBy(stakingMax).multipliedBy(100).toNumber());
            return percentage > 100 ? 100 : percentage;
        }
        return 0;
    }, [
        lockedAmount,
        stakingDecimals,
        stakingMax
    ]);
    var handleStakeInputChange = (0,react.useCallback)(function(input) {
        setLockedAmount(input);
    }, [
        setLockedAmount
    ]);
    var handleChangePercent = (0,react.useCallback)(function(sliderPercent) {
        if (sliderPercent > 0) {
            var percentageOfStakingMax = stakingMax.dividedBy(100).multipliedBy(sliderPercent);
            var amountToStake = (0,formatBalance/* getFullDisplayBalance */.NJ)(percentageOfStakingMax, stakingDecimals, stakingDecimals);
            setLockedAmount(amountToStake);
        } else {
            setLockedAmount("");
        }
    }, [
        stakingMax,
        setLockedAmount,
        stakingDecimals
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("BNOU to lock")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingAddress, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingSymbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                isWarning: userNotEnoughCake,
                value: lockedAmount,
                onUserInput: handleStakeInputChange,
                currencyValue: "~".concat(usedValueStaked || 0, " USD"),
                decimals: stakingDecimals
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "flex-end",
                mt: "4px",
                mb: "12px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "flex-end",
                    flexDirection: "column",
                    children: userNotEnoughCake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "failure",
                        children: notEnoughErrorMessage
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "8px",
                textAlign: "end",
                color: "textSubtle",
                fontSize: "12px",
                mb: "8px",
                children: t("Balance: %balance%", {
                    balance: (0,formatBalance/* getFullDisplayBalance */.NJ)(stakingMax, stakingDecimals)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                min: 0,
                max: 100,
                value: percent,
                onValueChanged: handleChangePercent,
                name: "stake",
                valueLabel: "".concat(percent, "%"),
                step: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mt: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceField_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(25);
                        },
                        children: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceField_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(50);
                        },
                        children: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceField_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(75);
                        },
                        children: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceField_StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(100);
                        },
                        children: t("Max")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Common_BalanceField = (/*#__PURE__*/(0,react.memo)(BalanceField));

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Modals/LockedStakeModal.tsx











var LockedStakeModal = function(param) {
    var onDismiss = param.onDismiss, currentBalance = param.currentBalance, stakingToken = param.stakingToken, stakingTokenBalance = param.stakingTokenBalance;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,react.useState)(""), lockedAmount = ref[0], setLockedAmount = ref[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(toNumber_default()(lockedAmount));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_RoiCalculatorModalProvider, {
        lockedAmount: lockedAmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            title: t("Lock BNOU"),
            onDismiss: onDismiss,
            headerBackground: theme.colors.gradients.cardHeader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_BalanceField, {
                        stakingAddress: stakingToken.address,
                        stakingSymbol: stakingToken.symbol,
                        stakingDecimals: stakingToken.decimals,
                        lockedAmount: lockedAmount,
                        usedValueStaked: usdValueStaked,
                        stakingMax: currentBalance,
                        setLockedAmount: setLockedAmount,
                        stakingTokenBalance: stakingTokenBalance
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockedModalBody, {
                    currentBalance: currentBalance,
                    stakingToken: stakingToken,
                    onDismiss: onDismiss,
                    lockedAmount: new (bignumber_default())(lockedAmount)
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_LockedStakeModal = (LockedStakeModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/HasSharesActions.tsx











var HasSharesActions = function(param) {
    var pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, performanceFee = param.performanceFee;
    var ref = useVaultPoolByKey(pool.vaultKey), _userData = ref.userData, _balance = _userData.balance, cakeAsBigNumber = _balance.cakeAsBigNumber, cakeAsNumberBalance = _balance.cakeAsNumberBalance;
    var stakingToken = pool.stakingToken;
    var cakePriceBusd = (0,farms_hooks/* usePriceCakeBusd */.Iu)();
    var stakedDollarValue = cakePriceBusd.gt(0) ? (0,formatBalance/* getBalanceNumber */.mW)(cakeAsBigNumber.multipliedBy(cakePriceBusd), stakingToken.decimals) : 0;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_NotEnoughTokensModal, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_VaultStakeModal, {
        stakingMax: stakingTokenBalance,
        performanceFee: performanceFee,
        pool: pool
    })), 1), onPresentStake = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_VaultStakeModal, {
        stakingMax: cakeAsBigNumber,
        pool: pool,
        isRemovingStake: true
    }), true, true, "withdraw-vault"), 1), onPresentUnstake = ref3[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "16px",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                fontSize: "20px",
                                bold: true,
                                value: cakeAsNumberBalance,
                                decimals: 5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: Flex/* default */.Z,
                                fontSize: "12px",
                                color: "textSubtle",
                                flexWrap: "wrap",
                                children: cakePriceBusd.gt(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    value: stakedDollarValue,
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    decimals: 2,
                                    prefix: "~",
                                    unit: " USD"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    mt: "1px",
                                    height: 16,
                                    width: 64
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "secondary",
                                onClick: onPresentUnstake,
                                mr: "6px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                    color: "primary",
                                    width: "24px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "secondary",
                                onClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "primary",
                                    width: "24px",
                                    height: "24px"
                                })
                            })
                        ]
                    })
                ]
            }),
            pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_ConvertToLock, {
                    stakingToken: stakingToken,
                    currentStakedAmount: cakeAsNumberBalance
                })
            })
        ]
    });
};
/* harmony default export */ var VaultCardActions_HasSharesActions = (HasSharesActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/VaultStakeActions.tsx









var VaultStakeActions = function(param) {
    var pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, accountHasSharesStaked = param.accountHasSharesStaked, performanceFee = param.performanceFee;
    var stakingToken = pool.stakingToken, userDataLoaded = pool.userDataLoaded;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_NotEnoughTokensModal, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_VaultStakeModal, {
        stakingMax: stakingTokenBalance,
        pool: pool,
        performanceFee: performanceFee
    })), 1), onPresentStake = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_LockedStakeModal, {
        currentBalance: stakingTokenBalance,
        stakingToken: stakingToken,
        stakingTokenBalance: stakingTokenBalance
    })), 1), openPresentLockedStakeModal = ref2[0];
    var renderStakeAction = function() {
        return accountHasSharesStaked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_HasSharesActions, {
            pool: pool,
            stakingTokenBalance: stakingTokenBalance,
            performanceFee: performanceFee
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeButtonGroup, {
            onFlexibleClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
            onLockedClick: pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? openPresentLockedStakeModal : null
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: userDataLoaded ? renderStakeAction() : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        })
    });
};
/* harmony default export */ var VaultCardActions_VaultStakeActions = (VaultStakeActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/index.tsx

function VaultCardActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    VaultCardActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var VaultCardActions_InlineText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-32d3da30-0"
})(VaultCardActions_templateObject());
var CakeVaultCardActions = function(param) {
    var pool = param.pool, accountHasSharesStaked = param.accountHasSharesStaked, isLoading = param.isLoading, performanceFee = param.performanceFee;
    var stakingToken = pool.stakingToken, userData = pool.userData;
    var t = (0,src/* useTranslation */.$G)().t;
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new (bignumber_default())(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var ref = useCheckVaultApprovalStatus(pool.vaultKey), isVaultApproved = ref.isVaultApproved, setLastUpdated = ref.setLastUpdated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "inline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VaultCardActions_InlineText, {
                            color: accountHasSharesStaked ? "secondary" : "textSubtle",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: [
                                accountHasSharesStaked ? stakingToken.symbol : t("Stake"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_InlineText, {
                            color: accountHasSharesStaked ? "textSubtle" : "secondary",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: accountHasSharesStaked ? t("Staked") : "".concat(stakingToken.symbol)
                        })
                    ]
                }),
                isVaultApproved ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_VaultStakeActions, {
                    pool: pool,
                    stakingTokenBalance: stakingTokenBalance,
                    accountHasSharesStaked: accountHasSharesStaked,
                    performanceFee: performanceFee
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_VaultApprovalAction, {
                    vaultKey: pool.vaultKey,
                    isLoading: isLoading,
                    setLastUpdated: setLastUpdated
                })
            ]
        })
    });
};
/* harmony default export */ var VaultCardActions = (CakeVaultCardActions);

// EXTERNAL MODULE: ./src/hooks/useInterval.ts
var useInterval = __webpack_require__(76159);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(11699);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/BurningCountDown.tsx








var BurningCountDown = function(param) {
    var lockEndTime = param.lockEndTime;
    var ref = (0,react.useState)(0), remainingSeconds = ref[0], setRemainingSeconds = ref[1];
    // 1 week after lockEndTime
    var burnDate = (0,react.useMemo)(function() {
        return (0,addSeconds/* default */.Z)(convertTimeToSeconds(lockEndTime), pools/* UNLOCK_FREE_DURATION */.by);
    }, [
        lockEndTime
    ]);
    var updateRemainingSeconds = (0,react.useCallback)(function() {
        setRemainingSeconds((0,differenceInSeconds/* default */.Z)(burnDate, new Date()));
    }, [
        burnDate
    ]);
    // Update every minute
    (0,useInterval/* default */.Z)(updateRemainingSeconds, 1000 * 60);
    var ref1 = (0,getTimePeriods/* default */.Z)(remainingSeconds), days = ref1.days, hours = ref1.hours, minutes = ref1.minutes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "".concat(days, "d: ").concat(hours, "h: ").concat(minutes, "m")
    });
};
/* harmony default export */ var Common_BurningCountDown = (/*#__PURE__*/(0,react.memo)(BurningCountDown));

// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Modals/AddAmountModal.tsx


















var RenewDuration = function(param) {
    var setCheckedState = param.setCheckedState, checkedState = param.checkedState;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !checkedState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    maxWidth: "320px",
                    children: t("Adding more BNOU will renew your lock, setting it to remaining duration. Due to shorter lock period, benefits decrease. To keep similar benefits, extend your lock.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checkedState,
                        onChange: function() {
                            return setCheckedState(function(prev) {
                                return !prev;
                            });
                        },
                        scale: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "8px",
                        color: "text",
                        children: t("Renew and extend your lock to keep similar benefits.")
                    })
                ]
            })
        ]
    });
};
// add 60s buffer in order to make sure minimum duration by pass on renew extension
var MIN_DURATION_BUFFER = 60;
var AddAmountModal = function(param) {
    var onDismiss = param.onDismiss, currentBalance = param.currentBalance, currentLockedAmount = param.currentLockedAmount, stakingToken = param.stakingToken, lockStartTime = param.lockStartTime, lockEndTime = param.lockEndTime, stakingTokenBalance = param.stakingTokenBalance;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ceiling = useIfoCeiling();
    var ref = (0,react.useState)(""), lockedAmount = ref[0], setLockedAmount = ref[1];
    var ref1 = (0,react.useState)(false), checkedState = ref1[0], setCheckedState = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var lockedAmountAsBigNumber = !Number.isNaN(new (bignumber_default())(lockedAmount).toNumber()) ? new (bignumber_default())(lockedAmount) : bigNumber/* BIG_ZERO */.HW;
    var totalLockedAmount = (0,formatBalance/* getBalanceNumber */.mW)(currentLockedAmount.plus((0,formatBalance/* getDecimalAmount */.Qe)(lockedAmountAsBigNumber)));
    var currentLockedAmountAsBalance = (0,formatBalance/* getBalanceAmount */.U4)(currentLockedAmount);
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(lockedAmountAsBigNumber.toNumber());
    var usdValueNewStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(totalLockedAmount);
    var remainingDuration = (0,differenceInSeconds/* default */.Z)(new Date(convertTimeToSeconds(lockEndTime)), new Date(), {
        roundingMethod: "ceil"
    });
    var passedDuration = (0,differenceInSeconds/* default */.Z)(new Date(), new Date(convertTimeToSeconds(lockStartTime)), {
        roundingMethod: "ceil"
    });
    // if you locked for 1 week, then add cake without renew the extension, it's possible that remainingDuration + passedDuration less than 1 week.
    var atLeastOneWeekNewDuration = Math.max(pools/* ONE_WEEK_DEFAULT */.kp + MIN_DURATION_BUFFER, remainingDuration + passedDuration);
    var prepConfirmArg = (0,react.useCallback)(function() {
        var extendDuration = atLeastOneWeekNewDuration - remainingDuration;
        return {
            finalDuration: checkedState ? extendDuration : 0
        };
    }, [
        atLeastOneWeekNewDuration,
        checkedState,
        remainingDuration
    ]);
    var customOverview = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Overview, {
            isValidDuration: true,
            openCalculator: (noop_default()),
            duration: remainingDuration,
            newDuration: checkedState ? atLeastOneWeekNewDuration : null,
            lockedAmount: currentLockedAmountAsBalance.toNumber(),
            newLockedAmount: totalLockedAmount,
            usdValueStaked: usdValueNewStaked,
            lockEndTime: lockEndTime,
            ceiling: ceiling
        });
    }, [
        remainingDuration,
        checkedState,
        currentLockedAmountAsBalance,
        atLeastOneWeekNewDuration,
        totalLockedAmount,
        usdValueNewStaked,
        lockEndTime,
        ceiling, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_RoiCalculatorModalProvider, {
        lockedAmount: lockedAmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            style: {
                maxWidth: "420px"
            },
            title: t("Add BNOU"),
            onDismiss: onDismiss,
            headerBackground: theme.colors.gradients.cardHeader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_BalanceField, {
                        stakingAddress: stakingToken.address,
                        stakingSymbol: stakingToken.symbol,
                        stakingDecimals: stakingToken.decimals,
                        lockedAmount: lockedAmount,
                        usedValueStaked: usdValueStaked,
                        stakingMax: currentBalance,
                        setLockedAmount: setLockedAmount,
                        stakingTokenBalance: stakingTokenBalance
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockedModalBody, {
                    currentBalance: currentBalance,
                    stakingToken: stakingToken,
                    onDismiss: onDismiss,
                    lockedAmount: lockedAmountAsBigNumber,
                    editAmountOnly: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenewDuration, {
                        checkedState: checkedState,
                        setCheckedState: setCheckedState
                    }),
                    prepConfirmArg: prepConfirmArg,
                    customOverview: customOverview
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_AddAmountModal = (AddAmountModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/AddCakeButton.tsx








var AddCakeButton = function(param) {
    var currentBalance = param.currentBalance, stakingToken = param.stakingToken, currentLockedAmount = param.currentLockedAmount, lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime, stakingTokenBalance = param.stakingTokenBalance;
    var ref = usePool(0), userDataLoaded = ref.pool.userDataLoaded;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_AddAmountModal, {
        currentLockedAmount: currentLockedAmount,
        currentBalance: currentBalance,
        stakingToken: stakingToken,
        lockStartTime: lockStartTime,
        lockEndTime: lockEndTime,
        stakingTokenBalance: stakingTokenBalance
    }), true, true, "AddAmountModal"), 1), openAddAmountModal = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_NotEnoughTokensModal, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref2[0];
    var handleClicked = (0,react.useCallback)(function() {
        return currentBalance.gt(0) ? openAddAmountModal() : onPresentTokenRequired();
    }, [
        currentBalance,
        openAddAmountModal,
        onPresentTokenRequired
    ]);
    return userDataLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: handleClicked,
        width: "100%",
        children: t("Add BNOU")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        height: 48
    });
};
/* harmony default export */ var Buttons_AddCakeButton = (/*#__PURE__*/(0,react.memo)(AddCakeButton));

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/ConvertToFlexibleButton.tsx


















var ConvertToFlexibleButton = function(props) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)(types/* VaultKey.CakeVault */.om.CakeVault);
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var handleUnlock = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var callOptions, receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    callOptions = {
                        gasLimit: pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].gasLimit
                    };
                    _ctx.next = 3;
                    return fetchWithCatchTxError(function() {
                        var methodArgs = [
                            account
                        ];
                        return callWithGasPrice(vaultPoolContract, "unlock", methodArgs, callOptions);
                    });
                case 3:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Staked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: receipt.transactionHash,
                            children: t("Your funds have been staked in the pool")
                        }));
                        dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                            account: account
                        }));
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        t,
        toastSuccess,
        account,
        callWithGasPrice,
        dispatch,
        fetchWithCatchTxError,
        vaultPoolContract
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        disabled: pendingTx,
        onClick: handleUnlock
    }, props), {
        children: pendingTx ? t("Converting...") : t("Convert to Flexible")
    }));
};
/* harmony default export */ var Buttons_ConvertToFlexibleButton = (/*#__PURE__*/(0,react.memo)(ConvertToFlexibleButton));

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/AfterLockedActions.tsx









var AfterLockedActions_obj;
var msg = (AfterLockedActions_obj = {}, (0,_define_property/* default */.Z)(AfterLockedActions_obj, VaultPosition.None, null), (0,_define_property/* default */.Z)(AfterLockedActions_obj, VaultPosition.Flexible, null), (0,_define_property/* default */.Z)(AfterLockedActions_obj, VaultPosition.Locked, null), (0,_define_property/* default */.Z)(AfterLockedActions_obj, VaultPosition.LockedEnd, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "The lock period has ended. Convert to flexible staking or renew your position to start a new lock staking."
})), (0,_define_property/* default */.Z)(AfterLockedActions_obj, VaultPosition.AfterBurning, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "The lock period has ended. To avoid more rewards being burned, convert to flexible staking or renew your position to start a new lock staking."
})), AfterLockedActions_obj);
var AfterLockedActions = function(param) {
    var currentLockedAmount = param.currentLockedAmount, stakingToken = param.stakingToken, position = param.position, isInline = param.isInline;
    var t = (0,src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpointsContext/* default */.Z)().isDesktop;
    var isDesktopView = isInline && isDesktop;
    var Container = isDesktopView ? Flex/* default */.Z : Box/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
        variant: "warning",
        mb: "16px",
        action: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            mt: !isDesktopView && "8px",
            ml: "10px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_ConvertToFlexibleButton, {
                    mb: !isDesktopView && "8px",
                    minWidth: isDesktopView && "200px",
                    mr: isDesktopView && "14px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_ExtendDurationButton, {
                    modalTitle: t("Renew"),
                    lockEndTime: "0",
                    lockStartTime: "0",
                    stakingToken: stakingToken,
                    currentLockedAmount: currentLockedAmount,
                    minWidth: "186px",
                    children: t("Renew")
                })
            ]
        }),
        actionInline: isDesktopView,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
            children: msg[position]
        })
    });
};
/* harmony default export */ var Common_AfterLockedActions = (/*#__PURE__*/(0,react.memo)(AfterLockedActions));

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/LockedActions.tsx











var LockedActions = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime, stakingToken = param.stakingToken, stakingTokenBalance = param.stakingTokenBalance, lockedAmount = param.lockedAmount;
    var position = (0,react.useMemo)(function() {
        return getVaultPosition({
            userShares: userShares,
            locked: locked,
            lockEndTime: lockEndTime
        });
    }, [
        userShares,
        locked,
        lockEndTime
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var lockedAmountAsNumber = (0,formatBalance/* getBalanceNumber */.mW)(lockedAmount);
    var currentBalance = (0,react.useMemo)(function() {
        return stakingTokenBalance ? new (bignumber_default())(stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    }, [
        stakingTokenBalance
    ]);
    if (position === VaultPosition.Locked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    mr: "4px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_AddCakeButton, {
                        lockEndTime: lockEndTime,
                        lockStartTime: lockStartTime,
                        currentLockedAmount: lockedAmount,
                        stakingToken: stakingToken,
                        currentBalance: currentBalance,
                        stakingTokenBalance: stakingTokenBalance
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    ml: "4px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_ExtendDurationButton, {
                        lockEndTime: lockEndTime,
                        lockStartTime: lockStartTime,
                        stakingToken: stakingToken,
                        currentBalance: currentBalance,
                        currentLockedAmount: lockedAmountAsNumber,
                        children: t("Extend")
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_AfterLockedActions, {
        lockEndTime: lockEndTime,
        lockStartTime: lockStartTime,
        position: position,
        currentLockedAmount: lockedAmountAsNumber,
        stakingToken: stakingToken
    });
};
/* harmony default export */ var Common_LockedActions = (LockedActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/YieldBoostRow.tsx





var YieldBoostRow = function(param) {
    var secondDuration = param.secondDuration;
    var boostFactor = useVaultApy({
        duration: secondDuration
    }).boostFactor;
    var t = (0,src/* useTranslation */.$G)().t;
    var tooltipContent = t("Your yield will be boosted based on the total lock duration of your current fixed term staking position.");
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    textTransform: "uppercase",
                    bold: true,
                    fontSize: "12px",
                    children: t("Yield boost")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                color: "text",
                bold: true,
                fontSize: "16px",
                value: boostFactor ? boostFactor === null || boostFactor === void 0 ? void 0 : boostFactor.toString() : "0",
                decimals: 2,
                unit: "x"
            })
        ]
    });
};
/* harmony default export */ var Common_YieldBoostRow = (YieldBoostRow);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/LockDurationRow.tsx



var LockDurationRow = function(param) {
    var weekDuration = param.weekDuration;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: t("Lock Duration")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "text",
                bold: true,
                fontSize: "16px",
                children: weekDuration
            })
        ]
    });
};
/* harmony default export */ var Common_LockDurationRow = (LockDurationRow);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/IfoCakeRow.tsx

function IfoCakeRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    IfoCakeRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var InlineLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-41c00ecf-0"
})(IfoCakeRow_templateObject());
var IfoCakeRow = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var credit = useIfoCredit();
    var ceiling = useIfoCeiling();
    var weeksDisplay = (0,Pools_helpers/* getICakeWeekDisplay */.XW)(ceiling);
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The number of iCAKE equals the locked staking amount if the staking duration is longer than %weeks% weeks. If the staking duration is less than %weeks% weeks, it will linearly decrease based on the staking duration.", {
                    weeks: weeksDisplay
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineLink, {
                external: true,
                href: "https://docs.pancakeswap.finance/products/ifo-initial-farm-offering/icake",
                children: t("Learn more about iCAKE")
            })
        ]
    }), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    bold: true,
                    fontSize: "12px",
                    children: t("iCAKE")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                color: "text",
                bold: true,
                fontSize: "16px",
                decimals: 3,
                value: (0,formatBalance/* getBalanceNumber */.mW)(credit)
            })
        ]
    });
};
/* harmony default export */ var Common_IfoCakeRow = (IfoCakeRow);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useUserDataInVaultPresenter.ts



var useUserDataInVaultPresenter = function(param) {
    var lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime;
    var ref = (0,src/* useTranslation */.$G)(), locale = ref.currentLanguage.locale;
    var secondDuration = Number(lockEndTime) - Number(lockStartTime);
    var lockEndTimeSeconds = convertTimeToSeconds(lockEndTime);
    var lockEndDate = "";
    try {
        lockEndDate = new Date(lockEndTimeSeconds).toLocaleString(locale, {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });
    } catch (_) {
    // ignore invalid format
    }
    return {
        weekDuration: utils_formatSecondsToWeeks(secondDuration),
        remainingTime: distanceToNowStrict(lockEndTimeSeconds),
        lockEndDate: lockEndDate,
        secondDuration: secondDuration
    };
};
/* harmony default export */ var hooks_useUserDataInVaultPresenter = (useUserDataInVaultPresenter);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/LockedStakingApy.tsx


















var LockedStakingApy = function(param) {
    var stakingToken = param.stakingToken, stakingTokenBalance = param.stakingTokenBalance, userData = param.userData, showICake = param.showICake;
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    var position = (0,react.useMemo)(function() {
        return getVaultPosition({
            userShares: userData === null || userData === void 0 ? void 0 : userData.userShares,
            locked: userData === null || userData === void 0 ? void 0 : userData.locked,
            lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime
        });
    }, [
        userData
    ]);
    var currentLockedAmountAsBigNumber = (0,react.useMemo)(function() {
        var ref;
        return userData === null || userData === void 0 ? void 0 : (ref = userData.balance) === null || ref === void 0 ? void 0 : ref.cakeAsBigNumber;
    }, [
        userData === null || userData === void 0 ? void 0 : (ref = userData.balance) === null || ref === void 0 ? void 0 : ref.cakeAsBigNumber
    ]);
    var currentLockedAmount = (0,formatBalance/* getBalanceNumber */.mW)(currentLockedAmountAsBigNumber);
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(currentLockedAmount);
    var ref1 = hooks_useUserDataInVaultPresenter({
        lockStartTime: userData === null || userData === void 0 ? void 0 : userData.lockStartTime,
        lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime
    }), weekDuration = ref1.weekDuration, lockEndDate = ref1.lockEndDate, secondDuration = ref1.secondDuration, remainingTime = ref1.remainingTime;
    var lockedApy = useVaultApy({
        duration: secondDuration
    }).lockedApy;
    // earningTokenBalance includes overdue fee if any
    var earningTokenBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getBalanceNumber */.mW)(currentLockedAmountAsBigNumber.minus(userData === null || userData === void 0 ? void 0 : userData.cakeAtLastUserAction));
    }, [
        currentLockedAmountAsBigNumber,
        userData === null || userData === void 0 ? void 0 : userData.cakeAtLastUserAction
    ]);
    var tooltipContent = t("Calculated based on current rates and subject to change based on pool conditions. It is an estimate provided for your convenience only, and by no means represents guaranteed returns.");
    var ref2 = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref2.targetRef, tooltip = ref2.tooltip, tooltipVisible = ref2.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Card/* LightGreyCard */.m5, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                textTransform: "uppercase",
                                bold: true,
                                fontSize: "12px",
                                children: t("BNOU locked")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                color: "text",
                                bold: true,
                                fontSize: "16px",
                                value: currentLockedAmount,
                                decimals: 5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                value: usdValueStaked,
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                prefix: "~",
                                unit: " USD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                textTransform: "uppercase",
                                bold: true,
                                fontSize: "12px",
                                children: t("Unlocks In")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: position >= VaultPosition.LockedEnd ? "#D67E0A" : "text",
                                bold: true,
                                fontSize: "16px",
                                children: position >= VaultPosition.LockedEnd ? t("Unlocked") : remainingTime
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: position >= VaultPosition.LockedEnd ? "#D67E0A" : "text",
                                fontSize: "12px",
                                children: t("On %date%", {
                                    date: lockEndDate
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockedActions, {
                    userShares: userData === null || userData === void 0 ? void 0 : userData.userShares,
                    locked: userData === null || userData === void 0 ? void 0 : userData.locked,
                    lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime,
                    lockStartTime: userData === null || userData === void 0 ? void 0 : userData.lockStartTime,
                    stakingToken: stakingToken,
                    stakingTokenBalance: stakingTokenBalance,
                    lockedAmount: currentLockedAmountAsBigNumber
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
            ![
                VaultPosition.LockedEnd,
                VaultPosition.AfterBurning
            ].includes(position) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    tooltipVisible && tooltip,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ref: targetRef,
                            color: "textSubtle",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: t("APY")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                        color: "text",
                        bold: true,
                        fontSize: "16px",
                        value: parseFloat(lockedApy),
                        decimals: 2,
                        unit: "%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockDurationRow, {
                weekDuration: weekDuration
            }),
            ![
                VaultPosition.LockedEnd,
                VaultPosition.AfterBurning
            ].includes(position) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_YieldBoostRow, {
                secondDuration: secondDuration
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("Recent BNOU profit")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                        color: "text",
                        bold: true,
                        fontSize: "16px",
                        value: earningTokenBalance,
                        decimals: 5
                    })
                ]
            }),
            position === VaultPosition.LockedEnd && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("After Burning In")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        bold: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_BurningCountDown, {
                            lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime
                        })
                    })
                ]
            }),
            position === VaultPosition.AfterBurning && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("After burning")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        bold: true,
                        children: (0,isUndefinedOrNull/* default */.Z)(userData === null || userData === void 0 ? void 0 : userData.currentOverdueFee) ? "-" : t("%amount% Burned", {
                            amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(userData === null || userData === void 0 ? void 0 : userData.currentOverdueFee, 18, 5)
                        })
                    })
                ]
            }),
            showICake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_IfoCakeRow, {})
        ]
    });
};
/* harmony default export */ var LockedPool_LockedStakingApy = (/*#__PURE__*/(0,react.memo)(LockedStakingApy));

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/index.tsx




function CakeVaultCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: ",
        ";\n"
    ]);
    CakeVaultCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var StyledCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-7ac8ad80-0"
})(CakeVaultCard_templateObject(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "0" : "254px";
});
var CakeVaultDetail = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, account = param.account, pool = param.pool, vaultPool = param.vaultPool, accountHasSharesStaked = param.accountHasSharesStaked, showICake = param.showICake, performanceFeeAsDecimal = param.performanceFeeAsDecimal, defaultFooterExpanded = param.defaultFooterExpanded;
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardBody, {
                isLoading: isLoading,
                children: [
                    account && pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultPositionTagWithLabel, {
                        userData: vaultPool.userData
                    }),
                    account && pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultPool.userData.locked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedPool_LockedStakingApy, {
                        userData: vaultPool.userData,
                        stakingToken: pool === null || pool === void 0 ? void 0 : pool.stakingToken,
                        stakingTokenBalance: pool === null || pool === void 0 ? void 0 : (ref = pool.userData) === null || ref === void 0 ? void 0 : ref.stakingTokenBalance,
                        showICake: showICake
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakingApy, {
                                pool: pool
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                                mt: "16px",
                                gap: "24px",
                                flexDirection: accountHasSharesStaked ? "column-reverse" : "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        children: [
                                            account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                mb: "8px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_UnstakingFeeCountdownRow, {
                                                    vaultKey: pool.vaultKey
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentCakeProfitRow, {
                                                pool: pool
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions, {
                                            pool: pool,
                                            accountHasSharesStaked: accountHasSharesStaked,
                                            isLoading: isLoading,
                                            performanceFee: performanceFeeAsDecimal
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mb: "10px",
                                                    textTransform: "uppercase",
                                                    fontSize: "12px",
                                                    color: "textSubtle",
                                                    bold: true,
                                                    children: t("Start earning")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard_CardFooter, {
                defaultExpanded: defaultFooterExpanded,
                pool: pool,
                account: account
            })
        ]
    });
};
var CakeVaultCard = function(_param) {
    var pool = _param.pool, showStakedOnly = _param.showStakedOnly, defaultFooterExpanded = _param.defaultFooterExpanded, _showICake = _param.showICake, showICake = _showICake === void 0 ? false : _showICake, props = (0,_object_without_properties/* default */.Z)(_param, [
        "pool",
        "showStakedOnly",
        "defaultFooterExpanded",
        "showICake"
    ]);
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var vaultPool = useVaultPoolByKey(pool.vaultKey);
    var _userData = vaultPool.userData, userShares = _userData.userShares, isVaultUserDataLoading = _userData.isLoading, performanceFeeAsDecimal = vaultPool.fees.performanceFeeAsDecimal;
    var accountHasSharesStaked = userShares && userShares.gt(0);
    var isLoading = !pool.userData || isVaultUserDataLoading;
    if (showStakedOnly && !accountHasSharesStaked) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: true
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolCard_PoolCardHeader, {
                isStaking: accountHasSharesStaked,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCardHeaderTitle, {
                        title: pools/* vaultPoolConfig */.Y4[pool.vaultKey].name,
                        subTitle: pools/* vaultPoolConfig */.Y4[pool.vaultKey].description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPairImage/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pools/* vaultPoolConfig */.Y4[pool.vaultKey].tokenImage), {
                        width: 64,
                        height: 64
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultDetail, {
                isLoading: isLoading,
                account: account,
                pool: pool,
                vaultPool: vaultPool,
                accountHasSharesStaked: accountHasSharesStaked,
                showICake: showICake,
                performanceFeeAsDecimal: performanceFeeAsDecimal,
                defaultFooterExpanded: defaultFooterExpanded
            })
        ]
    }));
};
/* harmony default export */ var components_CakeVaultCard = (CakeVaultCard);

// EXTERNAL MODULE: ./src/components/ToggleView/ToggleView.tsx
var ToggleView = __webpack_require__(31455);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(45341);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(20508);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolTabButtons.tsx

function PoolTabButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n\n  ",
        " {\n    margin-left: 8px;\n  }\n"
    ]);
    PoolTabButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PoolTabButtons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  > div {\n    padding: 8px 0px;\n  }\n\n  ",
        " {\n    justify-content: flex-start;\n    width: auto;\n\n    > div {\n      padding: 0;\n    }\n  }\n"
    ]);
    PoolTabButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PoolTabButtons_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    PoolTabButtons_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ToggleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8cb1f6-0"
})(PoolTabButtons_templateObject(), Text/* default */.Z);
var ViewControls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8cb1f6-1"
})(PoolTabButtons_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var PoolTabButtons_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8cb1f6-2"
})(PoolTabButtons_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var PoolTabButtons = function(param) {
    var stakedOnly = param.stakedOnly, setStakedOnly = param.setStakedOnly, hasStakeInFinishedPools = param.hasStakeInFinishedPools, viewMode = param.viewMode, setViewMode = param.setViewMode;
    var router = (0,next_router.useRouter)();
    var t = (0,src/* useTranslation */.$G)().t;
    var isExact = router.asPath === "/pools" || router.asPath === "/_mp/pools";
    var viewModeToggle = /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleView/* default */.Z, {
        idPrefix: "clickPool",
        viewMode: viewMode,
        onToggle: setViewMode
    });
    var liveOrFinishedSwitch = /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolTabButtons_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
            activeIndex: isExact ? 0 : 1,
            scale: "sm",
            variant: "subtle",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                    as: NextLink/* NextLinkFromReactRouter */.a,
                    to: "/pools",
                    replace: true,
                    children: t("Live")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                    show: hasStakeInFinishedPools,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        id: "finished-pools-button",
                        as: NextLink/* NextLinkFromReactRouter */.a,
                        to: "/pools/history",
                        replace: true,
                        children: t("Finished")
                    })
                })
            ]
        })
    });
    var stakedOnlySwitch = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                checked: stakedOnly,
                onChange: function() {
                    return setStakedOnly(!stakedOnly);
                },
                scale: "sm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                children: [
                    " ",
                    t("Staked only")
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewControls, {
        children: [
            viewModeToggle,
            stakedOnlySwitch,
            liveOrFinishedSwitch
        ]
    });
};
/* harmony default export */ var components_PoolTabButtons = (PoolTabButtons);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(40447);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/BaseCell.tsx

function BaseCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: black;\n\n  padding: 24px 8px;\n\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    BaseCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BaseCell_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  max-height: 40px;\n  ",
        " {\n    line-height: 1;\n  }\n"
    ]);
    BaseCell_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var BaseCell = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2af072c6-0"
})(BaseCell_templateObject());
var CellContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2af072c6-1"
})(BaseCell_templateObject1(), Text/* default */.Z);
/* harmony default export */ var Cells_BaseCell = (BaseCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/NameCell.tsx




function NameCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 5;\n  flex-direction: row;\n  padding-left: 12px;\n  ",
        " {\n    flex: 1 0 150px;\n    padding-left: 32px;\n  }\n"
    ]);
    NameCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-73022ccf-0"
})(NameCell_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var NameCell = function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken, userData = pool.userData, isFinished = pool.isFinished, vaultKey = pool.vaultKey;
    var vaultData = useVaultPoolByKey(pool.vaultKey);
    var userShares = vaultData.userData.userShares;
    var hasVaultShares = userShares.gt(0);
    var stakingTokenSymbol = stakingToken.symbol;
    var earningTokenSymbol = earningToken.symbol;
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new (bignumber_default())(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    var isStaked = stakedBalance.gt(0);
    var showStakedTag = vaultKey ? hasVaultShares : isStaked;
    var title = "".concat(t("Earn"), " ").concat(earningTokenSymbol);
    var subtitle = "".concat(t("Stake"), " ").concat(stakingTokenSymbol);
    var showSubtitle = sousId !== 0 || sousId === 0 && !isMobile;
    if (vaultKey) {
        title = pools/* vaultPoolConfig */.Y4[vaultKey].name;
        subtitle = pools/* vaultPoolConfig */.Y4[vaultKey].description;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCell, {
        role: "cell",
        children: [
            vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPairImage/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pools/* vaultPoolConfig */.Y4[vaultKey].tokenImage), {
                mr: "8px",
                width: 40,
                height: 40
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                primaryToken: earningToken,
                secondaryToken: stakingToken,
                mr: "8px",
                width: 40,
                height: 40
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
                children: [
                    showStakedTag && (vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedCakeStatus, {
                        userShares: userShares,
                        locked: vaultData.userData.locked,
                        lockEndTime: vaultData.userData.lockEndTime
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: isFinished ? "failure" : "secondary",
                        textTransform: "uppercase",
                        children: t("Staked")
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: !isMobile,
                        small: isMobile,
                        children: title
                    }),
                    showSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Cells_NameCell = (NameCell);
var NameCell_obj;
var stakedStatus = (NameCell_obj = {}, (0,_define_property/* default */.Z)(NameCell_obj, VaultPosition.None, {
    text: "",
    color: "secondary"
}), (0,_define_property/* default */.Z)(NameCell_obj, VaultPosition.Locked, {
    text: "Locked",
    color: "secondary"
}), (0,_define_property/* default */.Z)(NameCell_obj, VaultPosition.LockedEnd, {
    text: "Locked End",
    color: "secondary"
}), (0,_define_property/* default */.Z)(NameCell_obj, VaultPosition.AfterBurning, {
    text: "After Burning",
    color: "failure"
}), (0,_define_property/* default */.Z)(NameCell_obj, VaultPosition.Flexible, {
    text: "Flexible",
    color: "success"
}), NameCell_obj);
var StakedCakeStatus = /*#__PURE__*/ (0,react.memo)(function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    var vaultPosition = getVaultPosition({
        userShares: userShares,
        locked: locked,
        lockEndTime: lockEndTime
    });
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        fontSize: "12px",
        bold: true,
        color: stakedStatus[vaultPosition].color,
        textTransform: "uppercase",
        children: t(stakedStatus[vaultPosition].text)
    });
});

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/EarningsCell.tsx


function EarningsCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 4.5;\n  ",
        " {\n    flex: 1 0 120px;\n  }\n"
    ]);
    EarningsCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var EarningsCell_StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-f786aa19-0"
})(EarningsCell_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var EarningsCell = function(param) {
    var pool = param.pool, account = param.account;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var sousId = pool.sousId, earningToken = pool.earningToken, poolCategory = pool.poolCategory, userData = pool.userData, earningTokenPrice = pool.earningTokenPrice;
    var isManualCakePool = sousId === 0;
    var earnings = (userData === null || userData === void 0 ? void 0 : userData.pendingReward) ? new (bignumber_default())(userData.pendingReward) : bigNumber/* BIG_ZERO */.HW;
    var earningTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings, earningToken.decimals);
    var earningTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings.multipliedBy(earningTokenPrice), earningToken.decimals);
    var hasEarnings = account && earnings.gt(0);
    var fullBalance = (0,formatBalance/* getFullDisplayBalance */.NJ)(earnings, earningToken.decimals);
    var formattedBalance = (0,formatBalance/* formatNumber */.uf)(earningTokenBalance, 3, 3);
    var isBnbPool = poolCategory === constants_types/* PoolCategory.BINANCE */.jh.BINANCE;
    var labelText = t("%asset% Earned", {
        asset: earningToken.symbol
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_CollectModal, {
        formattedBalance: formattedBalance,
        fullBalance: fullBalance,
        earningToken: earningToken,
        earningsDollarValue: earningTokenDollarBalance,
        sousId: sousId,
        isBnbPool: isBnbPool,
        isCompoundPool: isManualCakePool
    })), 1), onPresentCollect = ref[0];
    var handleEarningsClick = function(event) {
        event.stopPropagation();
        onPresentCollect();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EarningsCell_StyledCell, {
        role: "cell",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: labelText
                }),
                !pool.userDataLoaded && account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "16px"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mr: "8px",
                            height: "32px",
                            onClick: hasEarnings ? handleEarningsClick : undefined,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    mt: "4px",
                                    bold: !isMobile,
                                    fontSize: isMobile ? "14px" : "16px",
                                    color: hasEarnings ? "primary" : "textDisabled",
                                    decimals: hasEarnings ? 5 : 1,
                                    value: hasEarnings ? earningTokenBalance : 0
                                }),
                                hasEarnings ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: earningTokenPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                        display: "inline",
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        decimals: 2,
                                        prefix: "~",
                                        value: earningTokenDollarBalance,
                                        unit: " USD"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "4px",
                                    fontSize: "12px",
                                    color: "textDisabled",
                                    children: "0 USD"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Cells_EarningsCell = (EarningsCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/AprCell.tsx







var AprCell = function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var userData = pool.userData;
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new (bignumber_default())(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_BaseCell, {
        role: "cell",
        flex: [
            "1 0 50px",
            "1 0 50px",
            "2 0 100px",
            "2 0 100px",
            "1 0 120px"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: t("APR")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Apr, {
                    pool: pool,
                    stakedBalance: stakedBalance,
                    showIcon: !isMobile
                })
            ]
        })
    });
};
/* harmony default export */ var Cells_AprCell = (AprCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/TotalStakedCell.tsx

function TotalStakedCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 2 0 100px;\n"
    ]);
    TotalStakedCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var TotalStakedCell_StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-d958b2f1-0"
})(TotalStakedCell_templateObject());
var TotalStakedCell = function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var stakingToken = pool.stakingToken, totalStaked = pool.totalStaked, vaultKey = pool.vaultKey;
    var totalCakeInVault = useVaultPoolByKey(vaultKey).totalCakeInVault;
    var totalStakedBalance = (0,react.useMemo)(function() {
        if (vaultKey) {
            return (0,formatBalance/* getBalanceNumber */.mW)(totalCakeInVault, stakingToken.decimals);
        }
        return (0,formatBalance/* getBalanceNumber */.mW)(totalStaked, stakingToken.decimals);
    }, [
        vaultKey,
        totalCakeInVault,
        totalStaked,
        stakingToken.decimals
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalStakedCell_StyledCell, {
        role: "cell",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: t("Total staked")
                }),
                totalStaked && totalStaked.gte(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    height: "20px",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        fontSize: "16px",
                        value: totalStakedBalance,
                        decimals: 0,
                        unit: " ".concat(stakingToken.symbol)
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "16px"
                })
            ]
        })
    });
};
/* harmony default export */ var Cells_TotalStakedCell = (TotalStakedCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/EndsInCell.tsx

function EndsInCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 2 0 100px;\n"
    ]);
    EndsInCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var EndsInCell_StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-867eec0-0"
})(EndsInCell_templateObject());
var EndsInCell = function(param) {
    var pool = param.pool;
    var sousId = pool.sousId, totalStaked = pool.totalStaked, startBlock = pool.startBlock, endBlock = pool.endBlock, isFinished = pool.isFinished;
    var currentBlock = (0,block_hooks/* useCurrentBlock */.je)();
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,Pools_helpers/* getPoolBlockInfo */.zy)(pool, currentBlock), shouldShowBlockCountdown = ref.shouldShowBlockCountdown, blocksUntilStart = ref.blocksUntilStart, blocksRemaining = ref.blocksRemaining, hasPoolStarted = ref.hasPoolStarted, blocksToDisplay = ref.blocksToDisplay;
    var isCakePool = sousId === 0;
    var renderBlocks = shouldShowBlockCountdown ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flex: "1.3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        fontSize: "16px",
                        value: blocksToDisplay,
                        decimals: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "4px",
                        textTransform: "lowercase",
                        children: t("Blocks")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flex: "1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    external: true,
                    href: (0,utils/* getBscScanLink */.s6)(hasPoolStarted ? endBlock : startBlock, "countdown"),
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
                        ml: "4px"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        children: "-"
    });
    // A bit hacky way to determine if public data is loading relying on totalStaked
    // Opted to go for this since we don't really need a separate publicDataLoaded flag
    // anywhere else
    var isLoadingBlockData = !currentBlock || !blocksRemaining && !blocksUntilStart;
    var isLoadingPublicData = hasPoolStarted ? !totalStaked.gt(0) || isLoadingBlockData : isLoadingBlockData;
    var showLoading = isLoadingPublicData && !isCakePool && !isFinished;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EndsInCell_StyledCell, {
        role: "cell",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: hasPoolStarted || !shouldShowBlockCountdown ? t("Ends in") : t("Starts in")
                }),
                showLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "16px"
                }) : renderBlocks
            ]
        })
    });
};
/* harmony default export */ var Cells_EndsInCell = (EndsInCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ActionPanel/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  padding: 16px;\n  border: 2px solid ",
        ";\n  border-radius: 16px;\n  margin-bottom: 16px;\n\n  ",
        " {\n    margin-left: 12px;\n    margin-right: 12px;\n    margin-bottom: 0;\n  }\n}\n\n  ",
        " {\n    margin-left: 32px;\n    margin-right: 0;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 12px;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ActionContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f91bd6da-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
ActionContainer.defaultProps = {
    flex: 1
};
var RowActionContainer = (0,styled_components_browser_esm/* default */.ZP)(ActionContainer).withConfig({
    componentId: "sc-f91bd6da-1"
})(styles_templateObject1());
var ActionTitles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f91bd6da-2"
})(styles_templateObject2());
var ActionContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f91bd6da-3"
})(_templateObject3());
ActionContent.defaultProps = {
    mt: "8px"
};

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ActionPanel/Harvest.tsx












var HarvestAction = function(param) {
    var sousId = param.sousId, poolCategory = param.poolCategory, earningToken = param.earningToken, userData = param.userData, userDataLoaded = param.userDataLoaded, earningTokenPrice = param.earningTokenPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var earnings = (userData === null || userData === void 0 ? void 0 : userData.pendingReward) ? new (bignumber_default())(userData.pendingReward) : bigNumber/* BIG_ZERO */.HW;
    var earningTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings, earningToken.decimals);
    var earningTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings.multipliedBy(earningTokenPrice), earningToken.decimals);
    var hasEarnings = earnings.gt(0);
    var fullBalance = (0,formatBalance/* getFullDisplayBalance */.NJ)(earnings, earningToken.decimals);
    var formattedBalance = (0,formatBalance/* formatNumber */.uf)(earningTokenBalance, 3, 3);
    var isCompoundPool = sousId === 0;
    var isBnbPool = poolCategory === constants_types/* PoolCategory.BINANCE */.jh.BINANCE;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_CollectModal, {
        formattedBalance: formattedBalance,
        fullBalance: fullBalance,
        earningToken: earningToken,
        earningsDollarValue: earningTokenDollarBalance,
        sousId: sousId,
        isBnbPool: isBnbPool,
        isCompoundPool: isCompoundPool
    })), 1), onPresentCollect = ref[0];
    var actionTitle = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "12px",
                bold: true,
                color: "secondary",
                as: "span",
                textTransform: "uppercase",
                children: [
                    earningToken.symbol,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "12px",
                bold: true,
                color: "textSubtle",
                as: "span",
                textTransform: "uppercase",
                children: t("Earned")
            })
        ]
    });
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: actionTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: "0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: true,
                            children: isCompoundPool ? t("Collect") : t("Harvest")
                        })
                    ]
                })
            ]
        });
    }
    if (!userDataLoaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: actionTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 180,
                        height: "32px",
                        marginTop: 14
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                children: actionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        alignSelf: "flex-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: hasEarnings ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                        lineHeight: "1",
                                        bold: true,
                                        fontSize: "20px",
                                        decimals: 5,
                                        value: earningTokenBalance
                                    }),
                                    earningTokenPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                        display: "inline",
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        decimals: 2,
                                        prefix: "~",
                                        value: earningTokenDollarBalance,
                                        unit: " USD"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        color: "textDisabled",
                                        children: "0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textDisabled",
                                        children: "0 USD"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !hasEarnings,
                        onClick: onPresentCollect,
                        children: isCompoundPool ? t("Collect") : t("Harvest")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Harvest = (HarvestAction);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ActionPanel/Stake.tsx


function Stake_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    Stake_templateObject = function _templateObject() {
        return data;
    };
    return data;
}































var IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9768324-0"
})(Stake_templateObject());
var Staked = function(param) {
    var pool = param.pool;
    var ref, ref1;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken, stakingLimit = pool.stakingLimit, isFinished = pool.isFinished, poolCategory = pool.poolCategory, userData = pool.userData, stakingTokenPrice = pool.stakingTokenPrice, vaultKey = pool.vaultKey, profileRequirement = pool.profileRequirement, userDataLoaded = pool.userDataLoaded;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var stakingTokenContract = (0,useContract/* useERC20 */.X_)(stakingToken.address || "");
    var ref2 = useApprovePool(stakingTokenContract, sousId, earningToken.symbol), handlePoolApprove = ref2.handleApprove, pendingPoolTx = ref2.pendingTx;
    var ref3 = useCheckVaultApprovalStatus(vaultKey), isVaultApproved = ref3.isVaultApproved, setLastUpdated = ref3.setLastUpdated;
    var ref4 = useVaultApprove(vaultKey, setLastUpdated), handleVaultApprove = ref4.handleApprove, pendingVaultTx = ref4.pendingTx;
    var handleApprove = vaultKey ? handleVaultApprove : handlePoolApprove;
    var pendingTx = vaultKey ? pendingVaultTx : pendingPoolTx;
    var isBnbPool = poolCategory === constants_types/* PoolCategory.BINANCE */.jh.BINANCE;
    var allowance = (userData === null || userData === void 0 ? void 0 : userData.allowance) ? new (bignumber_default())(userData.allowance) : bigNumber/* BIG_ZERO */.HW;
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new (bignumber_default())(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    var isNotVaultAndHasStake = !vaultKey && stakedBalance.gt(0);
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new (bignumber_default())(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var stakedTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance, stakingToken.decimals);
    var stakedTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance.multipliedBy(stakingTokenPrice), stakingToken.decimals);
    var vaultData = useVaultPoolByKey(pool.vaultKey);
    var _userData = vaultData.userData, userShares = _userData.userShares, _balance = _userData.balance, cakeAsBigNumber = _balance.cakeAsBigNumber, cakeAsNumberBalance = _balance.cakeAsNumberBalance;
    var ref5, ref6;
    var ref7 = hooks_useUserDataInVaultPresenter({
        lockStartTime: vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? (ref5 = (ref = vaultData.userData) === null || ref === void 0 ? void 0 : ref.lockStartTime) !== null && ref5 !== void 0 ? ref5 : "0" : "0",
        lockEndTime: vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? (ref6 = (ref1 = vaultData.userData) === null || ref1 === void 0 ? void 0 : ref1.lockEndTime) !== null && ref6 !== void 0 ? ref6 : "0" : "0"
    }), lockEndDate = ref7.lockEndDate, remainingTime = ref7.remainingTime;
    var hasSharesStaked = userShares.gt(0);
    var isVaultWithShares = vaultKey && hasSharesStaked;
    var stakedAutoDollarValue = (0,formatBalance/* getBalanceNumber */.mW)(cakeAsBigNumber.multipliedBy(stakingTokenPrice), stakingToken.decimals);
    var needsApproval = vaultKey ? !isVaultApproved : !allowance.gt(0) && !isBnbPool;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_NotEnoughTokensModal, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_StakeModal, {
        isBnbPool: isBnbPool,
        pool: pool,
        stakingTokenBalance: stakingTokenBalance,
        stakingTokenPrice: stakingTokenPrice
    })), 1), onPresentStake = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_VaultStakeModal, {
        stakingMax: stakingTokenBalance,
        pool: pool
    })), 1), onPresentVaultStake = ref10[0];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_StakeModal, {
        stakingTokenBalance: stakingTokenBalance,
        isBnbPool: isBnbPool,
        pool: pool,
        stakingTokenPrice: stakingTokenPrice,
        isRemovingStake: true
    })), 1), onPresentUnstake = ref11[0];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_VaultStakeModal, {
        stakingMax: cakeAsBigNumber,
        pool: pool,
        isRemovingStake: true
    })), 1), onPresentVaultUnstake = ref12[0];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_LockedStakeModal, {
        currentBalance: stakingTokenBalance,
        stakingToken: stakingToken,
        stakingTokenBalance: stakingTokenBalance
    })), 1), openPresentLockedStakeModal = ref13[0];
    var ref14 = useProfileRequirement(profileRequirement), notMeetRequired = ref14.notMeetRequired, notMeetThreshold = ref14.notMeetThreshold;
    var onStake = function() {
        if (vaultKey) {
            onPresentVaultStake();
        } else {
            onPresentStake();
        }
    };
    var onUnstake = function() {
        if (vaultKey) {
            onPresentVaultUnstake();
        } else {
            onPresentUnstake();
        }
    };
    var ref15 = (0,useTooltip/* default */.Z)(t("You've already staked the maximum amount you can stake in this pool!"), {
        placement: "bottom"
    }), targetRef = ref15.targetRef, tooltip = ref15.tooltip, tooltipVisible = ref15.tooltipVisible;
    var reachStakingLimit = stakingLimit.gt(0) && userData.stakedBalance.gte(stakingLimit);
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: "textSubtle",
                        as: "span",
                        textTransform: "uppercase",
                        children: t("Start staking")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                        width: "100%"
                    })
                })
            ]
        });
    }
    if (!userDataLoaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: "textSubtle",
                        as: "span",
                        textTransform: "uppercase",
                        children: t("Start staking")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 180,
                        height: "32px",
                        marginTop: 14
                    })
                })
            ]
        });
    }
    if (notMeetRequired || notMeetThreshold) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: "textSubtle",
                        as: "span",
                        textTransform: "uppercase",
                        children: t("Enable pool")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileRequirementWarning, {
                        profileRequirement: profileRequirement
                    })
                })
            ]
        });
    }
    if (needsApproval) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: "textSubtle",
                        as: "span",
                        textTransform: "uppercase",
                        children: t("Enable pool")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        disabled: pendingTx,
                        onClick: handleApprove,
                        variant: "secondary",
                        children: t("Enable")
                    })
                })
            ]
        });
    }
    // Wallet connected, user data loaded and approved
    if (isNotVaultAndHasStake || isVaultWithShares) {
        var vaultPosition = getVaultPosition(vaultData.userData);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContainer, {
                    flex: vaultPosition > 1 ? 1.5 : 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContent, {
                        mt: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flex: "1",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionTitles, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                fontSize: "12px",
                                                bold: true,
                                                color: "secondary",
                                                as: "span",
                                                textTransform: "uppercase",
                                                children: [
                                                    stakingToken.symbol,
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "12px",
                                                bold: true,
                                                color: "textSubtle",
                                                as: "span",
                                                textTransform: "uppercase",
                                                children: vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultData.userData.locked ? t("Locked") : t("Staked")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            position: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                                    lineHeight: "1",
                                                    bold: true,
                                                    fontSize: "20px",
                                                    decimals: 5,
                                                    value: vaultKey ? cakeAsNumberBalance : stakedTokenBalance
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonV2 */.i, {
                                                    isDataReady: Number.isFinite(vaultKey ? stakedAutoDollarValue : stakedTokenDollarBalance),
                                                    width: 120,
                                                    wrapperProps: {
                                                        height: "20px"
                                                    },
                                                    skeletonTop: "2px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                                        fontSize: "12px",
                                                        display: "inline",
                                                        color: "textSubtle",
                                                        decimals: 2,
                                                        value: vaultKey ? stakedAutoDollarValue : stakedTokenDollarBalance,
                                                        unit: " USD",
                                                        prefix: "~"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    vaultPosition === VaultPosition.Locked && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: "16px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_AddCakeButton, {
                                            lockEndTime: vaultData.userData.lockEndTime,
                                            lockStartTime: vaultData.userData.lockStartTime,
                                            currentLockedAmount: cakeAsBigNumber,
                                            stakingToken: stakingToken,
                                            currentBalance: stakingTokenBalance,
                                            stakingTokenBalance: stakingTokenBalance
                                        })
                                    })
                                ]
                            }),
                            vaultPosition >= VaultPosition.Locked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flex: "1",
                                ml: "20px",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        bold: true,
                                        color: "textSubtle",
                                        as: "span",
                                        textTransform: "uppercase",
                                        children: t("Unlocks In")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        lineHeight: "1",
                                        mt: "8px",
                                        bold: true,
                                        fontSize: "20px",
                                        color: vaultPosition >= VaultPosition.LockedEnd ? "#D67E0A" : "text",
                                        children: vaultPosition >= VaultPosition.LockedEnd ? t("Unlocked") : remainingTime
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        height: "20px",
                                        fontSize: "12px",
                                        display: "inline",
                                        color: vaultPosition >= VaultPosition.LockedEnd ? "#D67E0A" : "text",
                                        children: t("On %date%", {
                                            date: lockEndDate
                                        })
                                    }),
                                    vaultPosition === VaultPosition.Locked && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: "16px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_ExtendDurationButton, {
                                            lockEndTime: vaultData.userData.lockEndTime,
                                            lockStartTime: vaultData.userData.lockStartTime,
                                            stakingToken: stakingToken,
                                            currentBalance: stakingTokenBalance,
                                            currentLockedAmount: cakeAsNumberBalance,
                                            children: t("Extend")
                                        })
                                    })
                                ]
                            }),
                            (vaultPosition === VaultPosition.Flexible || !vaultKey) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButtonWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        variant: "secondary",
                                        onClick: onUnstake,
                                        mr: "6px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                            color: "primary",
                                            width: "14px"
                                        })
                                    }),
                                    reachStakingLimit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        ref: targetRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            variant: "secondary",
                                            disabled: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                                color: "textDisabled",
                                                width: "24px",
                                                height: "24px"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        variant: "secondary",
                                        onClick: stakingTokenBalance.gt(0) ? onStake : onPresentTokenRequired,
                                        disabled: isFinished,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                            color: "primary",
                                            width: "14px"
                                        })
                                    })
                                ]
                            }),
                            !isMobile && vaultPosition >= VaultPosition.LockedEnd && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flex: "1",
                                ml: "20px",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        bold: true,
                                        color: "textSubtle",
                                        as: "span",
                                        textTransform: "uppercase",
                                        children: vaultPosition === VaultPosition.AfterBurning ? t("After Burning") : t("After Burning In")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        lineHeight: "1",
                                        mt: "8px",
                                        bold: true,
                                        fontSize: "20px",
                                        color: "failure",
                                        children: vaultPosition === VaultPosition.AfterBurning ? (0,isUndefinedOrNull/* default */.Z)(vaultData.userData.currentOverdueFee) ? "-" : t("%amount% Burned", {
                                            amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(vaultData.userData.currentOverdueFee, 18, 5)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_BurningCountDown, {
                                            lockEndTime: vaultData.userData.lockEndTime
                                        })
                                    })
                                ]
                            }),
                            tooltipVisible && tooltip
                        ]
                    })
                }),
                isMobile && vaultPosition >= VaultPosition.LockedEnd && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "24px",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            color: "failure",
                            as: "span",
                            children: vaultPosition === VaultPosition.AfterBurning ? t("After Burning") : t("After Burning In")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            bold: true,
                            color: "failure",
                            children: vaultPosition === VaultPosition.AfterBurning ? (0,isUndefinedOrNull/* default */.Z)(vaultData.userData.currentOverdueFee) ? "-" : t("%amount% Burned", {
                                amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(vaultData.userData.currentOverdueFee, 18, 5)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_BurningCountDown, {
                                lockEndTime: vaultData.userData.lockEndTime
                            })
                        })
                    ]
                }),
                [
                    VaultPosition.AfterBurning,
                    VaultPosition.LockedEnd
                ].includes(vaultPosition) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    mt: [
                        "0",
                        "0",
                        "24px",
                        "24px",
                        "24px"
                    ],
                    ml: [
                        "0",
                        "0",
                        "12px",
                        "12px",
                        "12px",
                        "32px"
                    ],
                    mr: [
                        "0",
                        "0",
                        "12px",
                        "12px",
                        "12px",
                        "0px"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_AfterLockedActions, {
                        isInline: true,
                        position: vaultPosition,
                        currentLockedAmount: cakeAsNumberBalance,
                        stakingToken: stakingToken,
                        lockEndTime: "0",
                        lockStartTime: "0"
                    })
                }),
                vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultPosition === VaultPosition.Flexible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    mt: [
                        "0",
                        "0",
                        "24px",
                        "24px",
                        "24px"
                    ],
                    ml: [
                        "0",
                        "0",
                        "12px",
                        "12px",
                        "32px"
                    ],
                    mr: [
                        "0",
                        "0",
                        "12px",
                        "12px",
                        "0"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_ConvertToLock, {
                        stakingToken: stakingToken,
                        currentStakedAmount: cakeAsNumberBalance,
                        isInline: true
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionTitles, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: "secondary",
                        as: "span",
                        textTransform: "uppercase",
                        children: [
                            t("Stake"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        bold: true,
                        color: "textSubtle",
                        as: "span",
                        textTransform: "uppercase",
                        children: stakingToken.symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                children: vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeButtonGroup, {
                    onFlexibleClick: stakingTokenBalance.gt(0) ? onStake : onPresentTokenRequired,
                    onLockedClick: vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? openPresentLockedStakeModal : null
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    width: "100%",
                    onClick: stakingTokenBalance.gt(0) ? onStake : onPresentTokenRequired,
                    variant: "secondary",
                    disabled: isFinished,
                    children: t("Stake")
                })
            })
        ]
    });
};
/* harmony default export */ var Stake = (Staked);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ActionPanel/AutoHarvest.tsx













var AutoHarvestAction = function(param) {
    var userDataLoaded = param.userDataLoaded, earningTokenPrice = param.earningTokenPrice, vaultKey = param.vaultKey;
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var vaultData = useVaultPoolByKey(vaultKey);
    var _userData = vaultData.userData, userShares = _userData.userShares, cakeAtLastUserAction = _userData.cakeAtLastUserAction, pricePerFullShare = vaultData.pricePerFullShare;
    var ref2 = (0,Pools_helpers/* getCakeVaultEarnings */.UN)(account, cakeAtLastUserAction, userShares, pricePerFullShare, earningTokenPrice, vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? vaultData.userData.currentPerformanceFee.plus(vaultData.userData.currentOverdueFee).plus(vaultData.userData.userBoostedShare) : null), hasAutoEarnings = ref2.hasAutoEarnings, autoCakeToDisplay = ref2.autoCakeToDisplay, autoUsdToDisplay = ref2.autoUsdToDisplay;
    var ref3, ref4;
    var ref5 = hooks_useUserDataInVaultPresenter({
        lockStartTime: vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? (ref3 = (ref = vaultData.userData) === null || ref === void 0 ? void 0 : ref.lockStartTime) !== null && ref3 !== void 0 ? ref3 : "0" : "0",
        lockEndTime: vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? (ref4 = (ref1 = vaultData.userData) === null || ref1 === void 0 ? void 0 : ref1.lockEndTime) !== null && ref4 !== void 0 ? ref4 : "0" : "0"
    }), secondDuration = ref5.secondDuration, weekDuration = ref5.weekDuration;
    var boostFactor = useVaultApy({
        duration: secondDuration
    }).boostFactor;
    var vaultPosition = getVaultPosition(vaultData.userData);
    var actionTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        fontSize: "12px",
        bold: true,
        color: "secondary",
        as: "span",
        textTransform: "uppercase",
        children: t("Recent BNOU profit")
    });
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: actionTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        children: "0"
                    })
                })
            ]
        });
    }
    if (!userDataLoaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: actionTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 180,
                        height: "32px",
                        marginTop: 14
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowActionContainer, {
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                        children: actionTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flex: "1",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: hasAutoEarnings ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                                lineHeight: "1",
                                                bold: true,
                                                fontSize: "20px",
                                                decimals: 5,
                                                value: autoCakeToDisplay
                                            }),
                                            Number.isFinite(earningTokenPrice) && earningTokenPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                                display: "inline",
                                                fontSize: "12px",
                                                color: "textSubtle",
                                                decimals: 2,
                                                prefix: "~",
                                                value: autoUsdToDisplay,
                                                unit: " USD"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                color: "textDisabled",
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "12px",
                                                color: "textDisabled",
                                                children: "0 USD"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flex: "1.3",
                                flexDirection: "column",
                                alignSelf: "flex-start",
                                alignItems: "flex-start",
                                children: [
                                    VaultPosition.Flexible,
                                    VaultPosition.None
                                ].includes(vaultPosition) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_UnstakingFeeCountdownRow, {
                                    vaultKey: vaultKey,
                                    isTableVariant: true
                                })
                            })
                        ]
                    })
                ]
            }),
            !isMobile && vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultData.userData.locked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                minWidth: "123px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            bold: true,
                            color: "secondary",
                            as: "span",
                            textTransform: "uppercase",
                            children: t("Yield boost")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flex: "1",
                            flexDirection: "column",
                            alignSelf: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.s, {
                                    color: "text",
                                    lineHeight: "1",
                                    bold: true,
                                    fontSize: "20px",
                                    value: boostFactor ? boostFactor === null || boostFactor === void 0 ? void 0 : boostFactor.toString() : "0",
                                    decimals: 2,
                                    unit: "x"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    children: t("Lock for %duration%", {
                                        duration: weekDuration
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AutoHarvest = (AutoHarvestAction);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ActionPanel/CakeVaultApr.tsx










var CakeVaultApr = function(param) {
    var pool = param.pool, userData = param.userData, vaultPosition = param.vaultPosition;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useVaultApy({
        duration: vaultPosition > VaultPosition.Flexible ? +userData.lockEndTime - +userData.lockStartTime : pools/* MAX_LOCK_DURATION */.VO
    }), flexibleApy = ref.flexibleApy, lockedApy = ref.lockedApy;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
        pool: pool
    })), 1), onPresentFlexibleApyModal = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
        pool: pool,
        initialView: 1
    })), 1), onPresentLockedApyModal = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                marginX: "8px",
                mb: "8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "16px",
                            color: "textSubtle",
                            textAlign: "left",
                            children: t("Flexible APY")
                        }),
                        flexibleApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    fontSize: "16px",
                                    value: parseFloat(flexibleApy),
                                    decimals: 2,
                                    unit: "%",
                                    fontWeight: "600"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        onPresentFlexibleApyModal();
                                    },
                                    variant: "text",
                                    width: "20px",
                                    height: "20px",
                                    padding: "0px",
                                    marginLeft: "4px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                        color: "textSubtle",
                                        width: "20px"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: "80px",
                            height: "16px"
                        })
                    ]
                })
            }),
            pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                marginX: "8px",
                mb: "8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "16px",
                            color: "textSubtle",
                            textAlign: "left",
                            children: t("Locked APY")
                        }),
                        lockedApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "16px",
                                    style: {
                                        whiteSpace: "nowrap"
                                    },
                                    fontWeight: "600",
                                    children: t("Up to")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    ml: "7px",
                                    fontSize: "16px",
                                    value: parseFloat(lockedApy),
                                    decimals: 2,
                                    unit: "%",
                                    fontWeight: "600"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        onPresentLockedApyModal();
                                    },
                                    variant: "text",
                                    width: "20px",
                                    height: "20px",
                                    padding: "0px",
                                    marginLeft: "4px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                        color: "textSubtle",
                                        width: "20px"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: "80px",
                            height: "16px"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ActionPanel_CakeVaultApr = (CakeVaultApr);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ActionPanel/ActionPanel.tsx


function ActionPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    max-height: 0px;\n  }\n  to {\n    max-height: 1000px;\n  }\n"
    ]);
    ActionPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    max-height: 1000px;\n  }\n  to {\n    max-height: 0px;\n  }\n"
    ]);
    ActionPanel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    ActionPanel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    ActionPanel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  padding: 12px;\n\n  ",
        " {\n    flex-direction: row;\n    padding: 16px 32px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  flex-wrap: wrap;\n\n  ",
        " {\n    flex-direction: row;\n  }\n\n  ",
        " {\n    flex-direction: ",
        ";\n    align-items: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: auto;\n\n  padding: 8px 8px;\n  ",
        " {\n    padding: 0;\n    flex-basis: 230px;\n    ",
        " {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



















var expandAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ActionPanel_templateObject());
var collapseAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ActionPanel_templateObject1());
var StyledActionPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac18734-0"
})(_templateObject4(), function(param) {
    var expanded = param.expanded;
    return expanded ? (0,styled_components_browser_esm/* css */.iv)(ActionPanel_templateObject2(), expandAnimation) : (0,styled_components_browser_esm/* css */.iv)(ActionPanel_templateObject3(), collapseAnimation);
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var ActionPanel_ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac18734-1"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var isAutoVault = param.isAutoVault;
    return isAutoVault ? "row" : null;
}, function(param) {
    var isAutoVault = param.isAutoVault, hasBalance = param.hasBalance;
    return isAutoVault ? hasBalance ? "flex-start" : "stretch" : "center";
});
var InfoSection = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-2ac18734-2"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, Text/* default */.Z);
var YieldBoostDurationRow = function(param) {
    var lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime;
    var ref = hooks_useUserDataInVaultPresenter({
        lockEndTime: lockEndTime,
        lockStartTime: lockStartTime
    }), weekDuration = ref.weekDuration, secondDuration = ref.secondDuration;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_YieldBoostRow, {
                secondDuration: secondDuration
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockDurationRow, {
                weekDuration: weekDuration
            })
        ]
    });
};
var ActionPanel = function(param) {
    var account = param.account, pool = param.pool, expanded = param.expanded;
    var userData = pool.userData, vaultKey = pool.vaultKey;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var vaultData = useVaultPoolByKey(vaultKey);
    var _userData = vaultData.userData, cakeAsBigNumber = _userData.balance.cakeAsBigNumber;
    var vaultPosition = getVaultPosition(vaultData.userData);
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new (bignumber_default())(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new (bignumber_default())(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    var poolStakingTokenBalance = vaultKey ? cakeAsBigNumber.plus(stakingTokenBalance) : stakedBalance.plus(stakingTokenBalance);
    var manualTooltipText = t("You must harvest and compound your earnings from this pool manually.");
    var autoTooltipText = t("Rewards are distributed and included into your staking balance automatically. There\u2019s no need to manually compound your rewards.");
    var ref = (0,useTooltip/* default */.Z)(vaultKey ? autoTooltipText : manualTooltipText, {
        placement: "bottom-start"
    }), tagTargetRef = ref.targetRef, tagTooltip = ref.tooltip, tagTooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionPanel, {
        expanded: expanded,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSection, {
                children: [
                    isMobile && vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultData.userData.locked && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YieldBoostDurationRow, {
                            lockEndTime: vaultData.userData.lockEndTime,
                            lockStartTime: vaultData.userData.lockStartTime
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexDirection: "column",
                        mb: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PoolStatsInfo, {
                            pool: pool,
                            account: account,
                            showTotalStaked: isMobile,
                            alignLinksToRight: isMobile
                        })
                    }),
                    vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CompoundingPoolTag */.yd, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* ManualPoolTag */.EM, {}),
                    tagTooltipVisible && tagTooltip,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        ref: tagTargetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                            ml: "4px",
                            width: "20px",
                            height: "20px",
                            color: "textSubtle"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionPanel_ActionContainer, {
                children: [
                    isMobile && vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultPosition === VaultPosition.None && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionPanel_CakeVaultApr, {
                        pool: pool,
                        userData: vaultData.userData,
                        vaultPosition: vaultPosition
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        width: "100%",
                        children: [
                            pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultPositionTagWithLabel, {
                                userData: vaultData.userData,
                                width: [
                                    "auto",
                                    ,
                                    "fit-content"
                                ],
                                ml: [
                                    "12px",
                                    ,
                                    ,
                                    ,
                                    ,
                                    "32px"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionPanel_ActionContainer, {
                                isAutoVault: !!pool.vaultKey,
                                hasBalance: poolStakingTokenBalance.gt(0),
                                children: [
                                    pool.vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoHarvest, (0,_object_spread/* default */.Z)({}, pool)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Harvest, (0,_object_spread/* default */.Z)({}, pool)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stake, {
                                        pool: pool
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ActionPanel_ActionPanel = (ActionPanel);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/AutoEarningsCell.tsx

function AutoEarningsCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 4.5;\n  ",
        " {\n    flex: 1 0 120px;\n  }\n"
    ]);
    AutoEarningsCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AutoEarningsCell_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n"
    ]);
    AutoEarningsCell_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var AutoEarningsCell_StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-1728a02a-0"
})(AutoEarningsCell_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var HelpIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1728a02a-1"
})(AutoEarningsCell_templateObject1());
var AutoEarningsCell = function(param) {
    var pool = param.pool, account = param.account;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var earningTokenPrice = pool.earningTokenPrice, vaultKey = pool.vaultKey;
    var vaultData = useVaultPoolByKey(vaultKey);
    var _userData = vaultData.userData, userShares = _userData.userShares, cakeAtLastUserAction = _userData.cakeAtLastUserAction, isLoading = _userData.isLoading, pricePerFullShare = vaultData.pricePerFullShare;
    var ref = (0,Pools_helpers/* getCakeVaultEarnings */.UN)(account, cakeAtLastUserAction, userShares, pricePerFullShare, earningTokenPrice, vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? vaultData.userData.currentPerformanceFee.plus(vaultData.userData.currentOverdueFee).plus(vaultData.userData.userBoostedShare) : null), hasAutoEarnings = ref.hasAutoEarnings, autoCakeToDisplay = ref.autoCakeToDisplay, autoUsdToDisplay = ref.autoUsdToDisplay;
    var labelText = t("Recent BNOU profit");
    var earningTokenBalance = autoCakeToDisplay;
    var hasEarnings = hasAutoEarnings;
    var earningTokenDollarBalance = autoUsdToDisplay;
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_AutoEarningsBreakdown, {
        pool: pool,
        account: account
    }), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    if (vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && !userShares.gt(0)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoEarningsCell_StyledCell, {
        role: "cell",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: labelText
                }),
                isLoading && account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "16px"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        tooltipVisible && tooltip,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    mr: "8px",
                                    height: "32px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                            mt: "4px",
                                            bold: !isMobile,
                                            fontSize: isMobile ? "14px" : "16px",
                                            color: hasEarnings ? "primary" : "textDisabled",
                                            decimals: hasEarnings ? 5 : 1,
                                            value: hasEarnings ? earningTokenBalance : 0
                                        }),
                                        hasEarnings ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: earningTokenPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                                display: "inline",
                                                fontSize: "12px",
                                                color: "textSubtle",
                                                decimals: 2,
                                                prefix: "~",
                                                value: earningTokenDollarBalance,
                                                unit: " USD"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mt: "4px",
                                            fontSize: "12px",
                                            color: "textDisabled",
                                            children: "0 USD"
                                        })
                                    ]
                                }),
                                hasEarnings && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpIconWrapper, {
                                    ref: targetRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                        color: "textSubtle"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Cells_AutoEarningsCell = (AutoEarningsCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/AutoAprCell.tsx


function AutoAprCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    AutoAprCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var AutoAprCell_AprLabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aa96ede0-0"
})(AutoAprCell_templateObject());
var AutoAprCell = function(param) {
    var pool = param.pool;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    var userData = useVaultPoolByKey(pool.vaultKey).userData;
    var vaultPosition = getVaultPosition(userData);
    var ref = useVaultApy({
        duration: vaultPosition > VaultPosition.Flexible ? +userData.lockEndTime - +userData.lockStartTime : pools/* MAX_LOCK_DURATION */.VO
    }), flexibleApy = ref.flexibleApy, lockedApy = ref.lockedApy;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
        pool: pool
    })), 1), onPresentFlexibleApyModal = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal, {
        pool: pool,
        initialView: 1
    }), true, true, pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? "LockedVaultRoiCalculatorModal" : "FlexibleSideVaultRoiCalculatorModal"), 1), onPresentLockedApyModal = ref2[0];
    if (pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultPosition === VaultPosition.None) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_BaseCell, {
                    role: "cell",
                    flex: [
                        "1 0 50px",
                        "4.5",
                        "1 0 120px",
                        null,
                        "2 0 100px"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                textAlign: "left",
                                children: t("Flexible APY")
                            }),
                            flexibleApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoAprCell_AprLabelContainer, {
                                alignItems: "center",
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                        fontSize: [
                                            "14px",
                                            "14px",
                                            "16px"
                                        ],
                                        value: parseFloat(flexibleApy),
                                        decimals: 2,
                                        unit: "%",
                                        fontWeight: [
                                            600,
                                            400
                                        ]
                                    }),
                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            onPresentFlexibleApyModal();
                                        },
                                        variant: "text",
                                        width: "20px",
                                        height: "20px",
                                        padding: "0px",
                                        marginLeft: "4px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                            color: "textSubtle",
                                            width: "20px"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: "80px",
                                height: "16px"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_BaseCell, {
                    role: "cell",
                    flex: [
                        "1 0 50px",
                        "1 0 50px",
                        "2 0 100px",
                        null,
                        "1 0 120px"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                textAlign: "left",
                                children: t("Locked APY")
                            }),
                            lockedApy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoAprCell_AprLabelContainer, {
                                alignItems: "center",
                                justifyContent: "flex-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                                    gap: "4px",
                                    flexWrap: "wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: [
                                                "14px",
                                                "14px",
                                                "16px"
                                            ],
                                            style: {
                                                whiteSpace: "nowrap"
                                            },
                                            fontWeight: [
                                                500,
                                                400
                                            ],
                                            children: t("Up to")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                            fontSize: [
                                                "14px",
                                                "14px",
                                                "16px"
                                            ],
                                            value: parseFloat(lockedApy),
                                            decimals: 2,
                                            unit: "%",
                                            fontWeight: [
                                                600,
                                                400
                                            ]
                                        }),
                                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: function(e) {
                                                e.stopPropagation();
                                                onPresentLockedApyModal();
                                            },
                                            variant: "text",
                                            width: "20px",
                                            height: "20px",
                                            padding: "0px",
                                            marginLeft: "4px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                                color: "textSubtle",
                                                width: "20px"
                                            })
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: "80px",
                                height: "16px"
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_BaseCell, {
        role: "cell",
        flex: [
            "1 0 50px",
            "1 0 50px",
            "2 0 100px",
            "2 0 100px",
            "1 0 120px"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: t("APY")
                }),
                flexibleApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoAprCell_AprLabelContainer, {
                    alignItems: "center",
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                            fontSize: "16px",
                            value: vaultPosition > VaultPosition.Flexible ? parseFloat(lockedApy) : parseFloat(flexibleApy),
                            decimals: 2,
                            unit: "%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function(e) {
                                e.stopPropagation();
                                return vaultPosition > VaultPosition.Flexible ? onPresentLockedApyModal() : onPresentFlexibleApyModal();
                            },
                            variant: "text",
                            width: "20px",
                            height: "20px",
                            padding: "0px",
                            marginLeft: "4px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                color: "textSubtle",
                                width: "20px"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "16px"
                })
            ]
        })
    });
};
/* harmony default export */ var Cells_AutoAprCell = (AutoAprCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/StakedCell.tsx

function StakedCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    StakedCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var StakedCell_StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-2dbde65d-0"
})(StakedCell_templateObject());
var StakedCell = function(param) {
    var pool = param.pool, account = param.account;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpointsContext/* default */.Z)().isMobile;
    // vault
    var vaultData = useVaultPoolByKey(pool.vaultKey);
    var _userData = vaultData.userData, userShares = _userData.userShares, _balance = _userData.balance, cakeAsBigNumber = _balance.cakeAsBigNumber, cakeAsNumberBalance = _balance.cakeAsNumberBalance, isLoading = _userData.isLoading;
    var hasSharesStaked = userShares.gt(0);
    var isVaultWithShares = pool.vaultKey && hasSharesStaked;
    // pool
    var stakingTokenPrice = pool.stakingTokenPrice, stakingToken = pool.stakingToken, userData = pool.userData;
    var stakedAutoDollarValue = (0,formatBalance/* getBalanceNumber */.mW)(cakeAsBigNumber.multipliedBy(stakingTokenPrice), stakingToken.decimals);
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new (bignumber_default())(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    var stakedTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance, stakingToken.decimals);
    var stakedTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance.multipliedBy(stakingTokenPrice), stakingToken.decimals);
    var labelText = "".concat(pool.stakingToken.symbol, " ").concat(pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && vaultData.userData.locked ? t("Locked") : t("Staked"));
    var hasStaked = account && (stakedBalance.gt(0) || isVaultWithShares);
    var userDataLoading = pool.vaultKey ? isLoading : !pool.userDataLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedCell_StyledCell, {
        role: "cell",
        flex: pool.vaultKey === types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault ? "1 0 162px" : pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault && !hasStaked ? "1 0 120px" : "2 0 100px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "textSubtle",
                    textAlign: "left",
                    children: labelText
                }),
                userDataLoading && account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "16px"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mr: "8px",
                            height: "32px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    mt: "4px",
                                    bold: !isMobile,
                                    fontSize: isMobile ? "14px" : "16px",
                                    color: hasStaked ? "primary" : "textDisabled",
                                    decimals: hasStaked ? 5 : 1,
                                    value: hasStaked ? pool.vaultKey ? Number.isNaN(cakeAsNumberBalance) ? 0 : cakeAsNumberBalance : stakedTokenBalance : 0
                                }),
                                hasStaked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    display: "inline",
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    decimals: 2,
                                    prefix: "~",
                                    value: pool.vaultKey ? stakedAutoDollarValue : stakedTokenDollarBalance,
                                    unit: " USD"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "4px",
                                    fontSize: "12px",
                                    color: "textDisabled",
                                    children: "0 USD"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Cells_StakedCell = (StakedCell);

// EXTERNAL MODULE: ./src/hooks/useDelayedUnmount.ts
var useDelayedUnmount = __webpack_require__(30798);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/Cells/ExpandActionCell.tsx

function ExpandActionCell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1;\n  padding-right: 12px;\n  padding-left: 0px;\n  ",
        " {\n    flex: 0 0 120px;\n    padding-right: 32px;\n    padding-left: 8px;\n  }\n"
    ]);
    ExpandActionCell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExpandActionCell_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  height: 24px;\n"
    ]);
    ExpandActionCell_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ExpandActionCell_StyledCell = (0,styled_components_browser_esm/* default */.ZP)(Cells_BaseCell).withConfig({
    componentId: "sc-ed9fb7a7-0"
})(ExpandActionCell_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronDown/* default */.Z).withConfig({
    componentId: "sc-ed9fb7a7-1"
})(ExpandActionCell_templateObject1(), function(param) {
    var toggled = param.toggled;
    return toggled ? "rotate(180deg)" : "rotate(0)";
});
var ExpandActionCell = function(param) {
    var expanded = param.expanded, isFullLayout = param.isFullLayout;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandActionCell_StyledCell, {
        role: "cell",
        children: [
            isFullLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "primary",
                bold: true,
                children: expanded ? t("Hide") : t("Details")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                color: "primary",
                toggled: expanded
            })
        ]
    });
};
/* harmony default export */ var Cells_ExpandActionCell = (ExpandActionCell);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/ExpandRow.tsx

function ExpandRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  display: flex;\n  cursor: pointer;\n"
    ]);
    ExpandRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-485e2415-0"
})(ExpandRow_templateObject());
var ExpandRow = function(param) {
    var children = param.children, panel = param.panel, initialActivity = param.initialActivity;
    var hasSetInitialValue = (0,react.useRef)(false);
    var ref = (0,useMatchBreakpointsContext/* default */.Z)(), isTablet = ref.isTablet, isDesktop = ref.isDesktop;
    var ref1 = (0,react.useState)(initialActivity), expanded = ref1[0], setExpanded = ref1[1];
    var shouldRenderActionPanel = (0,useDelayedUnmount/* default */.Z)(expanded, 300);
    var toggleExpanded = (0,react.useCallback)(function() {
        setExpanded(function(prev) {
            return !prev;
        });
    }, []);
    (0,react.useEffect)(function() {
        if (initialActivity && hasSetInitialValue.current === false) {
            setExpanded(initialActivity);
            hasSetInitialValue.current = true;
        }
    }, [
        initialActivity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                role: "row",
                onClick: toggleExpanded,
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_ExpandActionCell, {
                        expanded: expanded,
                        isFullLayout: isTablet || isDesktop
                    })
                ]
            }),
            shouldRenderActionPanel && panel
        ]
    });
};
/* harmony default export */ var PoolsTable_ExpandRow = (/*#__PURE__*/(0,react.memo)(ExpandRow));

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/PoolRow.tsx














var VaultPoolRow = /*#__PURE__*/ (0,react.memo)(function(param) {
    var vaultKey = param.vaultKey, account = param.account, initialActivity = param.initialActivity;
    var ref = (0,useMatchBreakpointsContext/* default */.Z)(), isXs = ref.isXs, isSm = ref.isSm, isMd = ref.isMd, isLg = ref.isLg, isXl = ref.isXl, isXxl = ref.isXxl;
    var isLargerScreen = isLg || isXl || isXxl;
    var isXLargerScreen = isXl || isXxl;
    var pool = useDeserializedPoolByVaultKey(vaultKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolsTable_ExpandRow, {
        initialActivity: initialActivity,
        panel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionPanel_ActionPanel, {
            account: account,
            pool: pool,
            expanded: true,
            breakpoints: {
                isXs: isXs,
                isSm: isSm,
                isMd: isMd,
                isLg: isLg,
                isXl: isXl,
                isXxl: isXxl
            }
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_NameCell, {
                pool: pool
            }),
            isXLargerScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_AutoEarningsCell, {
                pool: pool,
                account: account
            }),
            isXLargerScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_StakedCell, {
                pool: pool,
                account: account
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_AutoAprCell, {
                pool: pool
            }),
            isLargerScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_TotalStakedCell, {
                pool: pool
            })
        ]
    });
});
var PoolRow = function(param) {
    var sousId = param.sousId, account = param.account, initialActivity = param.initialActivity;
    var ref = (0,useMatchBreakpointsContext/* default */.Z)(), isXs = ref.isXs, isSm = ref.isSm, isMd = ref.isMd, isLg = ref.isLg, isXl = ref.isXl, isXxl = ref.isXxl, isDesktop = ref.isDesktop;
    var isLargerScreen = isLg || isXl || isXxl;
    var pool = usePool(sousId).pool;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolsTable_ExpandRow, {
        initialActivity: initialActivity,
        panel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionPanel_ActionPanel, {
            account: account,
            pool: pool,
            expanded: true,
            breakpoints: {
                isXs: isXs,
                isSm: isSm,
                isMd: isMd,
                isLg: isLg,
                isXl: isXl,
                isXxl: isXxl
            }
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_NameCell, {
                pool: pool
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_EarningsCell, {
                pool: pool,
                account: account
            }),
            isLargerScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_TotalStakedCell, {
                pool: pool
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_AprCell, {
                pool: pool
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cells_EndsInCell, {
                pool: pool
            })
        ]
    });
};
/* harmony default export */ var PoolsTable_PoolRow = (/*#__PURE__*/(0,react.memo)(PoolRow));

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolsTable/PoolsTable.tsx

function PoolsTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  scroll-margin-top: 64px;\n\n  background-color: ",
        ";\n  > div:not(:last-child) {\n    border-bottom: 2px solid ",
        ";\n  }\n"
    ]);
    PoolsTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PoolsTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  padding: 1px 1px 3px 1px;\n  background-size: 400% 400%;\n"
    ]);
    PoolsTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PoolsTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding-top: 5px;\n  padding-bottom: 5px;\n"
    ]);
    PoolsTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var StyledTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9fbfe778-0"
})(PoolsTable_templateObject(), function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});
var StyledTableBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9fbfe778-1"
})(PoolsTable_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ScrollButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9fbfe778-2"
})(PoolsTable_templateObject2());
var PoolsTable = function(param) {
    var pools = param.pools, account = param.account, urlSearch = param.urlSearch;
    var t = (0,src/* useTranslation */.$G)().t;
    var tableWrapperEl = (0,react.useRef)(null);
    var scrollToTop = function() {
        window.scrollTo({
            top: tableWrapperEl.current.offsetTop,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableBorder, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
            id: "pools-table",
            role: "table",
            ref: tableWrapperEl,
            children: [
                pools.map(function(pool) {
                    var ref, ref1;
                    return pool.vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultPoolRow, {
                        initialActivity: urlSearch.toLowerCase() === ((ref = pool.earningToken.symbol) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                        vaultKey: pool.vaultKey,
                        account: account
                    }, pool.vaultKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolsTable_PoolRow, {
                        initialActivity: urlSearch.toLowerCase() === ((ref1 = pool.earningToken.symbol) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                        sousId: pool.sousId,
                        account: account
                    }, pool.sousId);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        variant: "text",
                        onClick: scrollToTop,
                        children: [
                            t("To Top"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {
                                color: "primary"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var PoolsTable_PoolsTable = (PoolsTable);

// EXTERNAL MODULE: ./src/components/Timer/Timer.tsx + 2 modules
var Timer_Timer = __webpack_require__(38451);
;// CONCATENATED MODULE: ./src/views/Pools/index.tsx


function Pools_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n"
    ]);
    Pools_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Pools_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  position: relative;\n\n  justify-content: space-between;\n  flex-direction: column;\n  margin-bottom: 32px;\n\n  ",
        " {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 16px 32px;\n    margin-bottom: 0;\n  }\n"
    ]);
    Pools_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Pools_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0px;\n\n  ",
        " {\n    width: auto;\n    padding: 0;\n  }\n"
    ]);
    Pools_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Pools_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > ",
        " {\n    font-size: 12px;\n  }\n"
    ]);
    Pools_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Pools_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div {\n    flex: 1;\n  }\n"
    ]);
    Pools_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Pools_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 32px;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    Pools_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Pools_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  white-space: nowrap;\n  text-decoration: underline;\n"
    ]);
    Pools_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

































var CardLayout = (0,styled_components_browser_esm/* default */.ZP)(Layout_Flex/* default */.Z).withConfig({
    componentId: "sc-aecfd16e-0"
})(Pools_templateObject());
var PoolControls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aecfd16e-1"
})(Pools_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FilterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aecfd16e-2"
})(Pools_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aecfd16e-3"
})(Pools_templateObject3(), Text/* default */.Z);
var ControlStretch = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aecfd16e-4"
})(Pools_templateObject4());
var FinishedTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aecfd16e-5"
})(Pools_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FinishedTextLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-aecfd16e-6"
})(Pools_templateObject6());
var NUMBER_OF_POOLS_VISIBLE = 12;
var sortPools = function(account, sortOption, pools, poolsToSort) {
    switch(sortOption){
        case "apr":
            // Ternary is needed to prevent pools without APR (like MIX) getting top spot
            return orderBy_default()(poolsToSort, function(pool) {
                return pool.apr ? pool.apr : 0;
            }, "desc");
        case "earned":
            return orderBy_default()(poolsToSort, function(pool) {
                if (!pool.userData || !pool.earningTokenPrice) {
                    return 0;
                }
                if (pool.vaultKey) {
                    var userData = pool.userData, pricePerFullShare = pool.pricePerFullShare;
                    if (!userData || !userData.userShares) {
                        return 0;
                    }
                    return (0,Pools_helpers/* getCakeVaultEarnings */.UN)(account, userData.cakeAtLastUserAction, userData.userShares, pricePerFullShare, pool.earningTokenPrice, pool.vaultKey === types/* VaultKey.CakeVault */.om.CakeVault ? pool.userData.currentPerformanceFee.plus(pool.userData.currentOverdueFee) : null).autoUsdToDisplay;
                }
                return pool.userData.pendingReward.times(pool.earningTokenPrice).toNumber();
            }, "desc");
        case "totalStaked":
            {
                return orderBy_default()(poolsToSort, function(pool) {
                    var ref;
                    var totalStaked = Number.NaN;
                    if (pool.vaultKey) {
                        var vault = pool;
                        if (pool.stakingTokenPrice && vault.totalCakeInVault.isFinite()) {
                            totalStaked = +(0,lib_esm/* formatUnits */.bM)(bignumber/* BigNumber.from */.O$.from(vault.totalCakeInVault.toString()), pool.stakingToken.decimals) * pool.stakingTokenPrice;
                        }
                    } else if (((ref = pool.totalStaked) === null || ref === void 0 ? void 0 : ref.isFinite()) && pool.stakingTokenPrice) {
                        totalStaked = +(0,lib_esm/* formatUnits */.bM)(bignumber/* BigNumber.from */.O$.from(pool.totalStaked.toString()), pool.stakingToken.decimals) * pool.stakingTokenPrice;
                    }
                    return Number.isFinite(totalStaked) ? totalStaked : 0;
                }, "desc");
            }
        case "latest":
            return orderBy_default()(poolsToSort, function(pool) {
                return Number(pool.sousId);
            }, "desc");
        default:
            return poolsToSort;
    }
};
var POOL_START_BLOCK_THRESHOLD = 60 / config/* BSC_BLOCK_TIME */.hJ * 4;
var Pools = function() {
    var router = (0,next_router.useRouter)();
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = usePoolsWithVault(), pools = ref.pools, userDataLoaded = ref.userDataLoaded;
    var poolStartBlock = (0,farms_hooks/* useFarmsStartBlock */.KF)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserPoolStakedOnly */.tw)(), 2), stakedOnly = ref1[0], setStakedOnly = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserPoolsViewMode */.Yi)(), 2), viewMode = ref2[0], setViewMode = ref2[1];
    var ref3 = (0,react.useState)(NUMBER_OF_POOLS_VISIBLE), numberOfPoolsVisible = ref3[0], setNumberOfPoolsVisible = ref3[1];
    var ref4 = (0,useIntersectionObserver/* default */.Z)(), observerRef = ref4.observerRef, isIntersecting = ref4.isIntersecting;
    var normalizedUrlSearch = (0,react.useMemo)(function() {
        var ref;
        return typeof (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.search) === "string" ? router.query.search : "";
    }, [
        router.query
    ]);
    var ref5 = (0,react.useState)(""), _searchQuery = ref5[0], setSearchQuery = ref5[1];
    var searchQuery = normalizedUrlSearch && !_searchQuery ? normalizedUrlSearch : _searchQuery;
    var ref6 = (0,react.useState)("hot"), sortOption = ref6[0], setSortOption = ref6[1];
    var chosenPoolsLength = (0,react.useRef)(0);
    var initialBlock = (0,block_hooks/* useInitialBlock */.Xh)();
    var ref7 = (0,react.useMemo)(function() {
        return partition_default()(pools, function(pool) {
            return pool.isFinished;
        });
    }, [
        pools
    ]), finishedPools = ref7[0], openPools = ref7[1];
    var openPoolsWithStartBlockFilter = (0,react.useMemo)(function() {
        return openPools.filter(function(pool) {
            return initialBlock > 0 && pool.startBlock ? Number(pool.startBlock) < initialBlock + POOL_START_BLOCK_THRESHOLD : true;
        });
    }, [
        initialBlock,
        openPools
    ]);
    var stakedOnlyFinishedPools = (0,react.useMemo)(function() {
        return finishedPools.filter(function(pool) {
            if (pool.vaultKey) {
                var vault = pool;
                return vault.userData.userShares.gt(0);
            }
            return pool.userData && new (bignumber_default())(pool.userData.stakedBalance).isGreaterThan(0);
        });
    }, [
        finishedPools
    ]);
    var stakedOnlyOpenPools = (0,react.useCallback)(function() {
        return openPoolsWithStartBlockFilter.filter(function(pool) {
            if (pool.vaultKey) {
                var vault = pool;
                return vault.userData.userShares.gt(0);
            }
            return pool.userData && new (bignumber_default())(pool.userData.stakedBalance).isGreaterThan(0);
        });
    }, [
        openPoolsWithStartBlockFilter
    ]);
    var hasStakeInFinishedPools = stakedOnlyFinishedPools.length > 0;
    usePoolsPageFetch();
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setNumberOfPoolsVisible(function(poolsCurrentlyVisible) {
                if (poolsCurrentlyVisible <= chosenPoolsLength.current) {
                    return poolsCurrentlyVisible + NUMBER_OF_POOLS_VISIBLE;
                }
                return poolsCurrentlyVisible;
            });
        }
    }, [
        isIntersecting
    ]);
    var showFinishedPools = router.pathname.includes("history");
    var handleChangeSearchQuery = (0,react.useCallback)(function(event) {
        return setSearchQuery(event.target.value);
    }, []);
    var handleSortOptionChange = (0,react.useCallback)(function(option) {
        return setSortOption(option.value);
    }, []);
    var chosenPools;
    if (showFinishedPools) {
        chosenPools = stakedOnly ? stakedOnlyFinishedPools : finishedPools;
    } else {
        chosenPools = stakedOnly ? stakedOnlyOpenPools() : openPoolsWithStartBlockFilter;
    }
    chosenPools = (0,react.useMemo)(function() {
        var sortedPools = sortPools(account, sortOption, pools, chosenPools).slice(0, numberOfPoolsVisible);
        if (searchQuery) {
            var lowercaseQuery = (0,latinise/* latinise */.b)(searchQuery.toLowerCase());
            return sortedPools.filter(function(pool) {
                return (0,latinise/* latinise */.b)(pool.earningToken.symbol.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return sortedPools;
    }, [
        account,
        sortOption,
        pools,
        chosenPools,
        numberOfPoolsVisible,
        searchQuery
    ]);
    chosenPoolsLength.current = chosenPools.length;
    var cardLayout = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLayout, {
        children: chosenPools.map(function(pool) {
            return pool.vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CakeVaultCard, {
                pool: pool,
                showStakedOnly: stakedOnly
            }, pool.vaultKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PoolCard, {
                pool: pool,
                account: account
            }, pool.sousId);
        })
    });
    var tableLayout = /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolsTable_PoolsTable, {
        urlSearch: normalizedUrlSearch,
        pools: chosenPools,
        account: account
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        mr: [
                            "8px",
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h1",
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Pools")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "md",
                                color: "text",
                                children: t("Just stake some tokens to earn.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "md",
                                color: "text",
                                children: t("High APR, low risk.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer_Timer/* default */.Z, {
                                startBlock: poolStartBlock
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolControls, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PoolTabButtons, {
                                stakedOnly: stakedOnly,
                                setStakedOnly: setStakedOnly,
                                hasStakeInFinishedPools: hasStakeInFinishedPools,
                                viewMode: viewMode,
                                setViewMode: setViewMode
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "12px",
                                                bold: true,
                                                color: "textSubtle",
                                                textTransform: "uppercase",
                                                children: t("Sort by")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlStretch, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                    options: [
                                                        {
                                                            label: t("Hot"),
                                                            value: "hot"
                                                        },
                                                        {
                                                            label: t("APR"),
                                                            value: "apr"
                                                        },
                                                        {
                                                            label: t("Earned"),
                                                            value: "earned"
                                                        },
                                                        {
                                                            label: t("Total staked"),
                                                            value: "totalStaked"
                                                        },
                                                        {
                                                            label: t("Latest"),
                                                            value: "latest"
                                                        }, 
                                                    ],
                                                    onOptionChange: handleSortOptionChange
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        style: {
                                            marginLeft: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "12px",
                                                bold: true,
                                                color: "textSubtle",
                                                textTransform: "uppercase",
                                                children: t("Search")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                                                initialValue: searchQuery,
                                                onChange: handleChangeSearchQuery,
                                                placeholder: "Search Pools"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                     false && /*#__PURE__*/ 0,
                    account && !userDataLoaded && stakedOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mb: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    }),
                    viewMode === actions/* ViewMode.CARD */.wO.CARD ? cardLayout : tableLayout,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: observerRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        mx: "auto",
                        mt: "12px",
                        src: "/logo.png",
                        alt: "Pancake illustration",
                        width: 192,
                        height: 192
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Pools = (Pools);


/***/ })

}]);